const _excluded = ["as", "children", "className", "href", "css"],
  _excluded2 = ["as", "children", "className", "css"],
  _excluded3 = ["as", "children", "className", "css"],
  _excluded4 = ["as", "children", "className", "css", "size", "src"],
  _excluded5 = ["alt", "as", "children", "className", "css", "fallback", "size", "src"],
  _excluded6 = ["as", "className", "css"],
  _excluded7 = ["as", "children", "className", "css"],
  _excluded8 = ["as", "children", "className", "css"],
  _excluded9 = ["as", "children", "className", "css", "href"],
  _excluded10 = ["as", "autoFocus", "children", "className", "css", "isDisabled", "endIcon", "href", "onClick", "onPress", "onPressStart", "onPressEnd", "onPressChange", "onPressUp", "rel", "size", "startIcon", "variant", "target", "type"],
  _excluded11 = ["as", "children", "className", "css", "isDisabled", "isAttached", "size", "variant"],
  _excluded12 = ["className", "css", "size"],
  _excluded13 = ["as", "className", "css", "icon"],
  _excluded14 = ["as", "className", "css", "variant"],
  _excluded15 = ["className", "css", "orientation"],
  _excluded16 = ["as", "className", "css"],
  _excluded17 = ["as", "align", "className", "css", "gap", "justify", "orientation", "wrap"],
  _excluded18 = ["as", "className", "css", "size"],
  _excluded19 = ["as", "className", "css", "state", "loading", "noResultsChildren", "loadingText"],
  _excluded20 = ["as", "className", "css", "showCalendar", "showRanges", "ranges"],
  _excluded21 = ["as", "children", "className", "css"],
  _excluded22 = ["as", "children", "className", "css"],
  _excluded23 = ["as", "children", "className", "css"],
  _excluded24 = ["as", "children", "className", "css"],
  _excluded25 = ["children", "className", "in", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "style", "timeout"],
  _excluded26 = ["children", "in", "duration", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "style", "timeout"],
  _excluded27 = ["children", "className", "css", "helperText", "helperTextProps", "isRequired", "label", "labelProps", "orientation", "validationState"],
  _excluded28 = ["as", "children", "className", "css"],
  _excluded29 = ["children", "locale", "disableCSSBaseline", "style"],
  _excluded30 = ["as", "children", "className", "css", "isDismissable", "isKeyboardDismissDisabled", "isOpen", "onClose", "shouldCloseOnBlur", "shouldCloseOnInteractOutside"],
  _excluded31 = ["as", "className", "css", "fixed", "maxWidth"],
  _excluded32 = ["children", "className", "css"],
  _excluded33 = ["as", "autoFocus", "children", "className", "css", "isActive", "isDisabled"],
  _excluded34 = ["as", "boundaries", "children", "className", "css", "defaultPage", "getPaginationLabel", "getItemAriaLabel", "onChange", "nextLabel", "page", "previousLabel", "rowsPerPage", "siblings", "showLabel", "showPageNumbers", "totalRowCount"],
  _excluded35 = ["data", "defaultColumn", "columns", "enableExpandAll", "enableExpanding", "enableMultiRowSelection", "enablePagination", "enablePinning", "enableRowSelection", "enableSelectAll", "enableSorting", "enableStickyHeader", "expandAllButtonProps", "expandButtonProps", "initialState", "isLoading", "manualExpanding", "manualPagination", "manualSorting", "pageCount", "paginationProps", "selectAllCheckboxProps", "selectCheckboxProps", "rowCount", "state", "onExpandedChange", "onPaginationChange", "onRowSelectionChange", "onSortingChange"],
  _excluded36 = ["as", "children", "className", "css", "isDismissable", "isKeyboardDismissDisabled", "isOpen", "onClose"],
  _excluded37 = ["isOpen"],
  _excluded38 = ["as", "children", "className", "css", "isDismissable", "onClose", "role"],
  _excluded39 = ["isDismissable", "isKeyboardDismissDisabled", "isOpen", "onClose"],
  _excluded40 = ["as", "children", "className", "css"],
  _excluded41 = ["as", "children", "className", "css", "buttonGroupProps"],
  _excluded42 = ["as", "buttonProps", "children", "className", "css", "typographyProps"],
  _excluded43 = ["defaultOpen", "children", "closeOnSelect", "isOpen", "offset", "placement", "shouldFlip", "onOpenChange", "trigger", "type"],
  _excluded44 = ["as", "className", "css"],
  _excluded45 = ["children", "in", "duration", "onEnter", "onExit", "style", "timeout"],
  _excluded46 = ["as", "className", "columnGap", "columns", "css", "flow", "gap", "rowGap", "rows"],
  _excluded47 = ["area", "as", "className", "css", "column", "columnEnd", "columnStart", "order", "row", "rowEnd", "rowStart"],
  _excluded48 = ["as", "autoFocus", "className", "css", "isSelected"],
  _excluded49 = ["as", "className", "css"],
  _excluded50 = ["as", "children", "className", "css"],
  _excluded51 = ["as", "children", "className", "css", "endIcon", "startIcon", "label", "labelProps", "isSelected"],
  _excluded52 = ["as", "children", "className", "css", "defaultExpanded", "iconProps", "isExpanded", "itemProps", "label", "labelProps", "onExpandedChange", "startIcon"],
  _excluded53 = ["as", "className", "css", "gap", "orientation"],
  _excluded54 = ["as", "children", "className", "css", "isCopyable", "isDisabled", "isRemovable", "label", "onRemove", "removeButtonProps", "startAdornment"],
  _excluded55 = ["className", "helperTextProps", "customLocale", "inputProps", "inputRef", "labelProps", "onChange", "size"],
  _excluded56 = ["as", "className", "colorScheme", "css", "icon", "isCollapsible", "label"],
  _excluded57 = ["as", "className", "children", "css", "orientation"],
  _excluded58 = ["as", "isFocusable"],
  _excluded59 = ["as", "autoFocus", "className", "css", "label", "endAdornment", "startAdornment", "value"],
  _excluded60 = ["as", "children", "className", "css", "defaultOpen", "isOpen", "onOpenChange"],
  _excluded61 = ["as", "children", "className", "css"],
  _excluded62 = ["as", "avatarProps", "children", "className", "css", "subTitle", "title"],
  _excluded63 = ["as", "children", "className", "css", "logo"],
  _excluded64 = ["className"],
  _excluded65 = ["className", "isExpanded"],
  _excluded66 = ["className"],
  _excluded67 = ["as", "children", "className", "css", "isDense", "showHover", "onMouseEnter", "onMouseLeave"],
  _excluded68 = ["as", "children", "className", "css"],
  _excluded69 = ["as", "align", "children", "className", "css", "onMouseEnter"],
  _excluded70 = ["as", "align", "children", "className", "css", "isActive", "isSortable", "sortDirection"],
  _excluded71 = ["as", "children", "className", "css"],
  _excluded72 = ["as", "children", "className", "css"],
  _excluded73 = ["as", "children", "className", "css", "onMouseEnter", "onMouseLeave"],
  _excluded74 = ["className", "helperTextProps", "inputProps", "inputRef", "labelProps", "onChange"],
  _excluded75 = ["className", "helperTextProps", "inputProps", "inputRef", "labelProps", "onChange", "size"],
  _excluded76 = ["action", "as", "children", "className", "css", "dismissButtonProps", "id", "isDismissable", "isVisible", "onDismiss", "description", "message", "variant"],
  _excluded77 = ["as", "className", "css", "duration"],
  _excluded78 = ["id", "visible"],
  _excluded79 = ["className", "children"],
  _excluded80 = ["defaultOpen", "children", "delay", "isOpen", "isDisabled", "placement", "onOpenChange", "title", "trigger"];
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
// Bundled with Packemon: https://packemon.dev
// Platform: browser, Support: stable, Format: esm

import { Item, Section } from '@react-stately/collections';
import { styled, card, pxToRem, cx, css, keyframes, globalCss, theme, focus, table, tableBody, tableCell, tableColumn, tableFooter, tableHeader, tableRow } from '@project44-manifest/react-styles';
export * from '@project44-manifest/react-styles';
import { ModalProvider, useModalProvider, Overlay as Overlay$1, useOverlay, useModal, DismissButton, useOverlayTrigger, useOverlayPosition, usePreventScroll, useOverlayFocusContain } from '@react-aria/overlays';
export { useOverlayPosition, useOverlayTrigger } from '@react-aria/overlays';
export { useAsyncList, useTreeData } from '@react-stately/data';
import { useOverlayTriggerState } from '@react-stately/overlays';
export { useOverlayTriggerState } from '@react-stately/overlays';
import { useCalendarCell, useCalendarGrid, useCalendar, useRangeCalendar } from '@react-aria/calendar';
import { useLocale, useDateFormatter, useCollator, I18nProvider, useFilter } from '@react-aria/i18n';
import { useCalendarState, useRangeCalendarState } from '@react-stately/calendar';
import { isSameMonth, getDayOfWeek, isSameDay, isToday, getWeeksInMonth, endOfMonth, createCalendar, endOfWeek, startOfWeek, startOfMonth, CalendarDate } from '@internationalized/date';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import * as React from 'react';
import React__default, { createContext as createContext$1, useContext } from 'react';
import { useButton } from '@react-aria/button';
export { useButton } from '@react-aria/button';
import { useFocusRing, FocusScope } from '@react-aria/focus';
export { FocusRing, FocusScope, useFocusRing } from '@react-aria/focus';
import { useHover, usePress, setInteractionModality, useInteractionModality } from '@react-aria/interactions';
export { useFocus, useHover } from '@react-aria/interactions';
import clsx from 'clsx';
import isObject from 'lodash.isobject';
import { useSeparator } from '@react-aria/separator';
import { mergeProps as mergeProps$1, mergeRefs as mergeRefs$1, filterDOMProps, useId, chain, useLayoutEffect } from '@react-aria/utils';
import { ListCollection, useListState } from '@react-stately/list';
import { useOption, useListBoxSection, useListBox } from '@react-aria/listbox';
import { useCheckbox } from '@react-aria/checkbox';
import { useToggleState } from '@react-stately/toggle';
import { ArrowRight, ChevronRight, Cube, ChevronDown, Sort, ArrowDown, ArrowUp, ChevronLeft, Calendar as Calendar$1, Close, Check, CopyAll, Expanded, Collapsed, InfoCircleFilled, ExclamationPointTriangleFilled, BackslashCircleFilled, CheckCircleFilled } from '@project44-manifest/react-icons';
import TransitionComponent from 'react-transition-group/Transition';
import { useComboBox } from '@react-aria/combobox';
import { useComboBoxState } from '@react-stately/combobox';
import { flexRender, useReactTable, getCoreRowModel, getExpandedRowModel, getPaginationRowModel, getSortedRowModel } from '@tanstack/react-table';
import ContentLoader from 'react-content-loader';
import { useControlledState as useControlledState$1 } from '@react-stately/utils';
import { useDatePicker, useDateRangePicker } from '@react-aria/datepicker';
import { useDatePickerState, useDateRangePickerState } from '@react-stately/datepicker';
import { useDialog } from '@react-aria/dialog';
import { useMenuTrigger, useMenuItem, useMenuSection, useMenu } from '@react-aria/menu';
import { useMenuTriggerState } from '@react-stately/menu';
import { useTreeState } from '@react-stately/tree';
import { useField } from '@react-aria/label';
import { ListKeyboardDelegate, useTypeSelect } from '@react-aria/selection';
import { useVisuallyHidden } from '@react-aria/visually-hidden';
import { useNumberField } from '@react-aria/numberfield';
import { useNumberFieldState } from '@react-stately/numberfield';
import { useTooltipTrigger, useTooltip } from '@react-aria/tooltip';
import { useTooltipTriggerState } from '@react-stately/tooltip';
import * as ReactDom from 'react-dom';
import { useRadioGroup, useRadio } from '@react-aria/radio';
import { useRadioGroupState } from '@react-stately/radio';
import { useSelect, HiddenSelect } from '@react-aria/select';
import { useSelectState } from '@react-stately/select';
import { useSwitch } from '@react-aria/switch';
import { useTextField } from '@react-aria/textfield';
import hotToast, { useToaster } from 'react-hot-toast/headless';
const StyledActionCard = styled('a', card, {
  display: 'inline-block',
  color: '$text-primary',
  textDecoration: 'none'
});
const StyledActionCardBody = styled('div', {
  px: '$large',
  paddingBottom: '$large',
  typography: '$body',
  width: '100%'
});
const StyledActionCardHeader = styled('div', {
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
  p: '$large',
  typography: '$title'
});
const StyledActionCardImage = styled('div', {
  display: 'block',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  objectFit: 'cover',
  variants: {
    size: {
      large: {
        height: pxToRem(180),
        minWidth: pxToRem(352)
      },
      small: {
        height: pxToRem(130),
        minWidth: pxToRem(320)
      }
    }
  },
  defaultVariants: {
    size: 'large'
  }
});
const ActionCard = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const as = props.as,
    children = props.children,
    classNameProp = props.className,
    href = props.href,
    css = props.css,
    other = _objectWithoutProperties(props, _excluded);
  const className = cx('manifest-action-card', classNameProp);
  return /*#__PURE__*/jsx(StyledActionCard, _objectSpread(_objectSpread({}, other), {}, {
    ref: forwardedRef,
    as: as,
    className: className,
    css: css,
    href: href,
    children: children
  }));
});

/* -------------------------------------------------------------------------------------------------
 * ActionCardBody
 * -----------------------------------------------------------------------------------------------*/

const ActionCardBody = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const as = props.as,
    children = props.children,
    classNameProp = props.className,
    css = props.css,
    other = _objectWithoutProperties(props, _excluded2);
  const className = cx('manifest-action-card-body', classNameProp);
  return /*#__PURE__*/jsx(StyledActionCardBody, _objectSpread(_objectSpread({}, other), {}, {
    ref: forwardedRef,
    as: as,
    className: className,
    css: css,
    children: children
  }));
});

/* -------------------------------------------------------------------------------------------------
 * ActionCardHeader
 * -----------------------------------------------------------------------------------------------*/

const ActionCardHeader = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const as = props.as,
    children = props.children,
    classNameProp = props.className,
    css = props.css,
    other = _objectWithoutProperties(props, _excluded3);
  const className = cx('manifest-action-card-header', classNameProp);
  return /*#__PURE__*/jsxs(StyledActionCardHeader, _objectSpread(_objectSpread({}, other), {}, {
    ref: forwardedRef,
    as: as,
    className: className,
    css: css,
    children: [children, /*#__PURE__*/jsx(ArrowRight, {
      "aria-hidden": true,
      className: "manifest-action-card-header__icon"
    })]
  }));
});

/* -------------------------------------------------------------------------------------------------
 * ActionCardImage
 * -----------------------------------------------------------------------------------------------*/

const ActionCardImage = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const as = props.as,
    children = props.children,
    classNameProp = props.className,
    css = props.css,
    _props$size = props.size,
    size = _props$size === void 0 ? 'large' : _props$size,
    src = props.src,
    other = _objectWithoutProperties(props, _excluded4);
  const className = cx('manifest-action-card-image', classNameProp, {
    [`manifest-action-card-image--${size}`]: size
  });
  return /*#__PURE__*/jsx(StyledActionCardImage, _objectSpread(_objectSpread({}, other), {}, {
    ref: forwardedRef,
    as: as,
    className: className,
    css: _objectSpread(_objectSpread({}, css), {}, {
      backgroundImage: `url(${src})`
    }),
    size: size
  }));
});
const StyledAvatarImage = styled('img', {
  borderRadius: 'inherit',
  boxSizing: 'border-box',
  height: '100%',
  objectFit: 'cover',
  verticalAlign: 'middle',
  width: '100%'
});
const StyledAvatarFallback = styled('span', {
  alignItems: 'center',
  color: 'inherit',
  display: 'flex',
  fontWeight: '$semibold',
  letterSpacing: '$medium',
  height: '100%',
  justifyContent: 'center',
  width: '100%'
});
const StyledAvatar = styled('div', {
  alignItems: 'center',
  backgroundColor: '$background-secondary',
  borderRadius: '$full',
  boxSizing: 'border-box',
  color: '$text-secondary',
  display: 'flex',
  justifyContent: 'center',
  outline: 'none',
  overflow: 'hidden',
  verticalAlign: 'middle',
  variants: {
    size: {
      medium: {
        minHeight: pxToRem(40),
        minWidth: pxToRem(40),
        size: pxToRem(40),
        [`& ${StyledAvatarFallback}`]: {
          fontSize: '$small',
          lineHeight: '$medium'
        }
      },
      small: {
        minHeight: pxToRem(28),
        minWidth: pxToRem(28),
        size: pxToRem(28),
        [`& ${StyledAvatarFallback}`]: {
          fontSize: '$x-small',
          lineHeight: pxToRem(14)
        }
      }
    }
  },
  defaultVariants: {
    size: 'medium'
  }
});
const Avatar = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const alt = props.alt,
    as = props.as,
    children = props.children,
    classNameProp = props.className,
    css = props.css,
    fallback = props.fallback,
    _props$size2 = props.size,
    size = _props$size2 === void 0 ? 'medium' : _props$size2,
    _props$src = props.src,
    src = _props$src === void 0 ? '' : _props$src,
    other = _objectWithoutProperties(props, _excluded5);
  const _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    mounted = _React$useState2[0],
    setMounted = _React$useState2[1];
  const _React$useState3 = React.useState('pending'),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    status = _React$useState4[0],
    setStatus = _React$useState4[1];
  const handleError = React.useCallback(() => void setStatus('error'), []);
  const handleLoad = React.useCallback(() => void setStatus('loaded'), []);
  const classes = cx('manifest-avatar', classNameProp, {
    [`manifest-avatar--${size}`]: size,
    [`manifest-avatar--${status}`]: status
  });

  // Reset status to pending if src changes.
  React.useEffect(() => {
    setStatus('pending');
  }, [src]);

  // Ensure that the image is only loaded on the client (ssr).
  React.useEffect(() => {
    setMounted(true);
  }, []);
  return /*#__PURE__*/jsxs(StyledAvatar, _objectSpread(_objectSpread({
    ref: forwardedRef,
    as: as,
    className: classes,
    css: css,
    size: size
  }, other), {}, {
    children: [src && mounted && status !== 'error' && /*#__PURE__*/jsx(StyledAvatarImage, {
      alt: alt,
      className: "manifest-avatar__image",
      src: src,
      onError: handleError,
      onLoad: handleLoad
    }), (!src || status === 'error') && /*#__PURE__*/jsx(StyledAvatarFallback, {
      className: "manifest-avatar__fallback",
      children: fallback
    })]
  }));
});
const StyledBox = styled('div', {
  boxSizing: 'border-box',
  margin: 0,
  minWidth: 0
});
const Box = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const as = props.as,
    classNameProp = props.className,
    css = props.css,
    other = _objectWithoutProperties(props, _excluded6);
  return /*#__PURE__*/jsx(StyledBox, _objectSpread(_objectSpread({}, other), {}, {
    ref: forwardedRef,
    as: as,
    className: cx('manifest-box', classNameProp),
    css: css
  }));
});
const StyledLink = styled('a', {
  alignItems: 'baseline',
  color: '$text-primary',
  display: 'inline-flex',
  fontSize: '$medium',
  fontWeight: '$semibold',
  letterSpacing: '$medium',
  lineHeight: '$medium',
  textDecoration: 'underline',
  width: 'fitContent'
});
const Link = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const as = props.as,
    children = props.children,
    classNameProp = props.className,
    css = props.css,
    other = _objectWithoutProperties(props, _excluded7);
  const className = cx('manifest-link', classNameProp);
  return /*#__PURE__*/jsx(StyledLink, _objectSpread(_objectSpread({}, other), {}, {
    ref: forwardedRef,
    as: as,
    className: className,
    css: css,
    children: children
  }));
});
Link.toString = () => '.manifest-link';
const StyledBreadcrumb = styled('nav', {
  overflowX: 'auto'
});
const StyledBreadcrumbList = styled('ol', {
  d: 'flex',
  listStyle: 'none',
  margin: 0,
  p: 0
});
const StyledBreadcrumbItem = styled('li', {
  d: 'flex',
  alignItems: 'center',
  color: '$text-secondary',
  [`& ${Link}`]: {
    typography: '$subtext',
    color: 'inherit',
    textDecoration: 'none'
  },
  '&:last-child .manifest-icon': {
    display: 'none'
  }
});
const Breadcrumb = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const as = props.as,
    children = props.children,
    classNameProp = props.className,
    css = props.css,
    other = _objectWithoutProperties(props, _excluded8);
  const className = cx('manifest-breadcrumb', classNameProp);
  return /*#__PURE__*/jsx(StyledBreadcrumb, _objectSpread(_objectSpread({}, other), {}, {
    ref: forwardedRef,
    as: as,
    className: className,
    css: css,
    children: /*#__PURE__*/jsx(StyledBreadcrumbList, {
      className: "manifest-breadcrumb__list",
      children: children
    })
  }));
});

/* -------------------------------------------------------------------------------------------------
 * BreadcrumbItem
 * -----------------------------------------------------------------------------------------------*/

const BreadcrumbItem = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const as = props.as,
    children = props.children,
    classNameProp = props.className,
    css = props.css,
    href = props.href,
    other = _objectWithoutProperties(props, _excluded9);
  const className = cx('manifest-breadcrumb-item', classNameProp);
  return /*#__PURE__*/jsxs(StyledBreadcrumbItem, _objectSpread(_objectSpread({}, other), {}, {
    ref: forwardedRef,
    as: as,
    className: className,
    css: css,
    children: [/*#__PURE__*/jsx(Link, {
      href: href,
      children: children
    }), /*#__PURE__*/jsx(ChevronRight, {
      "aria-hidden": true,
      className: "manifest-breadcrumb-item__icon",
      size: "small"
    })]
  }));
});

/**
 * Creates react context with a  provider and hook.
 */
function createContext(options = {}) {
  const name = options.name;
  const Context = /*#__PURE__*/React.createContext(undefined);
  Context.displayName = name;
  const useContext = () => React.useContext(Context);
  return [Context.Provider, useContext, Context];
}

// Will be fixed when this is moved into its own package
// eslint-disable-next-line import/no-unresolved

/**
 * Pulled directly from react-aria for composing our own multi-select state for the combobox component.
 *
 * https://github.com/adobe/react-spectrum/blob/main/packages/%40react-stately/combobox/src/useComboBoxState.ts
 */
function filterNodes(nodes, inputValue, filter) {
  const filteredNode = [];
  for (const node of nodes) {
    if (node.type === 'section' && node.hasChildNodes) {
      const filtered = filterNodes(node.childNodes, inputValue, filter);
      if ([...filtered].length > 0) {
        filteredNode.push(_objectSpread(_objectSpread({}, node), {}, {
          childNodes: filtered
        }));
      }
    } else if (node.type !== 'section' && filter(node.textValue, inputValue)) {
      filteredNode.push(_objectSpread({}, node));
    }
  }
  return filteredNode;
}
function filterCollection(collection, inputValue, filter) {
  return new ListCollection(filterNodes(collection, inputValue, filter));
}

/**
 * Merge all callbacks into a single callback function.
 */
function mergeCallbacks(...fns) {
  return (...args) => {
    for (const fn of fns) {
      if (typeof fn === 'function') {
        fn?.(...args);
      }
    }
  };
}

/**
 * Merge multiple sets of props together
 *
 * Adapted from react-aria to support style objects
 * https://github.com/adobe/react-spectrum/blob/main/packages/%40react-aria/utils/src/mergeProps.ts
 */
function mergeProps(...args) {
  const result = _objectSpread({}, args[0]);
  for (let i = 1; i < args.length; i += 1) {
    const props = args[i];
    for (const prop in props) {
      if (Object.prototype.hasOwnProperty.call(props, prop)) {
        const mergedValue = result[prop];
        const propValue = props[prop];

        // Merge classNames
        if (prop === 'className' && typeof mergedValue === 'string' && typeof propValue === 'string') {
          result[prop] = clsx(mergedValue, propValue);

          // Merge styles
        } else if (prop === 'style' && isObject(mergedValue) && isObject(propValue)) {
          result[prop] = _objectSpread(_objectSpread({}, mergedValue), propValue);

          // Merge event handlers that start with `on`
        } else if (typeof mergedValue === 'function' && typeof propValue === 'function' && /^on[A-Z]/.test(prop)) {
          result[prop] = mergeCallbacks(mergedValue, propValue);
        } else {
          result[prop] = propValue ?? mergedValue;
        }
      }
    }
  }
  return result;
}
function mergeRefs(...refs) {
  return value => {
    for (const ref of refs) {
      if (typeof ref === 'function') {
        ref(value);
      } else if (typeof ref === 'object' && ref !== null && 'current' in ref) {
        ref.current = value;
      }
    }
  };
}
function noop() {}
const reflow = node => node.scrollTop;
const StyledButton$1 = styled('button', {
  alignItems: 'center',
  appearance: 'none',
  backgroundColor: 'transparent',
  border: 'none',
  borderRadius: '$small',
  boxShadow: '$small',
  boxSizing: 'border-box',
  color: '$text-primary',
  cursor: 'pointer',
  display: 'inline-flex',
  fontFamily: 'inherit',
  fontSize: '$small',
  fontWeight: '$semibold',
  justifyContent: 'center',
  letterSpacing: '$medium',
  lineHeight: '$small',
  outline: 'none',
  position: 'relative',
  px: pxToRem(12),
  userSelect: 'none',
  whiteSpace: 'nowrap',
  variants: {
    hasEndIcon: {
      true: {
        paddingRight: '$small'
      }
    },
    hasStartIcon: {
      true: {
        paddingLeft: '$small'
      }
    },
    isDisabled: {
      true: {
        cursor: 'not-allowed',
        pointerEvents: 'none',
        opacity: 0.57
      }
    },
    isFocusVisible: {
      true: {
        '&:after': {
          backgroundColor: 'transparent',
          border: '2px solid $colors$palette-indigo-200',
          // TODO: replace with design token once its defined.s
          borderRadius: '4px',
          bottom: '-4px',
          content: '',
          display: 'block',
          left: '-4px',
          position: 'absolute',
          right: '-4px',
          top: '-4px'
        }
      },
      false: {}
    },
    isHovered: {
      true: {}
    },
    isPressed: {
      true: {}
    },
    variant: {
      danger: {
        backgroundColor: '$palette-red-500',
        color: '$palette-white'
      },
      brand: {
        background: '$brand-gradient',
        color: '$palette-white'
      },
      primary: {
        backgroundColor: '$primary-default',
        color: '$palette-white'
      },
      secondary: {
        backgroundColor: '$palette-white'
      },
      tertiary: {
        backgroundColor: 'transparent',
        boxShadow: 'none'
      }
    },
    size: {
      medium: {
        height: pxToRem(40),
        py: '$small',
        '> .material-icons': {
          fontSize: '$x-large'
        }
      },
      small: {
        height: pxToRem(32),
        py: pxToRem(6),
        '> .material-icons': {
          fontSize: pxToRem(18)
        }
      }
    }
  },
  compoundVariants: [{
    isHovered: true,
    variant: 'primary',
    css: {
      backgroundColor: '$primary-hover'
    }
  }, {
    isHovered: true,
    variant: 'secondary',
    css: {
      backgroundColor: '$palette-grey-100'
    }
  }, {
    isHovered: true,
    variant: 'tertiary',
    css: {
      backgroundColor: '$palette-grey-100'
    }
  }, {
    isHovered: true,
    variant: 'brand',
    css: {
      background: '$brand-hover'
    }
  }, {
    isHovered: true,
    variant: 'danger',
    css: {
      background: 'linear-gradient(0deg, rgba(9, 21, 33, 0.15), rgba(9, 21, 33, 0.15)), $colors$palette-red-500'
    }
  }, {
    isPressed: true,
    variant: 'primary',
    css: {
      backgroundColor: '$primary-active',
      boxShadow: 'inset 0px 1px 1px rgba(5, 10, 26, 0.25)'
    }
  }, {
    isPressed: true,
    variant: 'secondary',
    css: {
      backgroundColor: '$palette-grey-300',
      boxShadow: 'inset 0px 1px 1px rgba(5, 10, 26, 0.25)'
    }
  }, {
    isPressed: true,
    variant: 'tertiary',
    css: {
      backgroundColor: '$palette-grey-300'
    }
  }, {
    isPressed: true,
    variant: 'brand',
    css: {
      background: '$brand-active'
    }
  }, {
    isPressed: true,
    variant: 'danger',
    css: {
      background: 'linear-gradient(0deg, rgba(9, 21, 33, 0.3), rgba(9, 21, 33, 0.3)), $colors$palette-red-500',
      boxShadow: 'inset 0px 1px 1px rgba(5, 10, 26, 0.25)'
    }
  }],
  defaultVariants: {
    size: 'medium',
    variant: 'primary'
  }
});
const StyledButtonIcon = styled('span', {
  alignSelf: 'center',
  display: 'inline-flex',
  flexShrink: 0,
  variants: {
    placement: {
      end: {
        marginLeft: '$small',
        marginRight: '-$x-small'
      },
      start: {
        marginLeft: '-$x-small',
        marginRight: '$small'
      }
    },
    size: {
      medium: {
        fontSize: '$x-large'
      },
      small: {
        fontSize: pxToRem(18)
      }
    }
  }
});
const StyledButtonGroup = styled('div', {
  boxSizing: 'border-box',
  display: 'inline-flex',
  variants: {
    isAttached: {
      true: {
        '> *:first-of-type:not(:last-of-type)': {
          borderBottomRightRadius: 0,
          borderTopRightRadius: 0
        },
        '> *:not(:first-of-type):not(:last-of-type)': {
          borderRadius: 0
        },
        '> *:not(:first-of-type):last-of-type': {
          borderBottomLeftRadius: 0,
          borderTopLeftRadius: 0
        }
      },
      false: {
        '& > *:not(style) ~ *:not(style)': {
          marginLeft: '$small'
        }
      }
    }
  },
  defaultVariants: {
    isAttached: false
  }
});
const _createContext = createContext({
    name: 'ButtonGroupContext'
  }),
  _createContext2 = _slicedToArray(_createContext, 2),
  ButtonGroupProvider = _createContext2[0],
  useButtonGroup = _createContext2[1];

/* -------------------------------------------------------------------------------------------------
 * Button
 * -----------------------------------------------------------------------------------------------*/

const Button = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const group = useButtonGroup();
  const as = props.as,
    autoFocus = props.autoFocus,
    children = props.children,
    classNameProp = props.className,
    css = props.css,
    _props$isDisabled = props.isDisabled,
    isDisabled = _props$isDisabled === void 0 ? group?.isDisabled : _props$isDisabled,
    endIcon = props.endIcon,
    href = props.href,
    onClick = props.onClick,
    onPress = props.onPress,
    onPressStart = props.onPressStart,
    onPressEnd = props.onPressEnd,
    onPressChange = props.onPressChange,
    onPressUp = props.onPressUp,
    rel = props.rel,
    _props$size3 = props.size,
    size = _props$size3 === void 0 ? group?.size ?? 'medium' : _props$size3,
    startIcon = props.startIcon,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? group?.variant ?? 'primary' : _props$variant,
    target = props.target,
    _props$type = props.type,
    type = _props$type === void 0 ? 'button' : _props$type,
    other = _objectWithoutProperties(props, _excluded10);
  const buttonRef = React.useRef(null);
  const _useButton = useButton(_objectSpread(_objectSpread({}, other), {}, {
      elementType: typeof as === 'string' ? as : 'button',
      href,
      isDisabled,
      onClick,
      onPress,
      onPressStart,
      onPressEnd,
      onPressChange,
      onPressUp,
      rel,
      target,
      type
    }), buttonRef),
    buttonProps = _useButton.buttonProps,
    isPressed = _useButton.isPressed;
  const _useFocusRing = useFocusRing({
      autoFocus
    }),
    isFocusVisible = _useFocusRing.isFocusVisible,
    focusProps = _useFocusRing.focusProps;
  const _useHover = useHover({
      isDisabled
    }),
    isHovered = _useHover.isHovered,
    hoverProps = _useHover.hoverProps;
  const classnames = cx('manifest-button', classNameProp, {
    'manifest-button--disabled': isDisabled,
    [`manifest-button--${size}`]: size,
    [`manifest-button--${variant}`]: variant
  });
  return /*#__PURE__*/jsxs(StyledButton$1, _objectSpread(_objectSpread({}, mergeProps(buttonProps, focusProps, hoverProps, other)), {}, {
    ref: mergeRefs(buttonRef, forwardedRef),
    as: as,
    className: classnames,
    css: css,
    isDisabled: isDisabled,
    isFocusVisible: isFocusVisible,
    isHovered: isHovered,
    isPressed: isPressed,
    size: size,
    variant: variant,
    children: [startIcon && /*#__PURE__*/jsx(StyledButtonIcon, {
      className: cx('manifest-button__icon', 'manifest-button__icon--start'),
      placement: "start",
      size: size,
      children: startIcon
    }), children, endIcon && /*#__PURE__*/jsx(StyledButtonIcon, {
      className: cx('manifest-button__icon', 'manifest-button__icon--end'),
      placement: "end",
      size: size,
      children: endIcon
    })]
  }));
});

/* -------------------------------------------------------------------------------------------------
 * ButtonGroup
 * -----------------------------------------------------------------------------------------------*/

const ButtonGroup = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const as = props.as,
    children = props.children,
    classNameProp = props.className,
    css = props.css,
    isDisabled = props.isDisabled,
    isAttached = props.isAttached,
    size = props.size,
    variant = props.variant,
    other = _objectWithoutProperties(props, _excluded11);
  const context = React.useMemo(() => ({
    isDisabled,
    size,
    variant
  }), [isDisabled, size, variant]);
  const className = cx('manifest-button-group', {
    'manifest-button-group--attached': isAttached
  }, classNameProp);
  return /*#__PURE__*/jsx(StyledButtonGroup, _objectSpread(_objectSpread({}, other), {}, {
    ref: forwardedRef,
    as: as,
    className: className,
    css: css,
    isAttached: isAttached,
    children: /*#__PURE__*/jsx(ButtonGroupProvider, {
      value: context,
      children: children
    })
  }));
});

/* -------------------------------------------------------------------------------------------------
 * IconButton
 * -----------------------------------------------------------------------------------------------*/

const IconButton = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const classNameProp = props.className,
    css = props.css,
    _props$size4 = props.size,
    size = _props$size4 === void 0 ? 'medium' : _props$size4,
    other = _objectWithoutProperties(props, _excluded12);
  return /*#__PURE__*/jsx(Button, _objectSpread(_objectSpread({}, other), {}, {
    ref: forwardedRef,
    className: cx('manifest-icon-button', classNameProp),
    css: _objectSpread(_objectSpread({}, css), {}, {
      justifyContent: 'center',
      px: size === 'small' ? pxToRem(7) : '$small'
    }),
    size: size
  }));
});

/**
 * Creates a type-safe component with the `as` prop and `React.forwardRef`.
 *
 * Inspired by ariakit and chakra-ui.
 */
function createComponent(
// The function is being removed in favor of our Polymorphic types.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
component) {
  return /*#__PURE__*/React.forwardRef(component);
}
const useStyles$t = css({
  alignSelf: 'center',
  userSelect: 'none'
});
const Icon = createComponent((props, forwardedRef) => {
  const _props$as = props.as,
    Comp = _props$as === void 0 ? 'span' : _props$as,
    classNameProp = props.className,
    css = props.css,
    icon = props.icon,
    other = _objectWithoutProperties(props, _excluded13);
  const _useStyles$t = useStyles$t({
      css
    }),
    className = _useStyles$t.className;
  return /*#__PURE__*/jsx(Comp, _objectSpread(_objectSpread({}, other), {}, {
    ref: forwardedRef,
    className: cx(className, classNameProp, 'manifest-icon', 'material-icons'),
    children: icon
  }));
});
const useStyles$s = css({
  margin: '0',
  variants: {
    paragraph: {
      true: {
        marginBottom: '$medium'
      }
    },
    variant: {
      display: {
        typography: '$display'
      },
      heading: {
        typography: '$heading'
      },
      title: {
        typography: '$title'
      },
      subtitle: {
        typography: '$subtitle'
      },
      body: {
        typography: '$body'
      },
      bodyBold: {
        typography: '$body-bold'
      },
      subtext: {
        typography: '$subtext'
      },
      subtextBold: {
        typography: '$subtext-bold'
      },
      caption: {
        typography: '$caption'
      },
      captionBold: {
        typography: '$caption-bold'
      }
    }
  },
  defaultVariants: {
    variant: 'body'
  }
});
const Typography = createComponent((props, forwardedRef) => {
  const _props$as2 = props.as,
    Comp = _props$as2 === void 0 ? 'span' : _props$as2,
    classNameProp = props.className,
    css = props.css,
    _props$variant2 = props.variant,
    variant = _props$variant2 === void 0 ? 'body' : _props$variant2,
    other = _objectWithoutProperties(props, _excluded14);
  const _useStyles$s = useStyles$s({
      css,
      variant
    }),
    className = _useStyles$s.className;
  const classes = cx(className, classNameProp, {
    'manifest-typography': true,
    [`manifest-typography--${variant}`]: variant
  });
  return /*#__PURE__*/jsx(Comp, _objectSpread(_objectSpread({}, other), {}, {
    ref: forwardedRef,
    className: classes
  }));
});
const useStyles$r = css({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
  margin: 0,
  padding: '$small $medium',
  flexDirection: 'row',
  '.manifest-calendar-header__text': {
    color: '$text-secondary',
    fontWeight: '$bold'
  }
});

/* @private */
function CalendarHeader(props) {
  const nextButtonProps = props.nextButtonProps,
    prevButtonProps = props.prevButtonProps,
    state = props.state;
  const _useLocale = useLocale(),
    direction = _useLocale.direction;
  const currentMonth = state.visibleRange.start;
  const dateFormatter = useDateFormatter({
    month: 'long',
    year: 'numeric',
    era: currentMonth.calendar.identifier === 'gregory' && currentMonth.era === 'BC' ? 'short' : undefined,
    calendar: currentMonth.calendar.identifier,
    timeZone: state.timeZone
  });
  const _useStyles$r = useStyles$r(),
    className = _useStyles$r.className;
  return /*#__PURE__*/jsxs("div", {
    className: cx(className, 'manifest-calendar-header'),
    children: [/*#__PURE__*/jsx(IconButton, _objectSpread(_objectSpread({}, prevButtonProps), {}, {
      className: "manifest-calendar-header__previous-button",
      size: "small",
      variant: "tertiary",
      children: /*#__PURE__*/jsx(Icon, {
        icon: direction === 'rtl' ? 'chevron_right' : 'chevron_left'
      })
    })), /*#__PURE__*/jsx(Typography, {
      className: "manifest-calendar-header__text",
      variant: "subtext",
      children: dateFormatter.format(state.visibleRange.start.toDate(state.timeZone))
    }), /*#__PURE__*/jsx(IconButton, _objectSpread(_objectSpread({}, nextButtonProps), {}, {
      className: "manifest-calendar-header__next-button",
      size: "small",
      variant: "tertiary",
      children: /*#__PURE__*/jsx(Icon, {
        icon: direction === 'rtl' ? 'chevron_left' : 'chevron_right'
      })
    }))]
  });
}
const calendarCellUnderlineLight = {
  '.manifest-calendar-cell__text': {
    '&::after': {
      content: '""',
      backgroundColor: 'white',
      borderRadius: '$full',
      height: 1,
      position: 'absolute',
      top: pxToRem(23),
      width: 12
    }
  }
};
const useStyles$q = css({
  height: pxToRem(32),
  textAlign: 'center',
  padding: '$x-small 0',
  position: 'relative',
  width: pxToRem(44),
  '&:last-of-type': {
    '.manifest-calendar-cell__button': {
      borderTopRightRadius: pxToRem(4),
      borderBottomRightRadius: pxToRem(4)
    }
  },
  '&:first-of-type': {
    '.manifest-calendar-cell__button': {
      borderTopLeftRadius: pxToRem(4),
      borderBottomLeftRadius: pxToRem(4)
    }
  },
  '.manifest-calendar-cell__button': {
    background: 'transparent',
    boxSizing: 'border-box',
    cursor: 'pointer',
    display: 'block',
    height: pxToRem(28),
    margin: 0,
    outline: 'none',
    padding: 0,
    position: 'relative',
    width: '100%'
  },
  '.manifest-calendar-cell__text': {
    alignItems: 'center',
    backgroundColor: 'transparent',
    borderRadius: pxToRem(4),
    color: '$text-primary',
    display: 'flex',
    justifyContent: 'center',
    left: pxToRem(10),
    outline: 'none',
    position: 'absolute',
    top: 0,
    typography: '$caption',
    size: pxToRem(28),
    whiteSpace: 'nowrap'
  },
  variants: {
    isDisabled: {
      true: {
        '.manifest-calendar-cell__button': {
          cursor: 'default',
          pointerEvents: 'none'
        },
        '.manifest-calendar-cell__text': {
          color: '$text-disabled'
        }
      }
    },
    isFocusVisible: {
      true: {
        '.manifest-calendar-cell__text': {
          boxShadow: '0 0 0 2px $colors$palette-indigo-200'
        }
      },
      false: {
        '.manifest-calendar-cell__text': {
          boxShadow: 'none'
        }
      }
    },
    isRangeEnd: {
      true: {}
    },
    isRangeSelection: {
      true: {}
    },
    isRangeStart: {
      true: {}
    },
    isSelected: {
      true: {}
    },
    isSelectionEnd: {
      true: {}
    },
    isSelectionStart: {
      true: {}
    },
    isToday: {
      true: {
        '.manifest-calendar-cell__text': {
          '&::after': {
            content: '""',
            backgroundColor: '$text-primary',
            borderRadius: '$full',
            height: 1,
            position: 'absolute',
            top: pxToRem(23),
            width: 12
          }
        }
      }
    },
    isUnavailable: {
      true: {
        '.manifest-calendar-cell__text': {
          color: '$text-disabled'
        }
      }
    }
  },
  compoundVariants: [{
    isSelected: true,
    isRangeSelection: false,
    css: {
      '.manifest-calendar-cell__button': {
        '&::after': {
          display: 'none'
        }
      },
      '.manifest-calendar-cell__text': {
        backgroundColor: '$primary-default',
        borderColor: '$palette-indigo-100',
        color: '$palette-white'
      }
    }
  }, {
    isSelected: true,
    isRangeSelection: true,
    isSelectionStart: true,
    css: {
      '.manifest-calendar-cell__button': {
        background: 'linear-gradient(to left, $colors$palette-indigo-100 50%, transparent 50%)',
        '&::after': {
          display: 'none'
        }
      },
      '.manifest-calendar-cell__text': {
        backgroundColor: '$primary-default',
        borderColor: '$palette-indigo-100',
        color: '$text-contrast'
      }
    }
  }, {
    isSelected: true,
    isRangeSelection: true,
    isSelectionEnd: true,
    css: {
      '.manifest-calendar-cell__button': {
        background: 'linear-gradient(to right, $colors$palette-indigo-100 50%, transparent 50%)',
        '&::after': {
          display: 'none'
        }
      },
      '.manifest-calendar-cell__text': {
        backgroundColor: '$primary-default',
        borderColor: '$palette-indigo-100',
        color: '$palette-white'
      }
    }
  }, {
    isSelected: true,
    isRangeSelection: true,
    isSelectionEnd: true,
    isSelectionStart: true,
    css: {
      '.manifest-calendar-cell__button': {
        background: 'transparent',
        '&::after': {
          display: 'none'
        }
      },
      '.manifest-calendar-cell__text': {
        backgroundColor: '$primary-default',
        borderColor: '$palette-indigo-100',
        color: '$palette-white'
      }
    }
  }, {
    isSelected: true,
    isRangeSelection: true,
    isSelectionEnd: false,
    isSelectionStart: false,
    css: {
      '.manifest-calendar-cell__button': {
        background: '$palette-indigo-100'
      }
    }
  }, {
    isDisabled: true,
    isRangeSelection: true,
    css: {
      '.manifest-calendar-cell__text': {
        color: '$text-disabled'
      }
    }
  }, {
    isToday: true,
    isSelected: true,
    isRangeSelection: false,
    css: calendarCellUnderlineLight
  }, {
    isToday: true,
    isSelectionEnd: true,
    css: calendarCellUnderlineLight
  }, {
    isToday: true,
    isSelectionStart: true,
    css: calendarCellUnderlineLight
  }]
});

/** @private */
function CalendarCell(props) {
  const currentMonth = props.currentMonth,
    date = props.date,
    state = props.state;
  const ref = React.useRef(null);
  const _useCalendarCell = useCalendarCell(_objectSpread(_objectSpread({}, props), {}, {
      isDisabled: !isSameMonth(date, currentMonth)
    }), state, ref),
    cellProps = _useCalendarCell.cellProps,
    buttonProps = _useCalendarCell.buttonProps,
    isPressed = _useCalendarCell.isPressed,
    isSelected = _useCalendarCell.isSelected,
    isDisabled = _useCalendarCell.isDisabled,
    isInvalid = _useCalendarCell.isInvalid,
    formattedDate = _useCalendarCell.formattedDate;
  const _useLocale2 = useLocale(),
    locale = _useLocale2.locale;
  const dayOfWeek = getDayOfWeek(date, locale);
  const highlightedRange = 'highlightedRange' in state && state.highlightedRange;
  const isUnavailable = state.isCellUnavailable(date) && !isDisabled;
  const isOutsideMonth = !isSameMonth(currentMonth, date);
  const isLastSelectedBeforeDisabled = !isDisabled && !isInvalid && state.isCellUnavailable(date.add({
    days: 1
  }));
  const isFirstSelectedAfterDisabled = !isDisabled && !isInvalid && state.isCellUnavailable(date.subtract({
    days: 1
  }));
  const isSelectionStart = isSelected && highlightedRange && isSameDay(date, highlightedRange.start);
  const isSelectionEnd = isSelected && highlightedRange && isSameDay(date, highlightedRange.end);
  const isRangeStart = isSelected && (isFirstSelectedAfterDisabled || dayOfWeek === 0 || date.day === 1);
  const isRangeEnd = isSelected && (isLastSelectedBeforeDisabled || dayOfWeek === 6 || date.day === currentMonth.calendar.getDaysInMonth(currentMonth));
  const _useFocusRing2 = useFocusRing(),
    focusProps = _useFocusRing2.focusProps,
    isFocusVisible = _useFocusRing2.isFocusVisible;
  const _useHover2 = useHover({
      isDisabled
    }),
    hoverProps = _useHover2.hoverProps,
    isHovered = _useHover2.isHovered;
  const _useStyles$q = useStyles$q({
      isDisabled,
      isHovered,
      isFocusVisible,
      isOutsideMonth,
      isPressed,
      isRangeEnd,
      isRangeStart,
      isRangeSelection: isSelected && 'highlightedRange' in state,
      isSelected,
      isSelectionEnd,
      isSelectionStart,
      isToday: isToday(date, state.timeZone),
      isUnavailable
    }),
    className = _useStyles$q.className;
  return /*#__PURE__*/jsx("td", _objectSpread(_objectSpread({}, cellProps), {}, {
    className: cx(className, 'manifest-calendar-cell'),
    children: /*#__PURE__*/jsx("span", _objectSpread(_objectSpread({}, mergeProps$1(buttonProps, hoverProps, focusProps)), {}, {
      ref: ref,
      className: "manifest-calendar-cell__button",
      children: /*#__PURE__*/jsx("span", {
        className: "manifest-calendar-cell__text",
        children: /*#__PURE__*/jsx("span", {
          children: formattedDate
        })
      })
    }))
  }));
}
const useStyles$p = css({
  padding: '$small',
  '.manifest-calendar-table__table': {
    borderCollapse: 'collapse',
    maxWidth: `calc(${pxToRem(44)} * 7)`,
    margin: 0
  },
  '.manifest-calendar-table__head, .manifest-calendar-table__body': {
    border: 0
  },
  '.manifest-calendar-table__head': {
    color: '$colors$text-tertiary'
  },
  '.manifest-calendar-table__row': {
    height: '100%'
  },
  '.manifest-calendar-table__column': {
    height: pxToRem(32),
    padding: 0,
    textAlign: 'center',
    typography: '$caption',
    verticalAlign: 'middle'
  }
});

/** @private */
function CalendarTable(props) {
  const state = props.state;
  const _useLocale3 = useLocale(),
    locale = _useLocale3.locale;
  const weeksInMonth = getWeeksInMonth(state.visibleRange.start, locale);
  const startDate = state.visibleRange.start.add({});
  const endDate = endOfMonth(startDate);
  const weeks = [...Array.from({
    length: weeksInMonth
  }).keys()];
  const _useCalendarGrid = useCalendarGrid({
      endDate,
      startDate
    }, state),
    gridProps = _useCalendarGrid.gridProps,
    headerProps = _useCalendarGrid.headerProps,
    weekDays = _useCalendarGrid.weekDays;
  const _useStyles$p = useStyles$p(),
    className = _useStyles$p.className;
  return /*#__PURE__*/jsx("div", {
    className: cx(className, 'manifest-calendar-table'),
    children: /*#__PURE__*/jsxs("table", _objectSpread(_objectSpread({}, gridProps), {}, {
      className: "manifest-calendar-table__table",
      children: [/*#__PURE__*/jsx("thead", _objectSpread(_objectSpread({
        className: "manifest-calendar-table__head"
      }, headerProps), {}, {
        children: /*#__PURE__*/jsx("tr", {
          className: "manifest-calendar-table__row",
          children: weekDays.map((weekday, index) => /*#__PURE__*/jsx("th", {
            className: "manifest-calendar-table__column",
            scope: "col",
            children: /*#__PURE__*/jsx(Typography, {
              "aria-hidden": "true",
              variant: "caption",
              children: weekday
            })
          }, `column-${index.toString()}`))
        })
      })), /*#__PURE__*/jsx("tbody", {
        className: "manifest-calendar-table__body",
        children: weeks.map(weekIndex => /*#__PURE__*/jsx("tr", {
          className: "manifest-calendar-table__row",
          children: state.getDatesInWeek(weekIndex, startDate).map((date, index) => date ? /*#__PURE__*/jsx(CalendarCell, {
            currentMonth: startDate,
            date: date,
            state: state
          }, `cell-${index.toString()}`) : /*#__PURE__*/jsx("td", {}, `cell-${index.toString()}`))
        }, weekIndex))
      })]
    }))
  });
}
const useStyles$o = css({
  alignSelf: 'stretch',
  backgroundColor: '$border-primary',
  border: 'none',
  borderWidth: '1px',
  margin: 0,
  overflow: 'visible',
  variants: {
    orientation: {
      horizontal: {
        height: '1px',
        width: 'auto'
      },
      vertical: {
        height: 'auto',
        width: '1px'
      }
    }
  },
  defaultVariants: {
    orientation: 'horizontal'
  }
});
const Separator = createComponent((props, forwardedRef) => {
  const classNameProp = props.className,
    css = props.css,
    _props$orientation = props.orientation,
    orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
    other = _objectWithoutProperties(props, _excluded15);
  const Comp = orientation === 'vertical' ? 'div' : 'hr';
  const _useSeparator = useSeparator(_objectSpread(_objectSpread({}, props), {}, {
      elementType: Comp
    })),
    separatorProps = _useSeparator.separatorProps;
  const _useStyles$o = useStyles$o({
      css,
      orientation
    }),
    className = _useStyles$o.className;
  const classes = cx(className, classNameProp, {
    'manifest-separator': true,
    [`manifest-separator--${orientation}`]: orientation
  });
  return /*#__PURE__*/jsx(Comp, _objectSpread(_objectSpread({}, mergeProps$1(separatorProps, other)), {}, {
    ref: forwardedRef,
    className: classes
  }));
});
const useStyles$n = css({
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  '.manifest-calendar__separator-container': {
    paddingInline: '$small'
  }
});
const Calendar = createComponent((props, forwardedRef) => {
  const _props$as3 = props.as,
    Comp = _props$as3 === void 0 ? 'div' : _props$as3,
    classNameProp = props.className,
    css = props.css,
    other = _objectWithoutProperties(props, _excluded16);
  const _useLocale4 = useLocale(),
    locale = _useLocale4.locale;
  const state = useCalendarState(_objectSpread(_objectSpread({}, other), {}, {
    locale,
    visibleDuration: {
      months: 1
    },
    createCalendar
  }));
  const _useCalendar = useCalendar(other, state),
    calendarProps = _useCalendar.calendarProps,
    nextButtonProps = _useCalendar.nextButtonProps,
    prevButtonProps = _useCalendar.prevButtonProps;
  const _useStyles$n = useStyles$n({
      css
    }),
    className = _useStyles$n.className;
  return /*#__PURE__*/jsxs(Comp, _objectSpread(_objectSpread({}, calendarProps), {}, {
    ref: forwardedRef,
    className: cx(className, classNameProp, 'manifest-calendar'),
    children: [/*#__PURE__*/jsx(CalendarHeader, {
      nextButtonProps: nextButtonProps,
      prevButtonProps: prevButtonProps,
      state: state
    }), /*#__PURE__*/jsx("div", {
      className: "manifest-calendar__separator-container",
      children: /*#__PURE__*/jsx(Separator, {})
    }), /*#__PURE__*/jsx(CalendarTable, {
      state: state
    })]
  }));
});
const StyledFlex = styled('div', {
  boxSizing: 'border-box',
  display: 'flex',
  variants: {
    align: {
      baseline: {
        alignItems: 'baseline'
      },
      center: {
        alignItems: 'center'
      },
      end: {
        alignItems: 'flex-end'
      },
      start: {
        alignItems: 'flex-start'
      }
    },
    gap: {
      large: {
        gap: '$large'
      },
      medium: {
        gap: '$medium'
      },
      small: {
        gap: '$small'
      },
      'x-large': {
        gap: '$x-large'
      },
      'x-small': {
        gap: '$x-small'
      }
    },
    justify: {
      around: {
        justifyContent: 'space-around'
      },
      between: {
        justifyContent: 'space-between'
      },
      center: {
        justifyContent: 'center'
      },
      end: {
        justifyContent: 'flex-end'
      },
      start: {
        justifyContent: 'flex-start'
      }
    },
    orientation: {
      horizontal: {
        flexDirection: 'row'
      },
      vertical: {
        flexDirection: 'column'
      }
    },
    wrap: {
      false: {},
      true: {
        flexWrap: 'wrap'
      }
    }
  }
});
const Flex = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const as = props.as,
    align = props.align,
    classNameProp = props.className,
    css = props.css,
    gap = props.gap,
    justify = props.justify,
    orientation = props.orientation,
    wrap = props.wrap,
    other = _objectWithoutProperties(props, _excluded17);
  return /*#__PURE__*/jsx(StyledFlex, _objectSpread(_objectSpread({}, other), {}, {
    ref: forwardedRef,
    align: align,
    as: as,
    className: cx('manifest-flex', classNameProp),
    css: css,
    gap: gap,
    justify: justify,
    orientation: orientation,
    wrap: wrap
  }));
});
const ListBoxContext = /*#__PURE__*/createContext$1(null);
const useListBoxContext = () => useContext(ListBoxContext);
const useStyles$m = css({
  $$backgroundColor: '$colors$background-primary',
  $$borderColor: '$colors$palette-grey-500',
  alignItems: 'center',
  boxSizing: 'border-box',
  display: 'inline-flex',
  justifyContent: 'flex-start',
  position: 'relative',
  width: 'auto',
  '.manifest-checkbox__control': {
    backgroundColor: '$$backgroundColor',
    border: '2px solid $$borderColor',
    borderRadius: '$small',
    color: '$palette-white',
    cursor: 'pointer',
    position: 'relative',
    size: pxToRem(18)
  },
  '.manifest-checkbox__indicator': {
    alignItems: 'center',
    display: 'flex',
    height: '100%',
    justifyContent: 'center',
    pointerEvents: 'none',
    width: '100%',
    '> .manifest-checkbox__icon': {
      fontSize: pxToRem(18)
    }
  },
  '.manifest-checkbox__input': {
    cursor: 'pointer',
    height: '100%',
    left: 0,
    margin: 0,
    opacity: 0,
    padding: 0,
    position: 'absolute',
    top: 0,
    width: '100%'
  },
  '.manifest-checkbox__text': {
    marginLeft: '$small'
  },
  variants: {
    isChecked: {
      true: {
        $$backgroundColor: '$colors$primary-default',
        $$borderColor: '$colors$primary-default'
      }
    },
    isDisabled: {
      true: {
        cursor: 'not-allowed',
        opacity: 0.58,
        pointerEvents: 'none'
      }
    },
    isFocusVisible: {
      true: {
        '.manifest-checkbox__control': {
          '&:after': {
            backgroundColor: 'transparent',
            border: '2px solid $colors$palette-indigo-200',
            // TODO: replace with design token once its defined.
            borderRadius: '4px',
            bottom: '-6px',
            content: '',
            display: 'block',
            left: '-6px',
            position: 'absolute',
            right: '-6px',
            top: '-6px'
          }
        }
      },
      false: {}
    },
    isHovered: {
      true: {
        $$borderColor: '$colors$palette-grey-600'
      }
    },
    isIndeterminate: {
      true: {
        $$backgroundColor: '$colors$primary-default',
        $$borderColor: '$colors$primary-default'
      }
    }
  },
  compoundVariants: [{
    isChecked: true,
    isHovered: true,
    css: {
      $$borderColor: '$colors$primary-default'
    }
  }, {
    isIndeterminate: true,
    isHovered: true,
    css: {
      $$borderColor: '$colors$primary-default'
    }
  }]
});
const Checkbox = createComponent((props, forwardedRef) => {
  const _props$as4 = props.as,
    Comp = _props$as4 === void 0 ? 'label' : _props$as4,
    autoFocus = props.autoFocus,
    children = props.children,
    classNameProp = props.className,
    css = props.css,
    isDisabled = props.isDisabled,
    isIndeterminate = props.isIndeterminate;
  const inputRef = React.useRef(null);
  const state = useToggleState(props);
  const isChecked = state.isSelected;
  const _useCheckbox = useCheckbox(props, state, inputRef),
    inputProps = _useCheckbox.inputProps;
  const _useFocusRing3 = useFocusRing({
      autoFocus
    }),
    isFocusVisible = _useFocusRing3.isFocusVisible,
    focusProps = _useFocusRing3.focusProps;
  const _useHover3 = useHover({
      isDisabled
    }),
    isHovered = _useHover3.isHovered,
    hoverProps = _useHover3.hoverProps;
  const _usePress = usePress({
      isDisabled: inputProps.disabled
    }),
    pressProps = _usePress.pressProps;
  const _useStyles$m = useStyles$m({
      css,
      isChecked,
      isDisabled,
      isFocusVisible,
      isHovered,
      isIndeterminate
    }),
    className = _useStyles$m.className;
  const classes = cx(className, classNameProp, {
    'manifest-checkbox': true,
    'manifest-checkbox--checked': isChecked,
    'manifest-checkbox--disabled': isDisabled,
    'manifest-checkbox--indeterminate': isIndeterminate
  });
  return /*#__PURE__*/jsxs(Comp, _objectSpread(_objectSpread({}, mergeProps$1(hoverProps, pressProps)), {}, {
    ref: forwardedRef,
    className: classes,
    children: [/*#__PURE__*/jsx("input", _objectSpread(_objectSpread({}, mergeProps$1(inputProps, focusProps)), {}, {
      ref: inputRef,
      className: "manifest-checkbox__input"
    })), /*#__PURE__*/jsx("div", {
      className: "manifest-checkbox__control",
      children: /*#__PURE__*/jsx("span", {
        className: "manifest-checkbox__indicator",
        children: /*#__PURE__*/jsx(Icon, {
          className: "manifest-checkbox__icon",
          icon: isIndeterminate ? 'remove' : 'check'
        })
      })
    }), children && /*#__PURE__*/jsx(Typography, {
      className: "manifest-checkbox__text",
      variant: "subtext",
      children: children
    })]
  }));
});
const useStyles$l = css({
  $$backgroundColor: 'transparent',
  alignItems: 'center',
  backgroundColor: '$$backgroundColor',
  borderRadius: '$small',
  boxSizing: 'border-box',
  color: '$text-primary',
  cursor: 'pointer',
  display: 'flex',
  outline: 'none',
  px: '$small',
  py: pxToRem(6),
  position: 'relative',
  '.manifest-checkbox': {
    pointerEvents: 'none'
  },
  '.manifest-listbox-item__icon': {
    alignSelf: 'center',
    color: '$text-secondary',
    display: 'inline-flex',
    flexShrink: 0
  },
  '.manifest-listbox-item__icon--end': {
    color: '$primary-default',
    marginLeft: pxToRem(12)
  },
  '.manifest-listbox-item__icon--start': {
    marginRight: pxToRem(12)
  },
  '.manifest-listbox-item__text': {
    display: 'block',
    flex: '1 1 0%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  variants: {
    isDisabled: {
      true: {
        cursor: 'not-allowed',
        pointerEvents: 'none',
        opacity: 0.57
      }
    },
    isFocused: {
      true: {
        $$backgroundColor: '$colors$background-secondary'
      }
    },
    isHovered: {
      true: {
        $$backgroundColor: '$colors$background-secondary'
      }
    },
    isPressed: {
      true: {
        $$backgroundColor: '$colors$background-secondary'
      }
    },
    isSelected: {
      true: {}
    },
    selectionMode: {
      none: {},
      multiple: {},
      single: {}
    }
  },
  compoundVariants: [{
    selectionMode: 'single',
    isSelected: true,
    css: {
      $$backgroundColor: '$colors$background-secondary'
    }
  }]
});

/** @private */
const ListBoxItem$1 = createComponent((props, forwardedRef) => {
  const _props$as5 = props.as,
    Comp = _props$as5 === void 0 ? 'div' : _props$as5,
    classNameProp = props.className,
    css = props.css,
    isVirtualized = props.isVirtualized,
    item = props.item,
    selectionMode = props.selectionMode,
    startIconProp = props.startIcon;
  const rendered = item.rendered,
    key = item.key;
  const itemRef = React.useRef(null);
  const _useListBoxContext = useListBoxContext(),
    state = _useListBoxContext.state;
  const _useOption = useOption({
      'aria-label': item['aria-label'],
      key,
      isVirtualized
    }, state, itemRef),
    optionProps = _useOption.optionProps,
    labelProps = _useOption.labelProps,
    isFocused = _useOption.isFocused,
    isDisabled = _useOption.isDisabled,
    isPressed = _useOption.isPressed,
    isSelected = _useOption.isSelected;
  const _useHover4 = useHover({
      isDisabled
    }),
    hoverProps = _useHover4.hoverProps,
    isHovered = _useHover4.isHovered;
  const startIcon = React.useMemo(() => {
    if (selectionMode === 'multiple') {
      return /*#__PURE__*/jsx(Checkbox, {
        isReadOnly: true,
        "aria-labelledby": labelProps.id,
        isSelected: isSelected
      });
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return startIconProp ?? item.props.startIcon;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  }, [labelProps, isSelected, selectionMode, startIconProp, item.props.startIcon]);
  const _useStyles$l = useStyles$l({
      css,
      isDisabled,
      isFocused,
      isHovered,
      isPressed,
      isSelected,
      selectionMode
    }),
    className = _useStyles$l.className;
  const classes = cx(className, classNameProp, {
    'manifest-listbox-item': true,
    'manifest-listbox-item--disabled': isDisabled,
    'manifest-listbox-item--selected': isSelected
  });
  return /*#__PURE__*/jsxs(Comp, _objectSpread(_objectSpread({}, mergeProps$1(optionProps, hoverProps)), {}, {
    ref: mergeRefs$1(itemRef, forwardedRef),
    className: classes,
    children: [startIcon && /*#__PURE__*/jsx("span", {
      className: cx('manifest-listbox-item__icon', 'manifest-listbox-item__icon--start'),
      children: startIcon
    }), /*#__PURE__*/jsx(Typography, _objectSpread(_objectSpread({}, labelProps), {}, {
      className: "manifest-listbox-item__text",
      variant: "subtext",
      children: rendered
    }))]
  }));
});
const ListBoxItem = Item;
const useStyles$k = css({
  boxSizing: 'border-box',
  margin: 0,
  minWidth: 0,
  '.manifest-listbox-section__group': {
    margin: 0,
    padding: 0
  },
  '.manifest-listbox-section__label': {
    color: '$text-tertiary',
    px: '$x-small'
  }
});

/** @private */
const ListBoxSection$1 = createComponent((props, forwardedRef) => {
  const _props$as6 = props.as,
    Comp = _props$as6 === void 0 ? 'div' : _props$as6,
    classNameProp = props.className,
    css = props.css,
    item = props.item;
  const _useListBoxContext2 = useListBoxContext(),
    state = _useListBoxContext2.state;
  const _useListBoxSection = useListBoxSection({
      'aria-label': item['aria-label'],
      heading: item.rendered
    }),
    itemProps = _useListBoxSection.itemProps,
    headingProps = _useListBoxSection.headingProps,
    groupProps = _useListBoxSection.groupProps;
  const showSeparator = item.key !== state.collection.getFirstKey();
  const _useStyles$k = useStyles$k({
      css
    }),
    className = _useStyles$k.className;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [showSeparator && /*#__PURE__*/jsx(Separator, {
      className: "manifest-listbox-separator"
    }), /*#__PURE__*/jsxs(Comp, _objectSpread(_objectSpread({}, itemProps), {}, {
      ref: forwardedRef,
      className: cx(className, classNameProp, 'manifest-listbox-section'),
      children: [item.rendered && /*#__PURE__*/jsx(Typography, _objectSpread(_objectSpread({}, headingProps), {}, {
        className: "manifest-listbox-section__label",
        variant: "caption",
        children: item.rendered
      })), /*#__PURE__*/jsx("div", _objectSpread(_objectSpread({}, groupProps), {}, {
        className: "manifest-listbox-section__group",
        children: [...item.childNodes].map(node => /*#__PURE__*/jsx(ListBoxItem$1, {
          item: node
        }, node.key))
      }))]
    }))]
  });
});
const ListBoxSection = Section;
const rotate = keyframes({
  from: {
    transform: 'rotate(0deg)'
  },
  to: {
    transform: 'rotate(360deg)'
  }
});
const StyledSpinner = styled(Cube, {
  animation: `${rotate} 1.25s`,
  animationIterationCount: 'infinite',
  animationTimingFunction: 'linear',
  variants: {
    size: {
      large: {
        fontSize: pxToRem(75)
      },
      medium: {
        fontSize: '$x-large'
      },
      small: {
        fontSize: '$medium'
      }
    }
  },
  defaultVariants: {
    size: 'large'
  },
  '@media (prefers-reduced-motion)': {
    animation: `${rotate} 7s`
  }
});
const Spinner = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const as = props.as,
    classNameProp = props.className,
    css = props.css,
    _props$size5 = props.size,
    size = _props$size5 === void 0 ? 'large' : _props$size5,
    other = _objectWithoutProperties(props, _excluded18);
  const className = cx('manifest-spinner', classNameProp);
  return /*#__PURE__*/jsx(StyledSpinner, _objectSpread(_objectSpread({}, other), {}, {
    ref: forwardedRef,
    as: as,
    className: className,
    css: css,
    size: size
  }));
});
const useStyles$j = css({
  boxSizing: 'border-box',
  margin: 0,
  outline: 'none',
  padding: '$small',
  position: 'relative',
  '.manifest-listbox-separator': {
    alignSelf: 'stretch',
    backgroundColor: '$border-primary',
    border: 'none',
    borderWidth: '$small',
    height: '1px',
    mx: '-$small',
    my: '$small',
    overflow: 'visible',
    width: 'auto'
  },
  '.manifest-listbox__no-results-container': {
    py: '$small'
  },
  '.manifest-listbox__loading-container': {
    py: '$small',
    '.manifest-spinner': {
      height: pxToRem(24),
      width: pxToRem(24),
      color: '$text-secondary'
    },
    '.manifest-typography--caption': {
      alignSelf: 'center',
      color: '$text-secondary',
      pl: '$x-small'
    }
  }
});
const ListBoxBase = createComponent((props, forwardedRef) => {
  const _props$as7 = props.as,
    Comp = _props$as7 === void 0 ? 'div' : _props$as7,
    classNameProp = props.className,
    css = props.css,
    state = props.state,
    loading = props.loading,
    noResultsChildren = props.noResultsChildren,
    loadingText = props.loadingText,
    other = _objectWithoutProperties(props, _excluded19);
  const listboxRef = React.useRef(null);
  const _useListBox = useListBox(other, state, listboxRef),
    listBoxProps = _useListBox.listBoxProps;
  const selectionMode = state.selectionManager.selectionMode;
  const context = React.useMemo(() => ({
    state
  }), [state]);
  const _useStyles$j = useStyles$j({
      css
    }),
    className = _useStyles$j.className;
  return /*#__PURE__*/jsx(ListBoxContext.Provider, {
    value: context,
    children: /*#__PURE__*/jsxs(Comp, _objectSpread(_objectSpread({}, listBoxProps), {}, {
      ref: mergeRefs$1(listboxRef, forwardedRef),
      className: cx(className, classNameProp, 'manifest-listbox'),
      children: [!loading && [...state.collection].map(item => {
        if (item.type === 'section') {
          return /*#__PURE__*/jsx(ListBoxSection$1, {
            item: item
          }, item.key);
        }
        return /*#__PURE__*/jsx(ListBoxItem$1, {
          item: item,
          selectionMode: selectionMode
        }, item.key);
      }), !loading && noResultsChildren && state.collection.size === 0 && /*#__PURE__*/jsx(Box, {
        className: "manifest-listbox__no-results-container",
        children: noResultsChildren
      }), loading && /*#__PURE__*/jsxs(Flex, {
        className: "manifest-listbox__loading-container",
        justify: "center",
        children: [/*#__PURE__*/jsx(Spinner, {}), /*#__PURE__*/jsx(Typography, {
          variant: "caption",
          children: loadingText
        })]
      })]
    }))
  });
});
const ListBox = createComponent((props, forwardedRef) => {
  const state = useListState(props);
  return /*#__PURE__*/jsx(ListBoxBase, _objectSpread(_objectSpread({}, props), {}, {
    ref: forwardedRef,
    state: state
  }));
});
const useStyles$i = css({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-evenly',
  margin: 0,
  padding: '$small $medium',
  flexDirection: 'column'
});
const createCalendarDate = date => {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  return new CalendarDate(year, month, day);
};
const addDays = (calendarDate, days) => {
  const day = calendarDate.day,
    month = calendarDate.month,
    year = calendarDate.year;
  const date = new Date(year, month, day);
  date.setDate(date.getDate() + days);
  return calendarDate.set({
    day: date.getDate(),
    month: date.getMonth(),
    year: date.getFullYear()
  });
};
const addMonths = (calendarDate, months) => {
  const day = calendarDate.day,
    month = calendarDate.month,
    year = calendarDate.year;
  const date = new Date(year, month, day);
  date.setMonth(date.getMonth() + months);
  return calendarDate.set({
    day: date.getDate(),
    month: date.getMonth(),
    year: date.getFullYear()
  });
};
const defaultDate = new Date();
const calendarDate = createCalendarDate(defaultDate);
const defineds = {
  startOfToday: calendarDate,
  endOfToday: calendarDate,
  startOfYesterday: addDays(calendarDate, -1),
  endOfYesterday: addDays(calendarDate, -1),
  sevenDaysAgo: addDays(calendarDate, -7),
  thirtyDaysAgo: addDays(calendarDate, -30),
  endOfWeek: endOfWeek(calendarDate, 'en-US'),
  startOfLastWeek: startOfWeek(addDays(calendarDate, -7), 'en-US'),
  endOfLastWeek: endOfWeek(addDays(calendarDate, -7), 'en-US'),
  startOfMonth: startOfMonth(calendarDate),
  endOfMonth: endOfMonth(calendarDate),
  startOfLastMonth: startOfMonth(addMonths(calendarDate, -1)),
  endOfLastMonth: endOfMonth(addMonths(calendarDate, -1))
};
const getDefaultRanges = () => [{
  key: 'today',
  label: 'Today',
  value: {
    start: defineds.startOfToday,
    end: defineds.startOfToday
  }
}, {
  key: 'yesterday',
  label: 'Yesterday',
  value: {
    start: defineds.startOfYesterday,
    end: defineds.endOfYesterday
  }
}, {
  key: 'last7Days',
  label: 'Last 7 days',
  value: {
    start: defineds.sevenDaysAgo,
    end: defineds.endOfToday
  }
}, {
  key: 'last30Days',
  label: 'Last 30 days',
  value: {
    start: defineds.thirtyDaysAgo,
    end: defineds.endOfToday
  }
}, {
  key: 'thisMonth',
  label: 'This Month',
  value: {
    start: defineds.startOfMonth,
    end: defineds.endOfMonth
  }
}, {
  key: 'lastMonth',
  label: 'Last Month',
  value: {
    start: defineds.startOfLastMonth,
    end: defineds.endOfLastMonth
  }
}];

/* @private */
function CalendarRanges(props) {
  const _props$listBoxProps = props.listBoxProps,
    listBoxProps = _props$listBoxProps === void 0 ? {} : _props$listBoxProps,
    onRangeChange = props.onRangeChange,
    _props$ranges = props.ranges,
    ranges = _props$ranges === void 0 ? getDefaultRanges() : _props$ranges;
  const _useStyles$i = useStyles$i(),
    className = _useStyles$i.className;
  const ariaLabel = listBoxProps?.['aria-label'] || 'listbox';
  const handleSelectionChange = React.useCallback(key => {
    if (onRangeChange) {
      onRangeChange(key, ranges);
    }
  }, [onRangeChange, ranges]);
  return /*#__PURE__*/jsx("div", {
    className: cx(className, 'manifest-calendar-ranges'),
    children: /*#__PURE__*/jsx(ListBox, _objectSpread(_objectSpread({}, listBoxProps), {}, {
      "aria-label": ariaLabel,
      selectionMode: "single",
      onSelectionChange: handleSelectionChange,
      children: ranges.map(item => /*#__PURE__*/jsx(ListBoxItem, {
        "aria-label": item.label,
        children: item.label
      }, item.key))
    }))
  });
}
const useStyles$h = css({
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'row',
  minHeight: 289,
  '.manifest-range-calendar__separator-container': {
    paddingInline: '$small'
  },
  variants: {
    showCalendar: {
      false: {
        minHeight: 112
      }
    }
  }
});
const CalendarRange = createComponent((props, forwardedRef) => {
  const _props$as8 = props.as,
    Comp = _props$as8 === void 0 ? 'div' : _props$as8,
    classNameProp = props.className,
    css = props.css,
    showCalendar = props.showCalendar,
    showRanges = props.showRanges,
    ranges = props.ranges,
    other = _objectWithoutProperties(props, _excluded20);
  const calendarRef = React.useRef(null);
  const _useLocale5 = useLocale(),
    locale = _useLocale5.locale;
  const state = useRangeCalendarState(_objectSpread(_objectSpread({}, other), {}, {
    locale,
    visibleDuration: {
      months: 1
    },
    createCalendar
  }));
  const findRangeByKey = (key, definedRanges) => definedRanges.find(item => item.key === key.toString());
  const handleRangeChange = React.useCallback((key, definedRanges) => {
    const _key = _slicedToArray(key, 1),
      first = _key[0];
    const selectedRange = findRangeByKey(first, definedRanges);
    if (selectedRange) {
      const value = selectedRange.value;
      state.setValue({
        start: value.start,
        end: value.end
      });
    }
  }, [state]);
  const _useRangeCalendar = useRangeCalendar(other, state, calendarRef),
    calendarProps = _useRangeCalendar.calendarProps,
    nextButtonProps = _useRangeCalendar.nextButtonProps,
    prevButtonProps = _useRangeCalendar.prevButtonProps;
  const _useStyles$h = useStyles$h({
      css,
      showCalendar
    }),
    className = _useStyles$h.className;
  return /*#__PURE__*/jsxs(Comp, _objectSpread(_objectSpread({}, calendarProps), {}, {
    ref: mergeRefs$1(calendarRef, forwardedRef),
    className: cx(className, classNameProp, 'manifest-range-calendar'),
    children: [showRanges && /*#__PURE__*/jsx(CalendarRanges, {
      ranges: ranges,
      onRangeChange: handleRangeChange
    }), showCalendar && /*#__PURE__*/jsxs(Fragment, {
      children: [showRanges && showCalendar && /*#__PURE__*/jsx(Separator, {
        orientation: "vertical"
      }), /*#__PURE__*/jsxs("div", {
        className: cx('manifest-datepicker__calendar'),
        "data-testid": "calendar-date-picker",
        children: [/*#__PURE__*/jsx(CalendarHeader, {
          nextButtonProps: nextButtonProps,
          prevButtonProps: prevButtonProps,
          state: state
        }), /*#__PURE__*/jsx("div", {
          className: "manifest-range-calendar__separator-container",
          children: /*#__PURE__*/jsx(Separator, {})
        }), /*#__PURE__*/jsx(CalendarTable, {
          state: state
        })]
      })]
    })]
  }));
});
const StyledCard = styled('div', card);
const Card = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const as = props.as,
    children = props.children,
    classNameProp = props.className,
    css = props.css,
    other = _objectWithoutProperties(props, _excluded21);
  const className = cx('manifest-card', classNameProp);
  return /*#__PURE__*/jsx(StyledCard, _objectSpread(_objectSpread({}, other), {}, {
    ref: forwardedRef,
    as: as,
    className: className,
    css: css,
    children: children
  }));
});
const StyledCardBody = styled('div', {
  alignItems: 'inherit',
  display: 'flex',
  flex: '1 1 auto',
  flexDirection: 'column',
  height: 'auto',
  justifyContent: 'inherit',
  position: 'relative',
  padding: '$large',
  typography: '$body',
  width: '100%'
});
const CardBody = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const as = props.as,
    children = props.children,
    classNameProp = props.className,
    css = props.css,
    other = _objectWithoutProperties(props, _excluded22);
  const className = cx('manifest-card-body', classNameProp);
  return /*#__PURE__*/jsx(StyledCardBody, _objectSpread(_objectSpread({}, other), {}, {
    ref: forwardedRef,
    as: as,
    className: className,
    css: css,
    children: children
  }));
});
const StyledCardFooter = styled('div', {
  alignItems: 'center',
  display: 'flex',
  height: 'auto',
  justifyContent: 'flex-end',
  paddingBottom: '$large',
  px: '$large',
  width: '100%'
});
const CardFooter = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const as = props.as,
    children = props.children,
    classNameProp = props.className,
    css = props.css,
    other = _objectWithoutProperties(props, _excluded23);
  const className = cx('manifest-card-footer', classNameProp);
  return /*#__PURE__*/jsx(StyledCardFooter, _objectSpread(_objectSpread({}, other), {}, {
    ref: forwardedRef,
    as: as,
    className: className,
    css: css,
    children: children
  }));
});
const StyledCardHeader = styled('div', {
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'flex-start',
  width: '100%',
  paddingTop: '$large',
  px: '$large',
  typography: '$title'
});
const CardHeader = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const as = props.as,
    children = props.children,
    classNameProp = props.className,
    css = props.css,
    other = _objectWithoutProperties(props, _excluded24);
  const className = cx('manifest-card-header', classNameProp);
  return /*#__PURE__*/jsx(StyledCardHeader, _objectSpread(_objectSpread({}, other), {}, {
    ref: forwardedRef,
    as: as,
    className: className,
    css: css,
    children: children
  }));
});
function useChildrenTextContent(children) {
  const childrenTextContent = React__default.useMemo(() => children === undefined ? '' : React__default.Children.toArray(children).filter(child => typeof child === 'string').join(' '), [children]);
  return childrenTextContent;
}

/**
 * A react hook used to manage controlled and uncontrolled states.
 */
function useControlledState(value, defaultValue, onChange) {
  const _React$useState5 = React.useState(defaultValue),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    stateValue = _React$useState6[0],
    setStateValue = _React$useState6[1];
  const isControlled = value !== undefined;
  const currentValue = isControlled ? value : stateValue;
  const handleChange = React.useCallback(next => {
    const setter = next;
    const nextValue = typeof next === 'function' ? setter(value) : next;
    if (value === nextValue) return;
    if (!isControlled) {
      setStateValue(nextValue);
    }
    onChange(nextValue);
  }, [isControlled, onChange, value]);
  return [currentValue, handleChange];
}
function useCopyToClipboard() {
  const _React__default$useSt = React__default.useState(null),
    _React__default$useSt2 = _slicedToArray(_React__default$useSt, 2),
    copiedText = _React__default$useSt2[0],
    setCopiedText = _React__default$useSt2[1];
  const copy = async text => {
    if (!navigator?.clipboard) {
      // eslint-disable-next-line no-console
      console.warn('Clipboard not supported');
      return false;
    }

    // Try to save to clipboard then save it in the state if worked
    try {
      await navigator.clipboard.writeText(text);
      setCopiedText(text);
      return true;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn('Copy failed', error);
      setCopiedText(null);
      return false;
    }
  };
  return {
    copiedText,
    copy
  };
}
function useDebouncedState(defaultValue, wait, options = {
  leading: false
}) {
  const _React$useState7 = React.useState(defaultValue),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    value = _React$useState8[0],
    setValue = _React$useState8[1];
  const timeoutRef = React.useRef();
  const leadingRef = React.useRef(true);
  const clearTimeout = React.useCallback(() => void window.clearTimeout(timeoutRef.current), [timeoutRef]);
  React.useEffect(() => clearTimeout, [clearTimeout]);
  const debouncedSetValue = newValue => {
    clearTimeout();
    if (leadingRef.current && options.leading) {
      setValue(newValue);
    } else {
      timeoutRef.current = window.setTimeout(() => {
        leadingRef.current = true;
        setValue(newValue);
      }, wait);
    }
    leadingRef.current = false;
  };
  return [value, debouncedSetValue];
}
const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? React.useLayoutEffect : React.useEffect;
function useMergedRef(...refs) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return React.useCallback(mergeRefs(...refs), refs);
}
function useMultiCombobox(props, state) {
  return useComboBox(props, state);
}
function useMultiSelect(props, state, ref) {
  const keyboardDelegate = props.keyboardDelegate,
    isDisabled = props.isDisabled;
  const collator = useCollator({
    usage: 'search',
    sensitivity: 'base'
  });
  const delegate = React.useMemo(() => keyboardDelegate ?? new ListKeyboardDelegate(state.collection, state.disabledKeys, null, collator), [keyboardDelegate, state.collection, state.disabledKeys, collator]);
  const _useMenuTrigger = useMenuTrigger({
      isDisabled,
      type: 'listbox'
    }, state, ref),
    menuTriggerProps = _useMenuTrigger.menuTriggerProps,
    menuProps = _useMenuTrigger.menuProps;
  const _useTypeSelect = useTypeSelect({
      keyboardDelegate: delegate,
      selectionManager: state.selectionManager,
      onTypeSelect: key => {
        if (state.selectedKeys === 'all') {
          state.setSelectedKeys(new Set([...state.collection].map(item => item.key).filter(k => k !== key)));
        } else {
          state.setSelectedKeys(state.selectedKeys.add(key));
        }
      }
    }),
    typeSelectProps = _useTypeSelect.typeSelectProps;
  const _useField = useField(_objectSpread(_objectSpread({}, props), {}, {
      labelElementType: 'span'
    })),
    labelProps = _useField.labelProps,
    fieldProps = _useField.fieldProps,
    descriptionProps = _useField.descriptionProps,
    errorMessageProps = _useField.errorMessageProps;
  typeSelectProps.onKeyDown = typeSelectProps.onKeyDownCapture;
  delete typeSelectProps.onKeyDownCapture;
  const domProps = filterDOMProps(props, {
    labelable: true
  });
  const triggerProps = mergeProps$1(typeSelectProps, menuTriggerProps, fieldProps);
  const valueId = useId();
  return {
    labelProps: _objectSpread(_objectSpread({}, labelProps), {}, {
      onClick: () => {
        if (!props.isDisabled) {
          ref.current?.focus();

          // Show the focus ring so the user knows where focus went
          setInteractionModality('keyboard');
        }
      }
    }),
    triggerProps: mergeProps$1(domProps, _objectSpread(_objectSpread({}, triggerProps), {}, {
      onKeyDown: chain(triggerProps.onKeyDown, props.onKeyDown),
      onKeyUp: props.onKeyUp,
      'aria-labelledby': [triggerProps['aria-labelledby'], triggerProps['aria-label'] && !triggerProps['aria-labelledby'] ? triggerProps.id : null, valueId].filter(Boolean).join(' '),
      onFocus(event) {
        if (state.isFocused) {
          return;
        }
        if (props.onFocus) {
          props.onFocus(event);
        }
        if (props.onFocusChange) {
          props.onFocusChange(true);
        }
        state.setFocused(true);
      },
      onBlur(event) {
        if (state.isOpen) {
          return;
        }
        if (props.onBlur) {
          props.onBlur(event);
        }
        if (props.onFocusChange) {
          props.onFocusChange(false);
        }
        state.setFocused(false);
      }
    })),
    valueProps: {
      id: valueId
    },
    menuProps: _objectSpread(_objectSpread({}, menuProps), {}, {
      autoFocus: state.focusStrategy || true,
      shouldSelectOnPressUp: true,
      shouldFocusOnHover: true,
      disallowEmptySelection: true,
      onBlur: event => {
        if (event.currentTarget.contains(event.relatedTarget)) {
          return;
        }
        if (props.onBlur) {
          props.onBlur(event);
        }
        if (props.onFocusChange) {
          props.onFocusChange(false);
        }
        state.setFocused(false);
      },
      'aria-labelledby': [fieldProps['aria-labelledby'], triggerProps['aria-label'] && !fieldProps['aria-labelledby'] ? triggerProps.id : null].filter(Boolean).join(' ')
    }),
    descriptionProps,
    errorMessageProps
  };
}
const Transition = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const children = props.children,
    classNameProp = props.className,
    inProp = props.in,
    addEndListener = props.addEndListener,
    onEnter = props.onEnter,
    onEntering = props.onEntering,
    onEntered = props.onEntered,
    onExit = props.onExit,
    onExiting = props.onExiting,
    onExited = props.onExited,
    style = props.style,
    _props$timeout = props.timeout,
    timeout = _props$timeout === void 0 ? 250 : _props$timeout,
    other = _objectWithoutProperties(props, _excluded25);
  const nodeRef = React.useRef(null);
  const mergedRef = useMergedRef(nodeRef, forwardedRef);
  const handleEnter = React.useCallback(isAppearing => {
    if (nodeRef.current) {
      onEnter?.(nodeRef.current, isAppearing);
    }
  }, [onEnter]);
  const handleEntering = React.useCallback(isAppearing => {
    if (nodeRef.current) {
      onEntering?.(nodeRef.current, isAppearing);
    }
  }, [onEntering]);
  const handleEntered = React.useCallback(isAppearing => {
    if (nodeRef.current) {
      onEntered?.(nodeRef.current, isAppearing);
    }
  }, [onEntered]);
  const handleExit = React.useCallback(() => {
    if (nodeRef.current) {
      onExit?.(nodeRef.current);
    }
  }, [onExit]);
  const handleExited = React.useCallback(() => {
    if (nodeRef.current) {
      onExited?.(nodeRef.current);
    }
  }, [onExited]);
  const handleExiting = React.useCallback(() => {
    if (nodeRef.current) {
      onExiting?.(nodeRef.current);
    }
  }, [onExiting]);
  const handleAddEndLister = React.useCallback(done => {
    if (nodeRef.current) {
      addEndListener?.(nodeRef.current, done);
    }
  }, [addEndListener]);
  return /*#__PURE__*/jsx(TransitionComponent, _objectSpread(_objectSpread({}, other), {}, {
    addEndListener: handleAddEndLister,
    in: inProp,
    nodeRef: nodeRef,
    timeout: timeout,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    children: status => {
      const className = cx('manifest-transition', {
        'manifest-transition--entered': status === 'entered',
        'manifest-transition--entering': status === 'entering',
        'manifest-transition--exited': status === 'exited',
        'manifest-transition--exiting': status === 'exiting'
      }, classNameProp);
      if (typeof children === 'function') {
        return children(status, {
          className,
          ref: mergedRef
        });
      }
      return /*#__PURE__*/React.cloneElement(children, {
        className,
        ref: mergedRef
      });
    }
  }));
});
const Collapse = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const children = props.children,
    inProp = props.in,
    _props$duration = props.duration,
    duration = _props$duration === void 0 ? 200 : _props$duration,
    onEnter = props.onEnter,
    onEntering = props.onEntering,
    onEntered = props.onEntered,
    onExit = props.onExit,
    onExiting = props.onExiting,
    style = props.style,
    _props$timeout2 = props.timeout,
    timeout = _props$timeout2 === void 0 ? 200 : _props$timeout2,
    other = _objectWithoutProperties(props, _excluded26);
  const handleEnter = React.useCallback((node, isAppearing) => {
    node.style.height = '0px';
    onEnter?.(node, isAppearing);
  }, [onEnter]);
  const handleEntering = React.useCallback((node, isAppearing) => {
    const value = node.scrollHeight;
    node.style.height = `${value}px`;
    node.style.transition = `height ${duration}ms cubic-bezier(0.4, 0.14, 0.3, 1) 0ms`;
    onEntering?.(node, isAppearing);
  }, [duration, onEntering]);
  const handleEntered = React.useCallback((node, isAppearing) => {
    node.style.height = 'auto';
    onEntered?.(node, isAppearing);
  }, [onEntered]);
  const handleExit = React.useCallback(node => {
    const value = node.scrollHeight;
    node.style.height = `${value}px`;
    onExit?.(node);
  }, [onExit]);
  const handleExiting = React.useCallback(node => {
    reflow(node);
    node.style.height = '0px';
    node.style.transition = `height ${duration}ms cubic-bezier(0.4, 0.14, 0.3, 1) 0ms`;
    onExiting?.(node);
  }, [duration, onExiting]);
  return /*#__PURE__*/jsx(Transition, _objectSpread(_objectSpread({}, other), {}, {
    ref: forwardedRef,
    in: inProp,
    timeout: timeout,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExiting: handleExiting,
    children: (_, childrenProps) => /*#__PURE__*/jsx("div", _objectSpread(_objectSpread({}, childrenProps), {}, {
      style: _objectSpread({
        overflow: 'hidden',
        height: 0
      }, style),
      children: children
    }))
  }));
});
const useStyles$g = css({
  $$helperTextColor: '$colors$text-secondary',
  border: 0,
  display: 'inline-flex',
  margin: 0,
  padding: 0,
  position: 'relative',
  width: '100%',
  '.manifest-form-control__helper-text': {
    color: '$$helperTextColor',
    marginTop: '$x-small'
  },
  '.manifest-form-control__label': {
    color: '$text-secondary',
    padding: 0,
    marginBottom: '$x-small',
    position: 'relative'
  },
  '.manifest-form-control__required-indicator': {
    color: '$text-tertiary',
    marginLeft: '$x-small'
  },
  variants: {
    isInvalid: {
      true: {
        $$helperTextColor: '$colors$text-danger'
      }
    },
    orientation: {
      horizontal: {
        flexDirection: 'row'
      },
      vertical: {
        flexDirection: 'column'
      }
    }
  },
  defaultVariants: {
    orientation: 'horizontal'
  }
});
const FormControl = createComponent((props, forwardedRef) => {
  const children = props.children,
    classNameProp = props.className,
    css = props.css,
    helperText = props.helperText,
    _props$helperTextProp = props.helperTextProps,
    helperTextProps = _props$helperTextProp === void 0 ? {} : _props$helperTextProp,
    _props$isRequired = props.isRequired,
    isRequired = _props$isRequired === void 0 ? true : _props$isRequired,
    label = props.label,
    _props$labelProps = props.labelProps,
    labelProps = _props$labelProps === void 0 ? {} : _props$labelProps,
    _props$orientation2 = props.orientation,
    orientation = _props$orientation2 === void 0 ? 'vertical' : _props$orientation2,
    validationState = props.validationState,
    other = _objectWithoutProperties(props, _excluded27);
  const isInvalid = validationState === 'invalid';
  const _useStyles$g = useStyles$g({
      css,
      isInvalid,
      orientation
    }),
    className = _useStyles$g.className;
  return /*#__PURE__*/jsxs("div", _objectSpread(_objectSpread({}, other), {}, {
    ref: forwardedRef,
    className: cx(className, classNameProp, 'manifest-form-control'),
    children: [label && /*#__PURE__*/jsxs(Typography, _objectSpread(_objectSpread({
      as: "label",
      className: "manifest-form-control__label",
      variant: "subtextBold"
    }, labelProps), {}, {
      children: [label, !isRequired && /*#__PURE__*/jsx("span", {
        "aria-hidden": true,
        className: "manifest-form-control__required-indicator",
        children: "(optional)"
      })]
    })), children, helperText && /*#__PURE__*/jsx(Typography, _objectSpread(_objectSpread({
      className: "manifest-form-control__helper-text",
      variant: "caption"
    }, helperTextProps), {}, {
      children: helperText
    }))]
  }));
});
const useStyles$f = globalCss({
  '*, *:before, *:after': {
    boxSizing: 'border-box'
  }
});
const CssBaseline = /*#__PURE__*/React.memo(props => {
  const children = props.children;
  useStyles$f();

  // We don't wish to add any markup here, a fragment is not useless in this case.
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return /*#__PURE__*/jsx(Fragment, {
    children: children
  });
});
const StyledProvider = styled('div', {
  fontFamily: '$text',
  fontSize: '$medium',
  fontWeight: '$regular',
  letterSpacing: '$medium',
  lineHeight: '$medium',
  '&:lang(zh-Hans), &:lang(ja), &:lang(fr), &:lang(de), &:lang(es), &:lang(pt)': {
    fontFamily: '$character'
  }
});
const ProviderImpl = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const as = props.as,
    children = props.children,
    classNameProp = props.className,
    css = props.css,
    other = _objectWithoutProperties(props, _excluded28);
  const _useLocale6 = useLocale(),
    locale = _useLocale6.locale,
    direction = _useLocale6.direction;
  const _useModalProvider = useModalProvider(),
    modalProviderProps = _useModalProvider.modalProviderProps;
  const classnames = cx('manifest-provider', classNameProp);
  return /*#__PURE__*/jsx(StyledProvider, _objectSpread(_objectSpread(_objectSpread({}, other), modalProviderProps), {}, {
    ref: forwardedRef,
    as: as,
    className: classnames,
    css: css,
    dir: direction,
    lang: locale,
    children: children
  }));
});
const Provider = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const _useLocale7 = useLocale(),
    prevLocale = _useLocale7.locale;
  const children = props.children,
    _props$locale = props.locale,
    locale = _props$locale === void 0 ? prevLocale : _props$locale,
    disableCSSBaseline = props.disableCSSBaseline,
    style = props.style,
    other = _objectWithoutProperties(props, _excluded29);
  return /*#__PURE__*/jsx(I18nProvider, {
    locale: locale,
    children: /*#__PURE__*/jsxs(ModalProvider, {
      children: [!disableCSSBaseline && /*#__PURE__*/jsx(CssBaseline, {}), /*#__PURE__*/jsx(ProviderImpl, _objectSpread(_objectSpread({}, other), {}, {
        ref: forwardedRef,
        children: children
      }))]
    })
  });
});
function Overlay(props) {
  const children = props.children,
    containerRef = props.containerRef,
    isOpen = props.isOpen;
  const portalContainer = containerRef?.current;
  return /*#__PURE__*/jsx(Overlay$1, {
    portalContainer: portalContainer,
    children: isOpen && /*#__PURE__*/jsx(Provider, {
      children: children
    })
  });
}
const StyledPopover = styled('div', {
  backgroundColor: '$background-surface',
  borderRadius: '$small',
  boxSizing: 'border-box',
  boxShadow: '$medium',
  display: 'inline-flex',
  flexDirection: 'column',
  outline: 0,
  overflow: 'hidden auto'
});
const Popover = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const as = props.as,
    children = props.children,
    classNameProp = props.className,
    css = props.css,
    _props$isDismissable = props.isDismissable,
    isDismissable = _props$isDismissable === void 0 ? true : _props$isDismissable,
    _props$isKeyboardDism = props.isKeyboardDismissDisabled,
    isKeyboardDismissDisabled = _props$isKeyboardDism === void 0 ? false : _props$isKeyboardDism,
    isOpen = props.isOpen,
    onClose = props.onClose,
    _props$shouldCloseOnB = props.shouldCloseOnBlur,
    shouldCloseOnBlur = _props$shouldCloseOnB === void 0 ? false : _props$shouldCloseOnB,
    shouldCloseOnInteractOutside = props.shouldCloseOnInteractOutside,
    other = _objectWithoutProperties(props, _excluded30);
  const overlayRef = React.useRef(null);
  const mergedRef = useMergedRef(overlayRef, forwardedRef);
  const _useOverlay = useOverlay({
      isDismissable: isDismissable && isOpen,
      isKeyboardDismissDisabled,
      isOpen,
      onClose,
      shouldCloseOnBlur,
      shouldCloseOnInteractOutside
    }, overlayRef),
    overlayProps = _useOverlay.overlayProps;
  const _useModal = useModal({
      isDisabled: true
    }),
    modalProps = _useModal.modalProps;
  return /*#__PURE__*/jsx(FocusScope, {
    restoreFocus: true,
    children: /*#__PURE__*/jsxs(StyledPopover, _objectSpread(_objectSpread({}, mergeProps(overlayProps, modalProps, other)), {}, {
      ref: mergedRef,
      as: as,
      className: cx('manifest-popover', classNameProp),
      css: css,
      role: "presentation",
      children: [/*#__PURE__*/jsx(DismissButton, {
        onDismiss: onClose
      }), children, /*#__PURE__*/jsx(DismissButton, {
        onDismiss: onClose
      })]
    }))
  });
});
function usePopoverTrigger(props, state) {
  const maxHeight = props.maxHeight,
    _props$offset = props.offset,
    offset = _props$offset === void 0 ? 4 : _props$offset,
    _props$placement = props.placement,
    placement = _props$placement === void 0 ? 'bottom' : _props$placement,
    scrollRef = props.scrollRef,
    _props$shouldFlip = props.shouldFlip,
    shouldFlip = _props$shouldFlip === void 0 ? true : _props$shouldFlip,
    _props$shouldUpdatePo = props.shouldUpdatePosition,
    shouldUpdatePosition = _props$shouldUpdatePo === void 0 ? true : _props$shouldUpdatePo,
    _props$type2 = props.type,
    type = _props$type2 === void 0 ? 'dialog' : _props$type2;
  const overlayRef = React.useRef(null);
  const triggerRef = React.useRef(null);
  const _useOverlayTrigger = useOverlayTrigger({
      type
    }, state, triggerRef),
    triggerProps = _useOverlayTrigger.triggerProps,
    overlayProps = _useOverlayTrigger.overlayProps;
  const _useOverlayPosition = useOverlayPosition({
      isOpen: state.isOpen,
      maxHeight,
      offset,
      onClose: state.close,
      overlayRef,
      placement,
      scrollRef,
      shouldFlip,
      shouldUpdatePosition,
      targetRef: triggerRef
    }),
    positionProps = _useOverlayPosition.overlayProps;
  return {
    overlayRef,
    overlayProps: _objectSpread(_objectSpread({}, overlayProps), positionProps),
    state,
    triggerRef,
    triggerProps
  };
}
function usePopoverTriggerState(props) {
  const state = useOverlayTriggerState(props);
  return state;
}
const useStyles$e = css({
  $$backgroundColor: '$colors$background-primary',
  $$borderColor: '$colors$palette-grey-500',
  $$iconColor: '$colors$text-tertiary',
  $$textColor: '$colors$text-primary',
  '.manifest-combobox__wrapper': {
    display: 'flex',
    minWidth: pxToRem(48),
    position: 'relative',
    width: '100%'
  },
  '.manifest-combobox__icon': {
    alignItems: 'center',
    color: '$$iconColor',
    display: 'inline-flex',
    justifyContent: 'center',
    padding: '$small',
    position: 'absolute',
    left: 0,
    top: 0,
    zIndex: 2
  },
  '.manifest-combobox__button': {
    appearance: 'none',
    alignItems: 'center',
    background: 'none',
    border: 0,
    borderLeft: '1px solid $$borderColor',
    color: '$$iconColor',
    cursor: 'pointer',
    display: 'inline-flex',
    justifyContent: 'center',
    margin: 0,
    outline: 'none',
    padding: '$small',
    position: 'absolute',
    right: 0,
    top: 0,
    zIndex: 2
  },
  '.manifest-combobox__input': {
    appearance: 'none',
    backgroundColor: '$$backgroundColor',
    border: '1px solid $$borderColor',
    borderRadius: '$small',
    boxSizing: 'border-box',
    color: '$$textColor',
    cursor: 'text',
    margin: 0,
    outline: 0,
    p: '0 $small',
    paddingRight: pxToRem(40),
    resize: 'none',
    transition: '$color',
    typography: '$subtext',
    width: '100%',
    '&::placeholder': {
      color: '$text-tertiary'
    }
  },
  variants: {
    hasStartIcon: {
      true: {
        '.manifest-combobox__input': {
          paddingLeft: pxToRem(40)
        }
      }
    },
    isDisabled: {
      true: {
        $$backgroundColor: '$colors$palette-grey-50',
        $$textColor: '$colors$text-disabled',
        '.manifest-combobox__input': {
          cursor: 'not-allowed'
        }
      }
    },
    isFocused: {
      true: {
        $$borderColor: '$colors$primary-default'
      }
    },
    isFocusVisible: {
      true: {
        '.manifest-combobox__wrapper': {
          '&:after': {
            backgroundColor: 'transparent',
            border: '2px solid $colors$palette-indigo-200',
            // TODO: replace with design token once its defined.s
            borderRadius: '4px',
            bottom: '-3px',
            content: '',
            display: 'block',
            left: '-3px',
            position: 'absolute',
            right: '-3px',
            top: '-3px'
          }
        }
      },
      false: {}
    },
    isHovered: {
      true: {
        $$borderColor: '$colors$palette-grey-600'
      }
    },
    isInvalid: {
      true: {
        $$borderColor: '$colors$border-danger',
        $$iconColor: '$colors$text-danger',
        $$textColor: '$colors$text-danger'
      }
    },
    isPlaceholder: {
      true: {
        $$textColor: '$colors$text-tertiary'
      }
    },
    size: {
      medium: {
        '.manifest-combobox__icon, .manifest-combobox__button': {
          fontSize: '$x-large',
          size: pxToRem(40),
          '> .material-icons': {
            fontSize: '$x-large'
          }
        },
        '.manifest-combobox__input': {
          height: pxToRem(40)
        }
      },
      small: {
        '.manifest-combobox__icon, .manifest-combobox__button': {
          fontSize: pxToRem(18),
          size: pxToRem(34),
          '> .material-icons': {
            fontSize: pxToRem(18)
          }
        },
        '.manifest-combobox__input': {
          height: pxToRem(34)
        }
      }
    }
  },
  defaultVariants: {
    size: 'medium'
  }
});
const Combobox = createComponent((props, forwardedRef) => {
  const _props$as9 = props.as,
    Comp = _props$as9 === void 0 ? 'div' : _props$as9,
    autoFocus = props.autoFocus,
    classNameProp = props.className,
    containerRefProp = props.containerRef,
    css = props.css,
    isDisabled = props.isDisabled,
    helperText = props.helperText,
    _props$helperTextProp2 = props.helperTextProps,
    helperTextPropsProp = _props$helperTextProp2 === void 0 ? {} : _props$helperTextProp2,
    label = props.label,
    _props$labelProps2 = props.labelProps,
    labelPropsProp = _props$labelProps2 === void 0 ? {} : _props$labelProps2,
    maxHeight = props.maxHeight,
    _props$offset2 = props.offset,
    offset = _props$offset2 === void 0 ? 4 : _props$offset2,
    _props$placement2 = props.placement,
    placement = _props$placement2 === void 0 ? 'bottom' : _props$placement2,
    _props$shouldFlip2 = props.shouldFlip,
    shouldFlip = _props$shouldFlip2 === void 0 ? true : _props$shouldFlip2,
    validationState = props.validationState,
    _props$size6 = props.size,
    size = _props$size6 === void 0 ? 'medium' : _props$size6,
    startIcon = props.startIcon,
    _props$variant3 = props.variant,
    variant = _props$variant3 === void 0 ? 'dropdown' : _props$variant3,
    _props$loading = props.loading,
    loading = _props$loading === void 0 ? false : _props$loading,
    loadingText = props.loadingText,
    noResultsChildren = props.noResultsChildren;
  const isInvalid = validationState === 'invalid';
  const containerRef = React.useRef(null);
  const buttonRef = React.useRef(null);
  const inputRef = React.useRef(null);
  const listBoxRef = React.useRef(null);
  const popoverRef = React.useRef(null);
  const _useFilter = useFilter({
      sensitivity: 'base'
    }),
    contains = _useFilter.contains;
  const state = useComboBoxState(_objectSpread(_objectSpread({}, props), {}, {
    defaultFilter: contains,
    // allow menu to open with no results if the user has set an
    // empty state or the combobox is indicated to be loading.
    // This enables us to open the menu and show these two states.
    allowsEmptyCollection: noResultsChildren !== undefined || loading
  }));
  const _useComboBox = useComboBox(_objectSpread(_objectSpread({}, props), {}, {
      buttonRef,
      inputRef,
      listBoxRef,
      popoverRef
    }), state),
    triggerProps = _useComboBox.buttonProps,
    inputProps = _useComboBox.inputProps,
    listBoxProps = _useComboBox.listBoxProps,
    labelProps = _useComboBox.labelProps,
    descriptionProps = _useComboBox.descriptionProps,
    errorMessageProps = _useComboBox.errorMessageProps;
  const _useOverlayPosition2 = useOverlayPosition({
      isOpen: state.isOpen,
      maxHeight,
      offset,
      onClose: state.close,
      overlayRef: popoverRef,
      placement,
      shouldFlip,
      scrollRef: listBoxRef,
      targetRef: containerRef
    }),
    overlayProps = _useOverlayPosition2.overlayProps;
  const _useButton2 = useButton(triggerProps, buttonRef),
    buttonProps = _useButton2.buttonProps;
  const _useHover5 = useHover({
      isDisabled
    }),
    hoverProps = _useHover5.hoverProps,
    isHovered = _useHover5.isHovered;
  const _useFocusRing4 = useFocusRing({
      autoFocus,
      isTextInput: true,
      within: true
    }),
    isFocusVisible = _useFocusRing4.isFocusVisible,
    isFocused = _useFocusRing4.isFocused,
    focusProps = _useFocusRing4.focusProps;
  const handleClose = React.useCallback(() => void state.close(), [state]);
  const _useStyles$e = useStyles$e({
      hasStartIcon: Boolean(startIcon),
      isDisabled,
      isFocused,
      isFocusVisible,
      isHovered,
      isInvalid,
      isPlaceholder: !state.selectedItem,
      size,
      css
    }),
    className = _useStyles$e.className;
  const classes = cx(className, classNameProp, {
    'manifest-combobox': true,
    'manifest-combobox--disabled': isDisabled,
    'manifest-combobox--invalid': isInvalid,
    [`manifest-combobox--${size}`]: size
  });
  const containerDimensions = containerRef.current?.getBoundingClientRect();
  return /*#__PURE__*/jsx(FormControl, {
    className: classes,
    helperText: helperText,
    helperTextProps: mergeProps$1(descriptionProps, errorMessageProps, helperTextPropsProp),
    label: label,
    labelProps: mergeProps$1(labelProps, labelPropsProp),
    validationState: validationState,
    children: /*#__PURE__*/jsxs(Comp, _objectSpread(_objectSpread({}, mergeProps$1(hoverProps, focusProps)), {}, {
      ref: mergeRefs$1(containerRef, forwardedRef),
      className: "manifest-combobox__wrapper",
      children: [startIcon && /*#__PURE__*/jsx("span", {
        className: "manifest-combobox__icon",
        children: startIcon
      }), /*#__PURE__*/jsx("input", _objectSpread(_objectSpread({}, inputProps), {}, {
        ref: inputRef,
        className: "manifest-combobox__input"
      })), variant === 'dropdown' && /*#__PURE__*/jsx("button", _objectSpread(_objectSpread({}, buttonProps), {}, {
        ref: buttonRef,
        className: "manifest-combobox__button",
        children: /*#__PURE__*/jsx(Icon, {
          icon: "expand_more"
        })
      })), /*#__PURE__*/jsx(Overlay, {
        containerRef: containerRefProp,
        isOpen: state.isOpen && !isDisabled,
        children: /*#__PURE__*/jsx(Popover, _objectSpread(_objectSpread({}, overlayProps), {}, {
          ref: popoverRef,
          className: "manifest-combobox__popover",
          css: {
            left: containerDimensions?.left,
            width: containerDimensions?.width
          },
          isOpen: state.isOpen,
          onClose: handleClose,
          children: /*#__PURE__*/jsx(ListBoxBase, _objectSpread(_objectSpread({}, listBoxProps), {}, {
            ref: listBoxRef,
            disallowEmptySelection: true,
            className: "manifest-combobox__list-box",
            loading: loading,
            loadingText: loadingText,
            noResultsChildren: noResultsChildren,
            state: state
          }))
        }))
      })]
    }))
  });
});
const ComboboxItem = Item;
const ComboboxSection = Section;
const StyledContainer = styled('div', {
  boxSizing: 'border-box',
  display: 'block',
  mx: 'auto',
  px: '$large',
  width: '100%',
  variants: {
    fixed: {
      true: {
        '@sm': {
          maxWidth: '$small'
        },
        '@md': {
          maxWidth: '$medium'
        },
        '@lg': {
          maxWidth: '$large'
        },
        '@xl': {
          maxWidth: '$x-large'
        },
        '@xs': {
          maxWidth: '$x-small'
        }
      }
    },
    maxWidth: {
      small: {
        maxWidth: '$small'
      },
      medium: {
        maxWidth: '$medium'
      },
      large: {
        maxWidth: '$large'
      },
      'x-large': {
        maxWidth: '$x-large'
      },
      'x-small': {
        maxWidth: '$x-small'
      }
    }
  }
});
const Container = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const as = props.as,
    classNameProp = props.className,
    css = props.css,
    fixed = props.fixed,
    _props$maxWidth = props.maxWidth,
    maxWidth = _props$maxWidth === void 0 ? 'large' : _props$maxWidth,
    other = _objectWithoutProperties(props, _excluded31);
  return /*#__PURE__*/jsx(StyledContainer, _objectSpread(_objectSpread({}, other), {}, {
    ref: forwardedRef,
    as: as,
    className: cx('manifest-container', classNameProp),
    css: css,
    fixed: fixed,
    maxWidth: maxWidth
  }));
});
const StyledSkeleton = styled(ContentLoader);
function Skeleton(props) {
  const children = props.children,
    classNameProp = props.className,
    css = props.css,
    other = _objectWithoutProperties(props, _excluded32);
  const id = React.useId();
  const className = cx('manifest-skeleton', classNameProp);
  return /*#__PURE__*/jsx(StyledSkeleton, _objectSpread(_objectSpread({}, other), {}, {
    className: className,
    css: css,
    uniqueKey: id // needed for SSR: https://github.com/danilowoz/react-content-loader#sedrver-side-rendering-ssr---match-snapshot
    ,

    children: children
  }));
}
const getColumnLayoutStyles = (table, column) => {
  const leftOffset = column.getStart('left');
  const rightOffset = (table.getRightLeafHeaders().length - 1 - column.getPinnedIndex()) * 180;
  const isFirstRightPinnedColumn = column.getIsPinned() === 'right' && column.getPinnedIndex() === 0;
  const isLastLeftPinnedColumn = column.getIsPinned() === 'left' && table.getLeftLeafHeaders().length - 1 === column.getPinnedIndex();
  const styles = _objectSpread(_objectSpread({
    left: column.getIsPinned() === 'left' ? `${leftOffset}px` : undefined,
    right: column.getIsPinned() === 'right' ? `${rightOffset}px` : undefined,
    minWidth: `max(calc(${column.getSize()} * 1px), ${column.columnDef.minSize ?? 40}px)`,
    width: `calc(${column.getSize()} * 1px)`
  }, isFirstRightPinnedColumn && {
    borderLeft: `1px solid ${theme.colors['border-primary']}`
  }), isLastLeftPinnedColumn && {
    borderRight: `1px solid ${theme.colors['border-primary']}`
  });
  return styles;
};
function DataTableCell(props) {
  const cell = props.cell,
    table = props.table;
  const styles = getColumnLayoutStyles(table, cell.column);
  const isNested = cell.column.id === 'manifest-data-table-row-expand';
  return /*#__PURE__*/jsxs("td", {
    className: cx('manifest-table__cell', {
      'manifest-table__cell--pinned': cell.column.getIsPinned()
    }),
    style: _objectSpread(_objectSpread({}, styles), {}, {
      paddingLeft: isNested ? `${cell.row.depth + 0.75}rem` : undefined
    }),
    children: [table.options.isLoading && /*#__PURE__*/jsx("div", {
      style: {
        display: 'flex',
        alignItems: 'center'
      },
      children: /*#__PURE__*/jsx(Skeleton, {
        height: 32,
        width: cell.column.getSize(),
        children: /*#__PURE__*/jsx("rect", {
          height: "32",
          rx: "4",
          ry: "4",
          width: "100%",
          x: "0",
          y: "0"
        })
      })
    }), !table.options.isLoading && flexRender(cell.column.columnDef.cell, cell.getContext())]
  });
}
function DataTableBody(props) {
  const table = props.table;
  return /*#__PURE__*/jsx("tbody", {
    className: "manifest-table__body",
    children: table.getRowModel().rows.map(row => /*#__PURE__*/jsx("tr", {
      className: "manifest-table__row",
      children: row.getVisibleCells().map(cell => /*#__PURE__*/jsx(DataTableCell, {
        cell: cell,
        table: table
      }, cell.id))
    }, row.id))
  });
}
function DataTableCheckbox(props) {
  const row = props.row,
    table = props.table;
  const options = table.options;
  const selectCheckboxProps = options.selectCheckboxProps,
    selectAllCheckboxProps = options.selectAllCheckboxProps;
  let parsedProps;
  if (row) {
    parsedProps = typeof selectCheckboxProps === 'function' ? selectCheckboxProps({
      row,
      table
    }) : selectCheckboxProps;
  } else {
    parsedProps = typeof selectAllCheckboxProps === 'function' ? selectAllCheckboxProps({
      table
    }) : selectAllCheckboxProps;
  }
  const isSelected = row ? row?.getIsSelected() : table.getIsAllPageRowsSelected();
  const isDisabled = row && !row.getCanSelect();
  const isIndeterminate = row ? row?.getIsSomeSelected() : table.getIsSomeRowsSelected() && !table.getIsAllPageRowsSelected();
  const handleChange = React.useCallback(checked => row ? void row?.toggleSelected(checked) : void table.toggleAllPageRowsSelected(), [row, table]);
  return /*#__PURE__*/jsx("div", {
    className: "manifest-data-table__checkbox",
    children: /*#__PURE__*/jsx(Checkbox, _objectSpread({
      isDisabled: isDisabled,
      isIndeterminate: isIndeterminate,
      isSelected: isSelected,
      onChange: handleChange
    }, parsedProps))
  });
}
function DataTableExpandAllButton(props) {
  const table = props.table;
  const options = table.options;
  const expandAllButtonProps = options.expandAllButtonProps,
    isLoading = options.isLoading;
  const parsedProps = typeof expandAllButtonProps === 'function' ? expandAllButtonProps({
    table
  }) : expandAllButtonProps;
  const isAllRowsExpanded = table.getIsAllRowsExpanded();
  const handleToggleExpand = React.useCallback(event => {
    void table.toggleAllRowsExpanded(!isAllRowsExpanded);
    parsedProps?.onPress?.(event);
  }, [isAllRowsExpanded, parsedProps, table]);
  return /*#__PURE__*/jsx(IconButton, _objectSpread(_objectSpread({}, parsedProps), {}, {
    isDisabled: isLoading || !table.getCanSomeRowsExpand(),
    size: "small",
    variant: "tertiary",
    onPress: handleToggleExpand,
    children: /*#__PURE__*/jsx(ChevronDown, {
      style: {
        transform: `rotate(${isAllRowsExpanded ? -180 : 0}deg)`,
        transition: 'transform 100ms'
      }
    })
  }));
}
function DataTableExpandButton(props) {
  const row = props.row,
    table = props.table;
  const options = table.options;
  const expandButtonProps = options.expandButtonProps,
    isLoading = options.isLoading;
  const parsedProps = typeof expandButtonProps === 'function' ? expandButtonProps({
    table,
    row
  }) : expandButtonProps;
  const canExpand = row.getCanExpand();
  const isExpanded = row.getIsExpanded();
  const handleToggleExpand = React.useCallback(event => {
    void row.toggleExpanded();
    parsedProps?.onPress?.(event);
  }, [row, parsedProps]);
  return /*#__PURE__*/jsx(IconButton, _objectSpread(_objectSpread({}, parsedProps), {}, {
    isDisabled: isLoading || !canExpand,
    size: "small",
    variant: "tertiary",
    onPress: handleToggleExpand,
    children: /*#__PURE__*/jsx(ChevronDown, {
      style: {
        transform: `rotate(${isExpanded ? -180 : 0}deg)`,
        transition: 'transform 100ms'
      }
    })
  }));
}
function DataTableColumn(props) {
  const header = props.header,
    table = props.table;
  const column = header.column;
  const isSortable = column.getCanSort();
  const styles = getColumnLayoutStyles(table, column);
  return /*#__PURE__*/jsx("th", {
    className: cx('manifest-table__cell', 'manifest-table__cell--header', {
      'manifest-table__cell--sticky-header': table.options.enableStickyHeader,
      'manifest-table__cell--pinned': column.getIsPinned()
    }),
    colSpan: header.colSpan,
    style: _objectSpread({}, styles),
    onClick: header.column.getToggleSortingHandler(),
    children: isSortable ? /*#__PURE__*/jsxs("button", {
      className: "manifest-table__heading",
      children: [flexRender(header.column.columnDef.header, header.getContext()), isSortable && !header.column.getIsSorted() && /*#__PURE__*/jsx(Sort, {
        size: "small"
      }), {
        asc: /*#__PURE__*/jsx(ArrowDown, {
          size: "small"
        }),
        desc: /*#__PURE__*/jsx(ArrowUp, {
          size: "small"
        })
      }[header.column.getIsSorted()]]
    }) : flexRender(header.column.columnDef.header, header.getContext())
  }, header.id);
}
function DataTableHeader(props) {
  const table = props.table;
  return /*#__PURE__*/jsx("thead", {
    className: cx('manifest-table__header', {
      'manifest-table__header--sticky': !!table.options.enableStickyHeader
    }),
    children: table.getHeaderGroups().map(headerGroup => /*#__PURE__*/jsx("tr", {
      className: "manifest-table__row",
      children: headerGroup.headers.map(header => /*#__PURE__*/jsx(DataTableColumn, {
        header: header,
        table: table
      }, header.id))
    }, headerGroup.id))
  });
}
const StyledPaginationItem = styled('button', {
  $$backgroundColor: '$colors$palette-grey-50',
  alignItems: 'center',
  appearance: 'none',
  backgroundColor: '$$backgroundColor',
  border: '1px solid $colors$palette-grey-200',
  borderRadius: '$small',
  boxSizing: 'border-box',
  color: '$text-secondary',
  cursor: 'pointer',
  display: 'inline-flex',
  margin: 0,
  outline: 0,
  position: 'relative',
  px: pxToRem(12),
  py: pxToRem(6),
  transition: '$color',
  textDecoration: 'none',
  userSelect: 'none',
  width: 'auto',
  '.manifest-icon': {
    fontSize: pxToRem(18)
  },
  '.manifest-pagination-item__icon--end': {
    marginLeft: '$x-small'
  },
  '.manifest-pagination-item__icon--start': {
    marginRight: '$x-small'
  },
  variants: {
    isActive: {
      true: {
        $$backgroundColor: '$colors$palette-grey-200'
      }
    },
    isDisabled: {
      true: {
        opacity: 0.37,
        pointerEvents: 'none'
      }
    },
    isHovered: {
      true: {
        $$backgroundColor: '$colors$palette-grey-100'
      }
    },
    isPressed: {
      true: {}
    }
  },
  compoundVariants: [{
    isActive: true,
    isHovered: true,
    css: {
      $$backgroundColor: '$colors$palette-grey-200'
    }
  }]
}, focus);
const PaginationItem = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const as = props.as,
    autoFocus = props.autoFocus,
    children = props.children,
    classNameProp = props.className,
    css = props.css,
    isActive = props.isActive,
    isDisabled = props.isDisabled,
    other = _objectWithoutProperties(props, _excluded33);
  const itemRef = React.useRef(null);
  const _useButton3 = useButton(_objectSpread(_objectSpread({}, other), {}, {
      elementType: 'button',
      isDisabled
    }), itemRef),
    buttonProps = _useButton3.buttonProps,
    isPressed = _useButton3.isPressed;
  const _useFocusRing5 = useFocusRing({
      autoFocus
    }),
    isFocusVisible = _useFocusRing5.isFocusVisible,
    focusProps = _useFocusRing5.focusProps;
  const _useHover6 = useHover({
      isDisabled
    }),
    hoverProps = _useHover6.hoverProps,
    isHovered = _useHover6.isHovered;
  const className = cx('manifest-pagination-item', classNameProp, {
    'manifest-pagination-item--disabled': true,
    'manifest-pagination-item--selected': isActive
  });
  return /*#__PURE__*/jsx(StyledPaginationItem, _objectSpread(_objectSpread({}, mergeProps$1(buttonProps, focusProps, hoverProps)), {}, {
    ref: mergeRefs$1(itemRef, forwardedRef),
    as: as,
    className: className,
    css: css,
    isActive: isActive,
    isDisabled: isDisabled,
    isFocusVisible: isFocusVisible,
    isHovered: isHovered,
    isPressed: isPressed,
    children: children
  }));
});
const StyledPagination = styled('div', {
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
  '.manifest-pagination__actions': {
    alignItems: 'center',
    boxSizing: 'border-box',
    columnGap: '$x-small',
    display: 'flex',
    flexWrap: 'wrap',
    rowGap: '$small'
  },
  '.manifest-pagination__ellipsis': {
    backgroundColor: '$palette-grey-50',
    border: '1px solid $colors$palette-grey-200',
    borderRadius: '$small',
    boxSizing: 'border-box',
    display: 'inline-flex',
    margin: 0,
    outline: 0,
    position: 'relative',
    px: pxToRem(12),
    py: pxToRem(6)
  }
});
const range = (start, end) => {
  const length = end - start + 1;
  return Array.from({
    length
  }, (_, i) => start + i);
};
const defaultPagiationLabel = ({
  count,
  from,
  to
}) => `${from}-${to} of ${count}`;
function defaultGetItemAriaLabel(type, page, isActive) {
  if (type === 'page') {
    return `${isActive ? '' : 'Go to '}page ${page}`;
  }
  return `Go to ${type} page`;
}
const Pagination = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const as = props.as,
    _props$boundaries = props.boundaries,
    boundaries = _props$boundaries === void 0 ? 1 : _props$boundaries,
    children = props.children,
    classNameProp = props.className,
    css = props.css,
    _props$defaultPage = props.defaultPage,
    defaultPage = _props$defaultPage === void 0 ? 1 : _props$defaultPage,
    _props$getPaginationL = props.getPaginationLabel,
    getPaginationLabel = _props$getPaginationL === void 0 ? defaultPagiationLabel : _props$getPaginationL,
    _props$getItemAriaLab = props.getItemAriaLabel,
    getItemAriaLabel = _props$getItemAriaLab === void 0 ? defaultGetItemAriaLabel : _props$getItemAriaLab,
    _props$onChange = props.onChange,
    onChange = _props$onChange === void 0 ? noop : _props$onChange,
    _props$nextLabel = props.nextLabel,
    nextLabel = _props$nextLabel === void 0 ? 'Next' : _props$nextLabel,
    _props$page = props.page,
    page = _props$page === void 0 ? 1 : _props$page,
    _props$previousLabel = props.previousLabel,
    previousLabel = _props$previousLabel === void 0 ? 'Previous' : _props$previousLabel,
    _props$rowsPerPage = props.rowsPerPage,
    rowsPerPage = _props$rowsPerPage === void 0 ? 10 : _props$rowsPerPage,
    _props$siblings = props.siblings,
    siblings = _props$siblings === void 0 ? 1 : _props$siblings,
    _props$showLabel = props.showLabel,
    showLabel = _props$showLabel === void 0 ? false : _props$showLabel,
    _props$showPageNumber = props.showPageNumbers,
    showPageNumbers = _props$showPageNumber === void 0 ? true : _props$showPageNumber,
    _props$totalRowCount = props.totalRowCount,
    totalRowCount = _props$totalRowCount === void 0 ? 1 : _props$totalRowCount,
    other = _objectWithoutProperties(props, _excluded34);
  const _useControlledState$ = useControlledState$1(page, defaultPage, onChange),
    _useControlledState$2 = _slicedToArray(_useControlledState$, 2),
    activePage = _useControlledState$2[0],
    setActivePage = _useControlledState$2[1];
  const pageCount = Math.ceil(totalRowCount / rowsPerPage);
  const pages = React.useMemo(() => {
    const startRange = range(1, Math.min(boundaries, pageCount));
    const endRange = range(Math.max(pageCount - boundaries + 1, boundaries + 1), pageCount);
    const startIndex = Math.max(Math.min(Number(activePage) - siblings, pageCount - boundaries - siblings * 2 - 1), boundaries + 2);
    const endIndex = Math.min(Math.max(Number(activePage) + siblings, boundaries + siblings * 2 + 2), endRange.length > 0 ? endRange[0] - 2 : pageCount - 1);

    // Show siblings or dots
    let siblingsEndRange = pageCount - boundaries > boundaries ? [pageCount - boundaries] : [];
    let siblingsStartRange = boundaries + 1 < pageCount - boundaries ? [boundaries + 1] : [];
    if (endIndex < pageCount - boundaries - 1) {
      siblingsEndRange = ['dots'];
    }
    if (startIndex > boundaries + 2) {
      siblingsStartRange = ['dots'];
    }
    return [...startRange, ...siblingsStartRange, ...range(startIndex, endIndex), ...siblingsEndRange, ...endRange];
  }, [activePage, boundaries, pageCount, siblings]);
  const next = React.useCallback(() => void setActivePage(Number(activePage) + 1), [activePage, setActivePage]);
  const previous = React.useCallback(() => void setActivePage(Number(activePage) - 1), [activePage, setActivePage]);
  const setPage = pageNumber => () => void setActivePage(pageNumber);
  const className = cx('manifest-pagination', classNameProp);
  return /*#__PURE__*/jsxs(StyledPagination, _objectSpread(_objectSpread({}, other), {}, {
    ref: forwardedRef,
    as: as,
    className: className,
    css: css,
    children: [showLabel && /*#__PURE__*/jsx("div", {
      className: "manifest-pagination__label",
      children: /*#__PURE__*/jsx(Typography, {
        children: getPaginationLabel({
          count: totalRowCount,
          from: (page - 1) * rowsPerPage + 1,
          to: Math.min(totalRowCount, rowsPerPage * page)
        })
      })
    }), /*#__PURE__*/jsxs("div", {
      className: "manifest-pagination__actions",
      children: [/*#__PURE__*/jsxs(PaginationItem, {
        "aria-label": getItemAriaLabel('previous'),
        isDisabled: activePage === 1,
        onPress: previous,
        children: [/*#__PURE__*/jsx(ChevronLeft, {
          "aria-hidden": true,
          className: "manifest-pagination-item__icon--start"
        }), /*#__PURE__*/jsx(Typography, {
          variant: "subtextBold",
          children: previousLabel
        })]
      }), showPageNumbers && pages.map((item, index) => /*#__PURE__*/jsxs(React.Fragment, {
        children: [item === 'dots' && /*#__PURE__*/jsx("div", {
          "aria-hidden": true,
          className: "manifest-pagination__ellipsis",
          children: /*#__PURE__*/jsx(Typography, {
            variant: "subtextBold",
            children: "..."
          })
        }), item !== 'dots' && /*#__PURE__*/jsx(PaginationItem, {
          "aria-current": item === activePage ? 'true' : undefined,
          "aria-label": getItemAriaLabel('page', item, item === activePage),
          isActive: item === activePage,
          onPress: setPage(item),
          children: /*#__PURE__*/jsx(Typography, {
            variant: "subtextBold",
            children: item.toString()
          })
        })]
      }, item)), /*#__PURE__*/jsxs(PaginationItem, {
        "aria-label": defaultGetItemAriaLabel('next'),
        isDisabled: activePage === pageCount,
        onPress: next,
        children: [/*#__PURE__*/jsx(Typography, {
          variant: "subtextBold",
          children: nextLabel
        }), /*#__PURE__*/jsx(ChevronRight, {
          "aria-hidden": true,
          className: "manifest-pagination-item__icon--end"
        })]
      })]
    })]
  }));
});
function DataTablePagination(props) {
  const rowCount = props.rowCount,
    table = props.table;
  const options = table.options,
    getPrePaginationRowModel = table.getPrePaginationRowModel,
    getState = table.getState,
    setPageIndex = table.setPageIndex;
  const paginationProps = options.paginationProps;
  const _getState = getState(),
    _getState$pagination = _getState.pagination,
    _getState$pagination$ = _getState$pagination.pageSize,
    pageSize = _getState$pagination$ === void 0 ? 10 : _getState$pagination$,
    _getState$pagination$2 = _getState$pagination.pageIndex,
    pageIndex = _getState$pagination$2 === void 0 ? 0 : _getState$pagination$2;
  const parsedProps = typeof paginationProps === 'function' ? paginationProps({
    table
  }) : paginationProps;
  const totalRowCount = rowCount ?? getPrePaginationRowModel().rows.length;
  const handlePageChange = React.useCallback(page => void setPageIndex(page - 1), [setPageIndex]);
  return /*#__PURE__*/jsx("div", {
    className: "manifest-data-table__footer",
    children: /*#__PURE__*/jsx(Pagination, _objectSpread({
      showLabel: true,
      page: pageIndex + 1,
      rowsPerPage: pageSize,
      showPageNumbers: false,
      totalRowCount: totalRowCount,
      onChange: handlePageChange
    }, parsedProps))
  });
}
const StyledDataTable = styled('div', {
  $$tableBackgroundColor: '$colors$background-primary',
  backgroundColor: '$$tableBackgroundColor',
  boxSizing: 'border-box',
  color: '$text-primary',
  border: '1px solid $border-primary',
  borderRadius: '$small',
  '.manifest-data-table__container': {
    maxWidth: '100%',
    overflow: 'auto',
    width: '100%',
    '&--sticky-header': {
      maxHeight: 'clamp(350px, calc(100vh - 0px), 9999px)'
    },
    '&--sticky-header, &--pagination': {
      maxHeight: 'clamp(350px, calc(100vh - 48px), 9999px)'
    },
    '.manifest-table tr:hover td': {
      backgroundColor: '$background-secondary'
    }
  },
  '.manifest-data-table__checkbox': {
    alignItems: 'center',
    display: 'flex'
  },
  '.manifest-data-table__footer': {
    alignItems: 'center',
    borderTop: '1px solid $border-primary',
    display: 'flex',
    justifyContent: 'space-between',
    minHeight: pxToRem(48),
    px: pxToRem(12),
    '> .manifest-pagination': {
      width: '100%'
    }
  },
  '.manifest-table': {
    borderCollapse: 'separate',
    borderSpacing: 0,
    display: 'table',
    width: '100%',
    '&__cell': {
      borderBottom: '1px solid $border-primary',
      display: 'table-cell',
      fontSize: '$small',
      fontWeight: '$regular',
      lineHeight: '$small',
      padding: `${pxToRem(6)} ${pxToRem(12)}`,
      textAlign: 'left',
      verticalAlign: 'inherit',
      '&--pinned': {
        backgroundColor: '$$tableBackgroundColor',
        position: 'sticky',
        zIndex: 1
      }
    },
    '&__cell--header': {
      fontSize: '$x-small',
      fontWeight: '$semibold',
      lineHeight: '$x-small',
      '&.manifest-table__cell--pinned': {
        zIndex: 2
      }
    },
    '&__cell--sticky-header': {
      backgroundColor: '$$tableBackgroundColor',
      position: 'sticky',
      top: 0,
      zIndex: 1
    },
    '&__header': {
      display: 'table-row-group'
    },
    '&__row': {
      color: 'inherit',
      display: 'table-row',
      verticalAlign: 'middle',
      outline: 0
    }
  },
  '.manifest-table__heading': {
    appearance: 'none',
    alignItems: 'center',
    background: 'none',
    border: 'none',
    borderRadius: '$small',
    color: 'inherit',
    cursor: 'pointer',
    display: 'inline-flex',
    fontSize: 'inherit',
    gap: '$small',
    lineHeight: 'inherit',
    mx: '-$x-small',
    padding: `$x-small ${pxToRem(6)}`,
    '&:hover': {
      backgroundColor: '$background-secondary'
    }
  }
});
function DataTable(props) {
  const dataProp = props.data,
    _props$defaultColumn = props.defaultColumn,
    defaultColumn = _props$defaultColumn === void 0 ? {
      minSize: 40,
      maxSize: 1000,
      size: 180
    } : _props$defaultColumn,
    columnsProp = props.columns,
    _props$enableExpandAl = props.enableExpandAll,
    enableExpandAll = _props$enableExpandAl === void 0 ? true : _props$enableExpandAl,
    _props$enableExpandin = props.enableExpanding,
    enableExpanding = _props$enableExpandin === void 0 ? false : _props$enableExpandin,
    _props$enableMultiRow = props.enableMultiRowSelection,
    enableMultiRowSelection = _props$enableMultiRow === void 0 ? true : _props$enableMultiRow,
    _props$enablePaginati = props.enablePagination,
    enablePagination = _props$enablePaginati === void 0 ? true : _props$enablePaginati,
    _props$enablePinning = props.enablePinning,
    enablePinning = _props$enablePinning === void 0 ? false : _props$enablePinning,
    _props$enableRowSelec = props.enableRowSelection,
    enableRowSelection = _props$enableRowSelec === void 0 ? false : _props$enableRowSelec,
    _props$enableSelectAl = props.enableSelectAll,
    enableSelectAll = _props$enableSelectAl === void 0 ? true : _props$enableSelectAl,
    _props$enableSorting = props.enableSorting,
    enableSorting = _props$enableSorting === void 0 ? true : _props$enableSorting,
    _props$enableStickyHe = props.enableStickyHeader,
    enableStickyHeader = _props$enableStickyHe === void 0 ? false : _props$enableStickyHe,
    _props$expandAllButto = props.expandAllButtonProps,
    expandAllButtonProps = _props$expandAllButto === void 0 ? {} : _props$expandAllButto,
    _props$expandButtonPr = props.expandButtonProps,
    expandButtonProps = _props$expandButtonPr === void 0 ? {} : _props$expandButtonPr,
    initialState = props.initialState,
    isLoading = props.isLoading,
    manualExpanding = props.manualExpanding,
    manualPaginationProp = props.manualPagination,
    manualSorting = props.manualSorting,
    pageCount = props.pageCount,
    _props$paginationProp = props.paginationProps,
    paginationProps = _props$paginationProp === void 0 ? {} : _props$paginationProp,
    _props$selectAllCheck = props.selectAllCheckboxProps,
    selectAllCheckboxProps = _props$selectAllCheck === void 0 ? {} : _props$selectAllCheck,
    _props$selectCheckbox = props.selectCheckboxProps,
    selectCheckboxProps = _props$selectCheckbox === void 0 ? {} : _props$selectCheckbox,
    rowCount = props.rowCount,
    state = props.state,
    onExpandedChange = props.onExpandedChange,
    onPaginationChange = props.onPaginationChange,
    onRowSelectionChange = props.onRowSelectionChange,
    onSortingChange = props.onSortingChange,
    other = _objectWithoutProperties(props, _excluded35);
  let manualPagination = manualPaginationProp;
  if (!enablePagination && manualPagination === undefined) {
    manualPagination = true;
  }
  const columns = React.useMemo(() => [enableExpanding && {
    id: 'manifest-data-table-row-expand',
    // eslint-disable-next-line react/no-unstable-nested-components
    header: ({
      table
    }) => enableExpandAll && /*#__PURE__*/jsx(DataTableExpandAllButton, {
      table: table
    }),
    // eslint-disable-next-line react/no-unstable-nested-components
    cell: ({
      row,
      table
    }) => /*#__PURE__*/jsx(DataTableExpandButton, {
      row: row,
      table: table
    }),
    size: 40
  }, enableRowSelection && {
    id: 'manifest-data-table-row-select',
    // eslint-disable-next-line react/no-unstable-nested-components
    header: ({
      table
    }) => enableSelectAll && /*#__PURE__*/jsx(DataTableCheckbox, {
      table: table
    }),
    // eslint-disable-next-line react/no-unstable-nested-components
    cell: ({
      row,
      table
    }) => /*#__PURE__*/jsx(DataTableCheckbox, {
      row: row,
      table: table
    }),
    size: 40
  }, ...columnsProp].filter(Boolean), [columnsProp, enableExpandAll, enableExpanding, enableRowSelection, enableSelectAll]);
  const data = React.useMemo(() => isLoading && !dataProp.length ? [...Array.from({
    length: state?.pagination?.pageSize || initialState?.pagination?.pageSize || 10
  }).fill(null)] : dataProp, [dataProp, initialState?.pagination?.pageSize, state?.pagination?.pageSize, isLoading]);
  const table = useReactTable(_objectSpread(_objectSpread(_objectSpread({
    columns,
    data,
    defaultColumn,
    enableExpandAll,
    enableExpanding,
    enablePinning,
    enableMultiRowSelection,
    enableRowSelection,
    enableSelectAll,
    enableSorting,
    enableStickyHeader,
    expandAllButtonProps,
    expandButtonProps,
    getCoreRowModel: getCoreRowModel(),
    getExpandedRowModel: getExpandedRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getSubRows: row => row?.subRows,
    initialState,
    isLoading,
    manualExpanding,
    manualPagination,
    manualSorting,
    paginationProps,
    rowCount,
    selectAllCheckboxProps,
    selectCheckboxProps,
    state
  }, manualExpanding && {
    onExpandedChange
  }), manualPagination && {
    onPaginationChange
  }), manualSorting && {
    onSortingChange
  }));
  return /*#__PURE__*/jsxs(StyledDataTable, _objectSpread(_objectSpread({
    className: "manifest-data-table"
  }, other), {}, {
    children: [/*#__PURE__*/jsx("div", {
      className: cx('manifest-data-table__container', {
        'manifest-data-table__container--sticky-header': !!enableStickyHeader
      }),
      children: /*#__PURE__*/jsxs("table", {
        className: "manifest-table",
        children: [/*#__PURE__*/jsx(DataTableHeader, {
          table: table
        }), /*#__PURE__*/jsx(DataTableBody, {
          table: table
        })]
      })
    }), /*#__PURE__*/jsx(DataTablePagination, _objectSpread({
      table: table
    }, paginationProps))]
  }));
}
const useStyles$d = css({
  $$backgroundColor: '$colors$background-primary',
  $$borderColor: '$colors$palette-grey-500',
  $$iconColor: '$colors$text-tertiary',
  $$textColor: '$colors$text-tertiary',
  '.manifest-datepicker__wrapper': {
    display: 'flex',
    minWidth: pxToRem(48),
    position: 'relative',
    width: '100%'
  },
  '.manifest-datepicker__icon': {
    alignItems: 'center',
    color: '$$iconColor',
    display: 'inline-flex',
    justifyContent: 'center',
    padding: '$small',
    pointerEvents: 'none',
    position: 'absolute',
    top: 0,
    zIndex: 2
  },
  '.manifest-datepicker__icon--end': {
    right: 0
  },
  '.manifest-datepicker__icon--start': {
    left: 0
  },
  '.manifest-datepicker__input': {
    appearance: 'none',
    backgroundColor: '$$backgroundColor',
    border: '1px solid $$borderColor',
    borderRadius: '$small',
    boxSizing: 'border-box',
    color: '$$textColor',
    cursor: 'default',
    margin: 0,
    outline: 0,
    padding: '0 $small',
    paddingRight: pxToRem(40),
    textAlign: 'start',
    width: '100%'
  },
  '.manifest-datepicker__text': {
    color: '$text-tertiary'
  },
  variants: {
    hasStartIcon: {
      true: {
        '.manifest-datepicker__input': {
          paddingLeft: pxToRem(40)
        }
      }
    },
    isActive: {
      true: {
        $$borderColor: '$colors$primary-active',
        $$iconColor: '$colors$text-secondary',
        $$textColor: '$colors$text-primary'
      }
    },
    isDisabled: {
      true: {
        $$backgroundColor: '$colors$palette-grey-50',
        $$textColor: '$colors$text-disabled',
        '.manifest-datepicker__input': {
          cursor: 'not-allowed'
        }
      }
    },
    isFocused: {
      true: {
        $$borderColor: '$colors$primary-active',
        $$iconColor: '$colors$text-secondary',
        $$textColor: '$colors$text-primary'
      }
    },
    isFocusVisible: {
      true: {
        '.manifest-datepicker__wrapper': {
          '&:after': {
            backgroundColor: 'transparent',
            border: '2px solid $colors$palette-indigo-200',
            // TODO: replace with design token once its defined.s
            borderRadius: '4px',
            bottom: '-3px',
            content: '',
            display: 'block',
            left: '-3px',
            position: 'absolute',
            right: '-3px',
            top: '-3px'
          }
        }
      }
    },
    isHovered: {
      true: {
        $$borderColor: '$colors$palette-grey-600'
      }
    },
    isInvalid: {
      true: {
        $$borderColor: '$colors$border-danger',
        $$iconColor: '$colors$text-danger',
        $$textColor: '$colors$text-danger'
      }
    },
    isPlaceholder: {
      true: {
        $$textColor: '$colors$text-tertiary'
      }
    },
    size: {
      medium: {
        '.manifest-datepicker__icon': {
          fontSize: '$x-large',
          size: pxToRem(40),
          '> .material-icons': {
            fontSize: '$x-large'
          }
        },
        '.manifest-datepicker__input': {
          height: pxToRem(40)
        }
      },
      small: {
        '.manifest-datepicker__icon': {
          fontSize: pxToRem(18),
          size: pxToRem(34),
          '> .material-icons': {
            fontSize: pxToRem(18)
          }
        },
        '.manifest-datepicker__input': {
          height: pxToRem(34)
        }
      }
    }
  },
  defaultVariants: {
    size: 'medium'
  }
});
const DatePicker = createComponent((props, forwardedRef) => {
  const _props$as10 = props.as,
    Comp = _props$as10 === void 0 ? 'div' : _props$as10,
    autoFocus = props.autoFocus,
    classNameProp = props.className,
    containerRefProp = props.containerRef,
    css = props.css,
    helperText = props.helperText,
    _props$helperTextProp3 = props.helperTextProps,
    helperTextProps = _props$helperTextProp3 === void 0 ? {} : _props$helperTextProp3,
    isDisabled = props.isDisabled,
    isReadOnly = props.isReadOnly,
    isRequired = props.isRequired,
    label = props.label,
    _props$labelProps3 = props.labelProps,
    labelPropsProp = _props$labelProps3 === void 0 ? {} : _props$labelProps3,
    _props$offset3 = props.offset,
    offset = _props$offset3 === void 0 ? 4 : _props$offset3,
    placeholder = props.placeholder,
    _props$placement3 = props.placement,
    placement = _props$placement3 === void 0 ? 'bottom start' : _props$placement3,
    _props$shouldFlip3 = props.shouldFlip,
    shouldFlip = _props$shouldFlip3 === void 0 ? true : _props$shouldFlip3,
    size = props.size,
    startIcon = props.startIcon,
    validationState = props.validationState;
  const state = useDatePickerState(props);
  const containerRef = React.useRef(null);
  const triggerRef = React.useRef(null);
  const popoverRef = React.useRef(null);
  const _useDatePicker = useDatePicker(props, state, triggerRef),
    groupProps = _useDatePicker.groupProps,
    labelProps = _useDatePicker.labelProps,
    triggerProps = _useDatePicker.buttonProps,
    dialogProps = _useDatePicker.dialogProps,
    calendarProps = _useDatePicker.calendarProps,
    descriptionProps = _useDatePicker.descriptionProps,
    errorMessageProps = _useDatePicker.errorMessageProps;
  const _useOverlayPosition3 = useOverlayPosition({
      isOpen: state.isOpen,
      offset,
      onClose: () => void state.setOpen(false),
      overlayRef: popoverRef,
      placement,
      shouldFlip,
      targetRef: containerRef
    }),
    overlayProps = _useOverlayPosition3.overlayProps;
  const isInvalid = validationState === 'invalid';
  const _useButton4 = useButton(_objectSpread(_objectSpread({}, triggerProps), {}, {
      isDisabled
    }), triggerRef),
    buttonProps = _useButton4.buttonProps,
    isPressed = _useButton4.isPressed;
  const _useFocusRing6 = useFocusRing({
      autoFocus
    }),
    isFocused = _useFocusRing6.isFocused,
    isFocusVisible = _useFocusRing6.isFocusVisible,
    focusProps = _useFocusRing6.focusProps;
  const _useHover7 = useHover({
      isDisabled
    }),
    hoverProps = _useHover7.hoverProps,
    isHovered = _useHover7.isHovered;
  const _useStyles$d = useStyles$d({
      hasStartIcon: Boolean(startIcon),
      isActive: state.isOpen,
      isDisabled,
      isFocused,
      isFocusVisible,
      isHovered,
      isInvalid,
      isPlaceholder: !state.value,
      isPressed,
      isReadOnly,
      size,
      css
    }),
    className = _useStyles$d.className;
  const handleClose = React.useCallback(() => void state.setOpen(false), [state]);
  const classes = cx(className, classNameProp, {
    'manifest-datepicker': true,
    'manifest-datepicker--disabled': isDisabled,
    'manifest-datepicker--invalid': isInvalid,
    [`manifest-datepicker--${size}`]: size
  });
  const displayValue = state.value ? `${new Date(state.value.year, state.value.month - 1, state.value.day).toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  })}` : placeholder;
  return /*#__PURE__*/jsx(FormControl, {
    className: classes,
    helperText: helperText,
    helperTextProps: mergeProps$1(descriptionProps, errorMessageProps, helperTextProps),
    isRequired: isRequired,
    label: label,
    labelProps: mergeProps$1(labelProps, labelPropsProp),
    validationState: validationState,
    children: /*#__PURE__*/jsxs(Comp, _objectSpread(_objectSpread({}, groupProps), {}, {
      ref: mergeRefs$1(containerRef, forwardedRef),
      className: "manifest-datepicker__wrapper",
      children: [startIcon && /*#__PURE__*/jsx("span", {
        className: cx('manifest-datepicker__icon', 'manifest-datepicker__icon--start'),
        children: startIcon
      }), /*#__PURE__*/jsx("button", _objectSpread(_objectSpread({}, mergeProps$1(buttonProps, focusProps, hoverProps)), {}, {
        ref: triggerRef,
        className: "manifest-datepicker__input",
        children: /*#__PURE__*/jsx(Typography, {
          variant: "subtext",
          children: displayValue
        })
      })), /*#__PURE__*/jsx("span", {
        className: cx('manifest-datepicker__icon', 'manifest-datepicker__icon--end'),
        children: /*#__PURE__*/jsx(Calendar$1, {})
      }), /*#__PURE__*/jsx(Overlay, {
        containerRef: containerRefProp,
        isOpen: state.isOpen,
        children: /*#__PURE__*/jsx(Popover, _objectSpread(_objectSpread({}, mergeProps$1(dialogProps, overlayProps)), {}, {
          ref: popoverRef,
          className: "manifest-datepicker__popover",
          isOpen: state.isOpen,
          onClose: handleClose,
          children: /*#__PURE__*/jsx(Calendar, _objectSpread({
            className: "manifest-datepicker__calendar"
          }, calendarProps))
        }))
      })]
    }))
  });
});
const DateRangePicker = createComponent((props, forwardedRef) => {
  const _props$as11 = props.as,
    Comp = _props$as11 === void 0 ? 'div' : _props$as11,
    autoFocus = props.autoFocus,
    classNameProp = props.className,
    containerRefProp = props.containerRef,
    css = props.css,
    helperText = props.helperText,
    _props$helperTextProp4 = props.helperTextProps,
    helperTextProps = _props$helperTextProp4 === void 0 ? {} : _props$helperTextProp4,
    isDisabled = props.isDisabled,
    isReadOnly = props.isReadOnly,
    isRequired = props.isRequired,
    ranges = props.ranges,
    _props$showCalendar = props.showCalendar,
    showCalendar = _props$showCalendar === void 0 ? true : _props$showCalendar,
    _props$showRanges = props.showRanges,
    showRanges = _props$showRanges === void 0 ? false : _props$showRanges,
    label = props.label,
    _props$labelProps4 = props.labelProps,
    labelPropsProp = _props$labelProps4 === void 0 ? {} : _props$labelProps4,
    _props$offset4 = props.offset,
    offset = _props$offset4 === void 0 ? 4 : _props$offset4,
    placeholder = props.placeholder,
    _props$placement4 = props.placement,
    placement = _props$placement4 === void 0 ? 'bottom start' : _props$placement4,
    _props$shouldFlip4 = props.shouldFlip,
    shouldFlip = _props$shouldFlip4 === void 0 ? true : _props$shouldFlip4,
    size = props.size,
    startIcon = props.startIcon,
    validationState = props.validationState;
  const state = useDateRangePickerState(props);
  const containerRef = React.useRef(null);
  const triggerRef = React.useRef(null);
  const popoverRef = React.useRef(null);
  const _useDateRangePicker = useDateRangePicker(props, state, triggerRef),
    groupProps = _useDateRangePicker.groupProps,
    labelProps = _useDateRangePicker.labelProps,
    triggerProps = _useDateRangePicker.buttonProps,
    dialogProps = _useDateRangePicker.dialogProps,
    calendarProps = _useDateRangePicker.calendarProps,
    descriptionProps = _useDateRangePicker.descriptionProps,
    errorMessageProps = _useDateRangePicker.errorMessageProps;
  const _useOverlayPosition4 = useOverlayPosition({
      isOpen: state.isOpen,
      offset,
      onClose: () => void state.setOpen(false),
      overlayRef: popoverRef,
      placement,
      shouldFlip,
      targetRef: containerRef
    }),
    overlayProps = _useOverlayPosition4.overlayProps;
  const isInvalid = validationState === 'invalid';
  const _useButton5 = useButton(_objectSpread(_objectSpread({}, triggerProps), {}, {
      isDisabled
    }), triggerRef),
    buttonProps = _useButton5.buttonProps,
    isPressed = _useButton5.isPressed;
  const _useFocusRing7 = useFocusRing({
      autoFocus
    }),
    isFocused = _useFocusRing7.isFocused,
    isFocusVisible = _useFocusRing7.isFocusVisible,
    focusProps = _useFocusRing7.focusProps;
  const _useHover8 = useHover({
      isDisabled
    }),
    hoverProps = _useHover8.hoverProps,
    isHovered = _useHover8.isHovered;
  const handleClose = React.useCallback(() => void state.setOpen(false), [state]);
  const _useStyles$d2 = useStyles$d({
      hasStartIcon: Boolean(startIcon),
      isActive: state.isOpen,
      isDisabled,
      isFocused,
      isFocusVisible,
      isHovered,
      isInvalid,
      isPlaceholder: !state.value,
      isPressed,
      isReadOnly,
      size,
      css
    }),
    className = _useStyles$d2.className;
  const classes = cx(className, classNameProp, {
    'manifest-datepicker': true,
    'manifest-datepicker--disabled': isDisabled,
    'manifest-datepicker--invalid': isInvalid,
    [`manifest-datepicker--${size}`]: size
  });
  const getDisplayValue = () => {
    const _state$value = state.value,
      start = _state$value.start,
      end = _state$value.end;
    const _map = [start, end].map(date => {
        if (!date) {
          return undefined;
        }
        return `${new Date(date.year, date.month - 1, date.day).toLocaleDateString(undefined, {
          month: 'short',
          day: 'numeric',
          year: 'numeric'
        })}`;
      }),
      _map2 = _slicedToArray(_map, 2),
      fromDate = _map2[0],
      toDate = _map2[1];
    return fromDate && toDate ? `${fromDate} - ${toDate}` : placeholder;
  };
  return /*#__PURE__*/jsx(FormControl, {
    className: classes,
    helperText: helperText,
    helperTextProps: mergeProps$1(descriptionProps, errorMessageProps, helperTextProps),
    isRequired: isRequired,
    label: label,
    labelProps: mergeProps$1(labelProps, labelPropsProp),
    validationState: validationState,
    children: /*#__PURE__*/jsxs(Comp, _objectSpread(_objectSpread({}, groupProps), {}, {
      ref: mergeRefs$1(containerRef, forwardedRef),
      className: "manifest-datepicker__wrapper",
      children: [startIcon && /*#__PURE__*/jsx("span", {
        className: cx('manifest-datepicker__icon', 'manifest-datepicker__icon--start'),
        children: startIcon
      }), /*#__PURE__*/jsx("button", _objectSpread(_objectSpread({}, mergeProps$1(buttonProps, focusProps, hoverProps)), {}, {
        ref: triggerRef,
        className: "manifest-datepicker__input",
        children: /*#__PURE__*/jsx(Typography, {
          variant: "subtext",
          children: getDisplayValue()
        })
      })), /*#__PURE__*/jsx("span", {
        className: cx('manifest-datepicker__icon', 'manifest-datepicker__icon--end'),
        children: /*#__PURE__*/jsx(Calendar$1, {})
      }), /*#__PURE__*/jsx(Overlay, {
        containerRef: containerRefProp,
        isOpen: state.isOpen,
        children: /*#__PURE__*/jsx(Popover, _objectSpread(_objectSpread({}, mergeProps$1(dialogProps, overlayProps)), {}, {
          ref: popoverRef,
          className: "manifest-datepicker__popover",
          isOpen: state.isOpen,
          onClose: handleClose,
          children: /*#__PURE__*/jsx(CalendarRange, _objectSpread(_objectSpread({
            className: "manifest-datepicker__calendar"
          }, calendarProps), {}, {
            ranges: ranges,
            showCalendar: showCalendar,
            showRanges: showRanges
          }))
        }))
      })]
    }))
  });
});
const modalStyles = css({
  opacity: 0,
  visibility: 'hidden',
  pointerEvents: 'none',
  transition: 'opacity 200ms ease-in-out, visibility 200ms linear 200ms',
  variants: {
    isOpen: {
      true: {
        opacity: 1,
        visibility: 'visible',
        pointerEvents: 'auto'
      }
    }
  }
});
const StyledModalWrapper = styled('div', {
  position: 'fixed',
  top: 0,
  left: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  boxSizing: 'border-box',
  inlineSize: '100vw',
  height: '100vh',
  visibility: 'hidden',
  pointerEvents: 'none',
  zIndex: 2,
  transition: 'visibilty 200ms linear 200ms',
  variants: {
    isOpen: {
      true: {
        visibility: 'visible'
      }
    }
  }
});
const StyledModal = styled('div', {
  backgroundColor: '$background-surface',
  borderRadius: '$small',
  outline: 'none',
  overflow: 'hidden',
  zIndex: 2
}, modalStyles);
const StyledUnderlay = styled('div', {
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  top: 0,
  overflow: 'hidden',
  zIndex: 1,
  // TODO: update once we have opacity tokens
  backgroundColor: 'rgba(9, 21, 33, 0.2)'
}, modalStyles);

/**
 * Modal implementation; Need to initialize the overlay component before calling
 * any modal related hooks to ensure focus states are managed correctly.
 *
 * @private
 */
const ModalImpl = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const as = props.as,
    children = props.children,
    classNameProp = props.className,
    css = props.css,
    isDismissable = props.isDismissable,
    isKeyboardDismissDisabled = props.isKeyboardDismissDisabled,
    isOpen = props.isOpen,
    onClose = props.onClose,
    other = _objectWithoutProperties(props, _excluded36);
  const overlayRef = React.useRef(null);
  const mergedRef = useMergedRef(overlayRef, forwardedRef);
  const _useOverlay2 = useOverlay({
      isDismissable,
      isKeyboardDismissDisabled,
      isOpen,
      onClose
    }, overlayRef),
    overlayProps = _useOverlay2.overlayProps,
    underlayProps = _useOverlay2.underlayProps;
  const className = cx('manifest-modal', classNameProp, {
    'manifest-modal--open': isOpen
  });
  usePreventScroll({
    isDisabled: !isOpen
  });
  useOverlayFocusContain();
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(StyledUnderlay, _objectSpread(_objectSpread({}, underlayProps), {}, {
      className: "manifest-underlay",
      isOpen: isOpen
    })), /*#__PURE__*/jsx(StyledModalWrapper, {
      className: "manifest-modal-wrapper",
      isOpen: isOpen,
      children: /*#__PURE__*/jsx(StyledModal, _objectSpread(_objectSpread({}, mergeProps(overlayProps, other)), {}, {
        ref: mergedRef,
        as: as,
        className: className,
        css: css,
        isOpen: isOpen,
        children: children
      }))
    })]
  });
});
const Modal = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const isOpen = props.isOpen,
    other = _objectWithoutProperties(props, _excluded37);
  return /*#__PURE__*/jsx(Overlay, {
    isOpen: isOpen,
    children: /*#__PURE__*/jsx(ModalImpl, _objectSpread(_objectSpread({}, other), {}, {
      ref: forwardedRef,
      isOpen: isOpen
    }))
  });
});
const _createContext3 = createContext({
    name: 'DialogContext'
  }),
  _createContext4 = _slicedToArray(_createContext3, 2),
  DialogProvider = _createContext4[0],
  useDialogContext = _createContext4[1];
const StyledDialog = styled('div', {
  backgroundColor: '$background-primary',
  borderRadius: '$small',
  boxShadow: '$small',
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  maxHeight: `calc(100% - ${pxToRem(52)})`,
  maxWidth: pxToRem(442),
  outline: 0,
  padding: '$large',
  position: 'relative'
});

/**
 * Dialog implementation; Need to initialize the modal component before calling
 * any dialog related hooks to ensure focus states are managed correctly.
 *
 * @private
 */
const DialogImpl = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const as = props.as,
    children = props.children,
    classNameProp = props.className,
    css = props.css,
    isDismissable = props.isDismissable,
    onClose = props.onClose,
    _props$role = props.role,
    role = _props$role === void 0 ? 'dialog' : _props$role,
    other = _objectWithoutProperties(props, _excluded38);
  const dialogRef = React.useRef(null);
  const mergedRef = useMergedRef(dialogRef, forwardedRef);
  const _useDialog = useDialog({
      role
    }, dialogRef),
    dialogProps = _useDialog.dialogProps,
    titleProps = _useDialog.titleProps;
  const context = React.useMemo(() => ({
    isDismissable,
    titleProps,
    onClose
  }), [isDismissable, onClose, titleProps]);
  const className = cx('manifest-dialog', classNameProp);
  return /*#__PURE__*/jsx(DialogProvider, {
    value: context,
    children: /*#__PURE__*/jsx(StyledDialog, _objectSpread(_objectSpread({}, mergeProps(dialogProps, other)), {}, {
      ref: mergedRef,
      as: as,
      className: className,
      css: css,
      children: children
    }))
  });
});
const Dialog = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const _props$isDismissable2 = props.isDismissable,
    isDismissable = _props$isDismissable2 === void 0 ? true : _props$isDismissable2,
    _props$isKeyboardDism2 = props.isKeyboardDismissDisabled,
    isKeyboardDismissDisabled = _props$isKeyboardDism2 === void 0 ? false : _props$isKeyboardDism2,
    isOpen = props.isOpen,
    onClose = props.onClose,
    other = _objectWithoutProperties(props, _excluded39);
  return /*#__PURE__*/jsx(Modal, {
    isDismissable: isDismissable,
    isKeyboardDismissDisabled: isKeyboardDismissDisabled,
    isOpen: isOpen,
    onClose: onClose,
    children: /*#__PURE__*/jsx(DialogImpl, _objectSpread(_objectSpread({}, other), {}, {
      isDismissable: isDismissable,
      onClose: onClose
    }))
  });
});
const StyledDialogContent = styled('div', {
  flex: '1 1 auto',
  py: '$medium'
});
const DialogContent = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const as = props.as,
    children = props.children,
    classNameProp = props.className,
    css = props.css,
    other = _objectWithoutProperties(props, _excluded40);
  const className = cx('manifest-dialog-content', classNameProp);
  return /*#__PURE__*/jsx(StyledDialogContent, _objectSpread(_objectSpread({}, other), {}, {
    ref: forwardedRef,
    as: as,
    className: className,
    css: css,
    children: children
  }));
});
const StyledDialogFooter = styled('div', {
  alignItems: 'center',
  borderTop: '1px solid $border-primary',
  display: 'flex',
  flex: '0 0 auto',
  justifyContent: 'flex-end',
  pt: '$medium'
});
const DialogFooter = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const as = props.as,
    children = props.children,
    classNameProp = props.className,
    css = props.css,
    _props$buttonGroupPro = props.buttonGroupProps,
    buttonGroupProps = _props$buttonGroupPro === void 0 ? {} : _props$buttonGroupPro,
    other = _objectWithoutProperties(props, _excluded41);
  const className = cx('manifest-dialog-footer', classNameProp);
  return /*#__PURE__*/jsx(StyledDialogFooter, _objectSpread(_objectSpread({}, other), {}, {
    ref: forwardedRef,
    as: as,
    className: className,
    css: css,
    children: /*#__PURE__*/jsx(ButtonGroup, _objectSpread(_objectSpread({
      className: "manifest-dialog-footer__button-group"
    }, buttonGroupProps), {}, {
      children: children
    }))
  }));
});
const StyledDialogHeader = styled('div', {
  alignItems: 'center',
  borderBottom: '1px solid $border-primary',
  display: 'flex',
  justifyContent: 'space-between',
  paddingBottom: '$medium',
  position: 'relative'
});
const StyledButton = styled(IconButton, {
  position: 'absolute',
  right: 0,
  top: -4
});
const DialogHeader = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const as = props.as,
    _props$buttonProps = props.buttonProps,
    buttonProps = _props$buttonProps === void 0 ? {} : _props$buttonProps,
    children = props.children,
    classNameProp = props.className,
    css = props.css,
    _props$typographyProp = props.typographyProps,
    typographyProps = _props$typographyProp === void 0 ? {} : _props$typographyProp,
    other = _objectWithoutProperties(props, _excluded42);
  const _useDialogContext = useDialogContext(),
    isDismissable = _useDialogContext.isDismissable,
    onClose = _useDialogContext.onClose,
    titleProps = _useDialogContext.titleProps;
  const className = cx('manifest-dialog-header', classNameProp);
  return /*#__PURE__*/jsxs(StyledDialogHeader, _objectSpread(_objectSpread({}, other), {}, {
    ref: forwardedRef,
    as: as,
    className: className,
    css: css,
    children: [/*#__PURE__*/jsx(Typography, _objectSpread(_objectSpread({
      className: "manifest-dialog-header__typography",
      role: "heading",
      variant: "title"
    }, mergeProps(titleProps, typographyProps)), {}, {
      children: children
    })), isDismissable && /*#__PURE__*/jsx(StyledButton, _objectSpread(_objectSpread({
      className: "manifest-dialog-header__button",
      variant: "tertiary",
      onPress: onClose
    }, buttonProps), {}, {
      children: /*#__PURE__*/jsx(Close, {})
    }))]
  }));
});
const _createContext5 = createContext({
    name: 'DropdownContext'
  }),
  _createContext6 = _slicedToArray(_createContext5, 2),
  DropdownProvider = _createContext6[0],
  useDropdownContext = _createContext6[1];
function Dropdown(props) {
  const defaultOpen = props.defaultOpen,
    children = props.children,
    closeOnSelect = props.closeOnSelect,
    isOpen = props.isOpen,
    _props$offset5 = props.offset,
    offset = _props$offset5 === void 0 ? 4 : _props$offset5,
    _props$placement5 = props.placement,
    placement = _props$placement5 === void 0 ? 'bottom start' : _props$placement5,
    shouldFlip = props.shouldFlip,
    onOpenChange = props.onOpenChange,
    _props$trigger = props.trigger,
    trigger = _props$trigger === void 0 ? 'press' : _props$trigger,
    _props$type3 = props.type,
    type = _props$type3 === void 0 ? 'menu' : _props$type3,
    other = _objectWithoutProperties(props, _excluded43);
  const triggerRef = React.useRef(null);
  const menuRef = React.useRef(null);
  const popoverRef = React.useRef(null);
  const _React$Children$toArr = React.Children.toArray(children),
    _React$Children$toArr2 = _slicedToArray(_React$Children$toArr, 2),
    menuTrigger = _React$Children$toArr2[0],
    menu = _React$Children$toArr2[1];
  const state = useMenuTriggerState({
    defaultOpen,
    isOpen,
    onOpenChange,
    closeOnSelect,
    shouldFlip,
    trigger
  });
  const _useMenuTrigger2 = useMenuTrigger({
      trigger,
      type
    }, state, triggerRef),
    menuTriggerProps = _useMenuTrigger2.menuTriggerProps,
    menuProps = _useMenuTrigger2.menuProps;
  const _useOverlayPosition5 = useOverlayPosition({
      isOpen: state.isOpen,
      offset,
      onClose: state.close,
      overlayRef: popoverRef,
      placement,
      shouldFlip,
      targetRef: triggerRef
    }),
    overlayProps = _useOverlayPosition5.overlayProps;
  const handleClose = React.useCallback(() => void state.close(), [state]);
  const context = React.useMemo(() => ({
    closeOnSelect,
    menuProps: mergeProps(menuProps, {
      autoFocus: state.focusStrategy || true
    }),
    menuRef,
    onClose: handleClose
  }), [closeOnSelect, handleClose, menuProps, menuRef, state.focusStrategy]);
  return /*#__PURE__*/jsxs(DropdownProvider, {
    value: context,
    children: [/*#__PURE__*/React.cloneElement(menuTrigger, _objectSpread(_objectSpread({}, menuTriggerProps), {}, {
      ref:
      // eslint does not like accessing children refs
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
      mergeRefs(triggerRef, menuTrigger.ref)
    })), /*#__PURE__*/jsx(Overlay, {
      isOpen: state.isOpen,
      children: /*#__PURE__*/jsx(Popover, _objectSpread(_objectSpread({}, mergeProps(overlayProps, other)), {}, {
        ref: popoverRef,
        isOpen: state.isOpen,
        onClose: handleClose,
        children: menu
      }))
    })]
  });
}
const StyledDropdownItem = styled('li', {
  $$backgroundColor: 'transparent',
  alignItems: 'center',
  backgroundColor: '$$backgroundColor',
  borderRadius: '$small',
  boxSizing: 'border-box',
  color: '$text-primary',
  cursor: 'default',
  display: 'flex',
  height: pxToRem(32),
  outline: 'none',
  padding: '$x-small $small',
  position: 'relative',
  '&.manifest-dropdown-item--selectable': {
    paddingRight: '$x-large'
  },
  '&.manifest-dropdown-item--selected': {
    '.manifest-dropdown-item__icon--end': {
      display: 'inline-flex'
    }
  },
  '.manifest-dropdown-item__icon': {
    alignSelf: 'center',
    color: '$text-secondary',
    display: 'inline-flex',
    flexShrink: 0
  },
  '.manifest-dropdown-item__icon--end': {
    display: 'none',
    color: '$primary-default',
    right: pxToRem(8),
    position: 'absolute',
    top: pxToRem(8)
  },
  '.manifest-dropdown-item__icon--start': {
    marginRight: '$small'
  },
  '.manifest-dropdown-item__text': {
    display: 'block',
    flex: '1 1 0%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  variants: {
    isDisabled: {
      true: {
        cursor: 'not-allowed',
        pointerEvents: 'none',
        opacity: 0.57
      }
    },
    isFocused: {
      true: {
        $$backgroundColor: '$colors$background-secondary'
      }
    },
    isHovered: {
      true: {
        $$backgroundColor: '$colors$background-secondary'
      }
    },
    isPressed: {
      true: {
        $$backgroundColor: '$colors$background-secondary'
      }
    },
    isSelected: {
      true: {
        $$backgroundColor: '$colors$background-secondary'
      }
    }
  }
});

/** @private */
const DropdownItem$1 = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const as = props.as,
    autoFocus = props.autoFocus,
    classNameProp = props.className,
    css = props.css,
    isVirtualized = props.isVirtualized,
    item = props.item,
    onAction = props.onAction,
    startIconProp = props.startIcon,
    state = props.state;
  const rendered = item.rendered,
    key = item.key;
  const itemProps = item.props;
  const itemRef = React.useRef(null);
  const isFocused = state.selectionManager.focusedKey === item.key;
  const isDisabled = state.disabledKeys.has(key);
  const isSelected = state.selectionManager.isSelected(key);
  const _useDropdownContext = useDropdownContext(),
    onClose = _useDropdownContext.onClose,
    closeOnSelect = _useDropdownContext.closeOnSelect;
  const _useMenuItem = useMenuItem({
      'aria-label': item['aria-label'],
      closeOnSelect,
      key,
      isDisabled,
      isSelected,
      isVirtualized,
      onAction,
      onClose
    }, state, itemRef),
    menuItemProps = _useMenuItem.menuItemProps,
    labelProps = _useMenuItem.labelProps;
  const _useFocusRing8 = useFocusRing({
      autoFocus
    }),
    focusProps = _useFocusRing8.focusProps;
  const _useHover9 = useHover({
      isDisabled
    }),
    hoverProps = _useHover9.hoverProps,
    isHovered = _useHover9.isHovered;
  const _usePress2 = usePress({
      isDisabled,
      ref: itemRef
    }),
    pressProps = _usePress2.pressProps,
    isPressed = _usePress2.isPressed;
  const startIcon = React.useMemo(() => startIconProp ?? itemProps.startIcon, [startIconProp, itemProps.startIcon]);
  const children = typeof rendered === 'string' ? /*#__PURE__*/jsx(Typography, _objectSpread(_objectSpread({}, labelProps), {}, {
    className: "manifest-dropdown-item__text",
    variant: "subtext",
    children: rendered
  })) : rendered;
  const classes = cx('manifest-dropdown-item', classNameProp, itemProps.className, {
    'manifest-dropdown-item': true,
    'manifest-dropdown-item--disabled': isDisabled,
    'manifest-dropdown-item--selected': isSelected,
    'manifest-dropdown-item--selectable': state.selectionManager.selectionMode !== 'none'
  });
  return /*#__PURE__*/jsxs(StyledDropdownItem, _objectSpread(_objectSpread({}, mergeProps(menuItemProps, pressProps, focusProps, hoverProps)), {}, {
    ref: mergeRefs(itemRef, forwardedRef),
    as: as,
    className: classes,
    css: _objectSpread(_objectSpread({}, css), itemProps.css),
    isDisabled: isDisabled,
    isFocused: isFocused,
    isHovered: isHovered,
    isPressed: isPressed,
    isSelected: isSelected,
    children: [startIcon && /*#__PURE__*/jsx("span", {
      className: cx('manifest-dropdown-item__icon', 'manifest-dropdown-item__icon--start'),
      children: startIcon
    }), children]
  }));
});
const DropdownItem = Item;
const StyledDropdownSection = styled('li', {});
const StyledDropdownSeperator = styled('li', {
  alignSelf: 'stretch',
  backgroundColor: '$border-primary',
  border: 'none',
  borderWidth: '$small',
  height: '1px',
  mx: '-$small',
  my: '$small',
  overflow: 'visible',
  width: 'auto'
});
const StyledDropdownSectionGroup = styled('ul', {
  boxSizing: 'border-box',
  display: 'block',
  listStyleType: 'none',
  margin: 0,
  padding: 0,
  overflow: 'auto',
  userSelect: 'none'
});
const StyledDropdownSectionLabel = styled(Typography, {
  color: '$text-tertiary',
  px: '$x-small'
});

/** @private */
const DropdownSection$1 = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const as = props.as,
    classNameProp = props.className,
    css = props.css,
    item = props.item,
    onAction = props.onAction,
    state = props.state;
  const _useMenuSection = useMenuSection({
      heading: item.rendered,
      'aria-label': item['aria-label']
    }),
    itemProps = _useMenuSection.itemProps,
    headingProps = _useMenuSection.headingProps,
    groupProps = _useMenuSection.groupProps;
  const _useSeparator2 = useSeparator({
      elementType: 'li'
    }),
    separatorProps = _useSeparator2.separatorProps;
  const showSeparator = item.key !== state.collection.getFirstKey();
  return /*#__PURE__*/jsxs(Fragment, {
    children: [showSeparator && /*#__PURE__*/jsx(StyledDropdownSeperator, _objectSpread(_objectSpread({}, separatorProps), {}, {
      className: "manifest-dropdown-separator"
    })), /*#__PURE__*/jsxs(StyledDropdownSection, _objectSpread(_objectSpread({}, itemProps), {}, {
      ref: forwardedRef,
      as: as,
      className: cx('manifest-dropdown-section', classNameProp),
      css: css,
      children: [item.rendered && /*#__PURE__*/jsx(StyledDropdownSectionLabel, _objectSpread(_objectSpread({}, headingProps), {}, {
        className: "manifest-dropdown-section__label",
        variant: "caption",
        children: item.rendered
      })), /*#__PURE__*/jsx(StyledDropdownSectionGroup, _objectSpread(_objectSpread({}, groupProps), {}, {
        className: "manifest-dropdown-section__group",
        children: [...item.childNodes].map(node => /*#__PURE__*/jsx(DropdownItem$1, {
          item: node,
          state: state,
          onAction: onAction
        }, node.key))
      }))]
    }))]
  });
});
const DropdownSection = Section;
const StyledDropdownMenu = styled('ul', {
  boxSizing: 'border-box',
  display: 'inline-block',
  listStyleType: 'none',
  margin: 0,
  padding: '$small',
  outline: 0,
  overflow: 'auto',
  userSelect: 'none',
  '.manifest-dropdown-separator': {
    alignSelf: 'stretch',
    backgroundColor: '$border-primary',
    border: 'none',
    borderWidth: '$small',
    height: '1px',
    mx: '-$small',
    my: '$small',
    overflow: 'visible',
    width: 'auto'
  }
});
const DropdownMenu = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const as = props.as,
    classNameProp = props.className,
    css = props.css,
    other = _objectWithoutProperties(props, _excluded44);
  const _useDropdownContext2 = useDropdownContext(),
    menuRef = _useDropdownContext2.menuRef,
    contextProps = _useDropdownContext2.menuProps;
  const completeProps = React.useMemo(() => _objectSpread({}, mergeProps(contextProps, other)), [contextProps, other]);
  const state = useTreeState(completeProps);
  const _useMenu = useMenu(completeProps, state, menuRef),
    menuProps = _useMenu.menuProps;
  const handleAction = React.useCallback(key => {
    completeProps.onAction?.(key);
  }, [completeProps]);
  return /*#__PURE__*/jsx(StyledDropdownMenu, _objectSpread(_objectSpread({}, menuProps), {}, {
    ref: mergeRefs(menuRef, forwardedRef),
    as: as,
    className: cx('manifest-dropdown', classNameProp),
    css: css,
    children: [...state.collection].map(item => {
      if (item.type === 'section') {
        return /*#__PURE__*/jsx(DropdownSection$1, {
          item: item,
          state: state,
          onAction: handleAction
        }, item.key);
      }
      return /*#__PURE__*/jsx(DropdownItem$1, {
        item: item,
        state: state,
        onAction: handleAction
      }, item.key);
    })
  }));
});
const styles = {
  entered: {
    opacity: 1
  },
  entering: {
    opacity: 1
  },
  exited: {},
  exiting: {},
  unmounted: {}
};
const Fade = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const children = props.children,
    inProp = props.in,
    _props$duration2 = props.duration,
    duration = _props$duration2 === void 0 ? 200 : _props$duration2,
    onEnter = props.onEnter,
    onExit = props.onExit,
    style = props.style,
    _props$timeout3 = props.timeout,
    timeout = _props$timeout3 === void 0 ? 200 : _props$timeout3,
    other = _objectWithoutProperties(props, _excluded45);
  const handleEnter = React.useCallback((node, isAppearing) => {
    reflow(node);
    node.style.transition = `opacity ${duration}ms cubic-bezier(0.4, 0.14, 0.3, 1) 0ms`;
    onEnter?.(node, isAppearing);
  }, [duration, onEnter]);
  const handleExit = React.useCallback(node => {
    node.style.transition = `opacity ${duration}ms cubic-bezier(0.4, 0.14, 0.3, 1) 0ms`;
    onExit?.(node);
  }, [duration, onExit]);
  return /*#__PURE__*/jsx(Transition, _objectSpread(_objectSpread({}, other), {}, {
    ref: forwardedRef,
    in: inProp,
    timeout: timeout,
    onEnter: handleEnter,
    onExit: handleExit,
    children: (status, childrenProps) => /*#__PURE__*/jsx("div", _objectSpread(_objectSpread({}, childrenProps), {}, {
      style: _objectSpread(_objectSpread({
        opacity: 0,
        visibility: status === 'exited' && !inProp ? 'hidden' : undefined
      }, styles[status]), style),
      children: children
    }))
  }));
});
const StyledGrid = styled('div', {
  boxSizing: 'border-box',
  display: 'grid',
  variants: {
    columnGap: {
      large: {
        columnGap: '$large'
      },
      medium: {
        columnGap: '$medium'
      },
      small: {
        columnGap: '$small'
      },
      'x-large': {
        columnGap: '$x-large'
      },
      'x-small': {
        columnGap: '$x-small'
      }
    },
    gap: {
      large: {
        gap: '$large'
      },
      medium: {
        gap: '$medium'
      },
      small: {
        gap: '$small'
      },
      'x-large': {
        gap: '$x-large'
      },
      'x-small': {
        gap: '$x-small'
      }
    },
    rowGap: {
      large: {
        rowGap: '$large'
      },
      medium: {
        rowGap: '$medium'
      },
      small: {
        rowGap: '$small'
      },
      'x-large': {
        rowGap: '$x-large'
      },
      'x-small': {
        rowGap: '$x-small'
      }
    }
  }
});
const StyledGridItem = styled('div', {
  boxSizing: 'border-box'
});
const Grid = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const as = props.as,
    classNameProp = props.className,
    columnGap = props.columnGap,
    _props$columns = props.columns,
    columns = _props$columns === void 0 ? 'auto' : _props$columns,
    css = props.css,
    flow = props.flow,
    gap = props.gap,
    rowGap = props.rowGap,
    _props$rows = props.rows,
    rows = _props$rows === void 0 ? 'auto' : _props$rows,
    other = _objectWithoutProperties(props, _excluded46);
  return /*#__PURE__*/jsx(StyledGrid, _objectSpread(_objectSpread({}, other), {}, {
    ref: forwardedRef,
    as: as,
    className: cx('manifest-grid', classNameProp),
    columnGap: columnGap,
    css: _objectSpread(_objectSpread({}, css), {}, {
      gridAutoFlow: flow,
      gridTemplateColumns: columns,
      gridTemplateRows: rows
    }),
    gap: gap,
    rowGap: rowGap
  }));
});

/* -------------------------------------------------------------------------------------------------
 * GridItem
 * -----------------------------------------------------------------------------------------------*/

const GridItem = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const area = props.area,
    as = props.as,
    classNameProp = props.className,
    css = props.css,
    column = props.column,
    columnEnd = props.columnEnd,
    columnStart = props.columnStart,
    order = props.order,
    row = props.row,
    rowEnd = props.rowEnd,
    rowStart = props.rowStart,
    other = _objectWithoutProperties(props, _excluded47);
  return /*#__PURE__*/jsx(StyledGridItem, _objectSpread(_objectSpread({}, other), {}, {
    ref: forwardedRef,
    as: as,
    className: cx('manifest-grid-item', classNameProp),
    css: _objectSpread(_objectSpread({}, css), {}, {
      gridArea: area,
      gridColumn: typeof column === 'number' ? `span ${column} / span ${column}` : column,
      gridColumnEnd: columnEnd,
      gridColumnStart: columnStart,
      gridRow: typeof row === 'number' ? `span ${row} / span ${row}` : row,
      gridRowEnd: rowEnd,
      gridRowStart: rowStart,
      order
    })
  }));
});
const StyledItem = styled('button', {
  alignItems: 'center',
  appearance: 'none',
  backgroundColor: 'transparent',
  border: 'none',
  borderRadius: '$small',
  boxSizing: 'border-box',
  color: '$palette-indigo-50',
  cursor: 'pointer',
  display: 'inline-flex',
  outline: 'none',
  position: 'relative',
  p: `${pxToRem(6)} ${pxToRem(12)}`,
  typography: '$subtext',
  userSelect: 'none',
  whiteSpace: 'nowrap',
  '&:active': {
    backgroundColor: '$palette-white',
    color: '$text-primary'
  },
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    color: '$text-contrast'
  },
  '&.manifest-local-navigation-item--selected': {
    backgroundColor: '$palette-white',
    color: '$text-primary',
    typography: '$subtext-bold',
    '&:hover, &:active': {
      backgroundColor: '$palette-white',
      color: '$text-primary'
    }
  }
});
const LocalNavigationItem = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const as = props.as,
    autoFocus = props.autoFocus,
    classNameProp = props.className,
    css = props.css,
    isSelected = props.isSelected,
    other = _objectWithoutProperties(props, _excluded48);
  const itemRef = React.useRef(null);
  const _useButton6 = useButton(_objectSpread(_objectSpread({}, props), {}, {
      elementType: typeof as === 'string' ? as : 'button'
    }), itemRef),
    buttonProps = _useButton6.buttonProps,
    isPressed = _useButton6.isPressed;
  const _useFocusRing9 = useFocusRing({
      autoFocus
    }),
    isFocusVisible = _useFocusRing9.isFocusVisible,
    focusProps = _useFocusRing9.focusProps;
  const _useHover10 = useHover({}),
    isHovered = _useHover10.isHovered,
    hoverProps = _useHover10.hoverProps;
  const className = cx('manifest-local-navigation-item', {
    'manifest-local-navigation-item--active': isPressed,
    'manifest-local-navigation-item--hover': isHovered,
    'manifest-local-navigation-item--focus-visible': isFocusVisible,
    'manifest-local-navigation-item--selected': isSelected
  }, classNameProp);
  return /*#__PURE__*/jsx(StyledItem, _objectSpread(_objectSpread({}, mergeProps$1(buttonProps, focusProps, hoverProps, other)), {}, {
    ref: mergeRefs$1(itemRef, forwardedRef),
    as: as,
    className: className,
    css: css
  }));
});
const StyledNavigation$1 = styled('div', {
  alignItems: 'center',
  display: 'flex',
  gap: '$small'
});
const LocalNavigation = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const as = props.as,
    classNameProp = props.className,
    css = props.css,
    other = _objectWithoutProperties(props, _excluded49);
  const className = cx('manifest-local-navigation', classNameProp);
  return /*#__PURE__*/jsx(StyledNavigation$1, _objectSpread(_objectSpread({}, other), {}, {
    ref: forwardedRef,
    as: as,
    className: className,
    css: css
  }));
});
const StyledMenu = styled('ul', {
  listStyle: 'none',
  margin: 0,
  padding: '$medium 0'
});
const Menu = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const as = props.as,
    children = props.children,
    classNameProp = props.className,
    css = props.css,
    other = _objectWithoutProperties(props, _excluded50);
  const className = cx('manifest-menu-header', classNameProp);
  return /*#__PURE__*/jsx(StyledMenu, _objectSpread(_objectSpread({}, other), {}, {
    ref: forwardedRef,
    as: as,
    className: className,
    css: css,
    children: children
  }));
});
const _createContext7 = createContext({
    name: 'MenuGroupContext'
  }),
  _createContext8 = _slicedToArray(_createContext7, 2),
  MenuGroupProvider = _createContext8[0],
  useMenuGroup = _createContext8[1];
const StyledMenuItem$1 = styled('li', {
  boxSizing: 'border-box',
  display: 'block',
  position: 'relative',
  my: pxToRem(2),
  textAlign: 'left',
  textDecoration: 'none',
  width: '100%',
  '.manifest-menu-item__container': {
    alignItems: 'center',
    borderRadius: '$small',
    boxSizing: 'border-box',
    color: '$text-primary',
    cursor: 'pointer',
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'flex-start',
    margin: 0,
    minHeight: pxToRem(36),
    minWidth: 0,
    position: 'relative',
    px: pxToRem(12),
    textAlign: 'left',
    textDecoration: 'none',
    transition: 'background-color 100ms cubic-bezier(0.4, 0.14, 0.3, 1)',
    userSelect: 'none'
  },
  '.manifest-menu-item__label': {
    flex: '1 1 auto',
    minWidth: 0
  },
  '&:hover': {
    '.manifest-menu-item__container': {
      backgroundColor: '$background-secondary'
    }
  },
  variants: {
    isGrouped: {
      true: {
        '.manifest-menu-item__container': {
          color: '$text-secondary',
          paddingLeft: pxToRem(48),
          paddingRight: '$medium'
        }
      }
    },
    isSelected: {
      true: {
        '.manifest-menu-item__container': {
          backgroundColor: '$background-secondary'
        }
      }
    }
  },
  compoundVariants: [{
    isGrouped: true,
    isSelected: true,
    css: {
      color: '$text-primary'
    }
  }]
});
const StyledMenuItemIcon = styled('div', {
  boxSizing: 'border-box',
  display: 'inline-flex',
  flexShrink: 0,
  variants: {
    placement: {
      end: {
        marginLeft: pxToRem(12)
      },
      start: {
        marginRight: pxToRem(12)
      }
    }
  }
});
const MenuItem = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const as = props.as,
    children = props.children,
    classNameProp = props.className,
    css = props.css,
    endIcon = props.endIcon,
    startIcon = props.startIcon,
    label = props.label,
    _props$labelProps5 = props.labelProps,
    labelProps = _props$labelProps5 === void 0 ? {} : _props$labelProps5,
    isSelected = props.isSelected,
    other = _objectWithoutProperties(props, _excluded51);
  const _ref = useMenuGroup() ?? {},
    isGrouped = _ref.isGrouped;
  const className = cx('manifest-menu-item', classNameProp);
  let variant = isGrouped ? 'subtext' : 'subtextBold';
  if (isGrouped && isSelected) {
    variant = 'subtextBold';
  }
  return /*#__PURE__*/jsx(StyledMenuItem$1, _objectSpread(_objectSpread({}, other), {}, {
    ref: forwardedRef,
    as: as,
    className: className,
    css: css,
    isGrouped: isGrouped,
    isSelected: isSelected,
    children: /*#__PURE__*/jsxs("div", {
      className: "manifest-menu-item__container",
      children: [startIcon && /*#__PURE__*/jsx(StyledMenuItemIcon, {
        className: "manifest-menu-item__icon--start",
        placement: "start",
        children: startIcon
      }), /*#__PURE__*/jsx(Typography, _objectSpread(_objectSpread({}, labelProps), {}, {
        className: "manifest-menu-item__label",
        variant: variant,
        children: label
      })), endIcon && /*#__PURE__*/jsx(StyledMenuItemIcon, {
        className: "manifest-menu-item__icon--end",
        placement: "end",
        children: endIcon
      })]
    })
  }));
});
const StyledMenuGroup$1 = styled('div', {
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  width: '100%'
});
const StyledMenuGroupWrapper = styled('div', {
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  width: '100%'
});
const StyledIcon = styled(ChevronDown, {
  color: '$text-secondary',
  transition: 'transform 100ms cubic-bezier(0.4, 0.14, 0.3, 1) 0ms',
  variants: {
    isExpanded: {
      true: {
        color: '$text-primary',
        transform: 'rotate(180deg)'
      }
    }
  }
});
const MenuGroup = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const as = props.as,
    children = props.children,
    classNameProp = props.className,
    css = props.css,
    defaultExpanded = props.defaultExpanded,
    _props$iconProps = props.iconProps,
    iconProps = _props$iconProps === void 0 ? {} : _props$iconProps,
    isExpandedProp = props.isExpanded,
    _props$itemProps = props.itemProps,
    itemProps = _props$itemProps === void 0 ? {} : _props$itemProps,
    label = props.label,
    labelProps = props.labelProps,
    _props$onExpandedChan = props.onExpandedChange,
    onExpandedChange = _props$onExpandedChan === void 0 ? noop : _props$onExpandedChan,
    startIcon = props.startIcon,
    other = _objectWithoutProperties(props, _excluded52);
  const _useControlledState = useControlledState(isExpandedProp, defaultExpanded ?? false, onExpandedChange),
    _useControlledState2 = _slicedToArray(_useControlledState, 2),
    isExpanded = _useControlledState2[0],
    setExpanded = _useControlledState2[1];
  const handleExpand = React.useCallback(() => {
    setExpanded(!isExpanded);
  }, [isExpanded, setExpanded]);
  const className = cx('manifest-menu-group', classNameProp);
  return /*#__PURE__*/jsxs(StyledMenuGroup$1, _objectSpread(_objectSpread({}, other), {}, {
    ref: forwardedRef,
    as: as,
    className: className,
    css: css,
    children: [/*#__PURE__*/jsx(MenuItem, _objectSpread(_objectSpread({}, itemProps), {}, {
      endIcon: /*#__PURE__*/jsx(StyledIcon, _objectSpread(_objectSpread({}, iconProps), {}, {
        isExpanded: isExpanded
      })),
      label: label,
      labelProps: labelProps,
      startIcon: startIcon,
      onClick: handleExpand
    })), /*#__PURE__*/jsx(MenuGroupProvider, {
      value: {
        isGrouped: true
      },
      children: /*#__PURE__*/jsx(Collapse, {
        appear: true,
        unmountOnExit: true,
        duration: 100,
        in: isExpanded,
        children: /*#__PURE__*/jsx(StyledMenuGroupWrapper, {
          className: "manifest-menu-group__wrapper",
          children: children
        })
      })
    })]
  }));
});

/**
 * Pulled directly from the following library and augmented for our needs:
 *
 * https://github.com/so99ynoodles/headless-react/blob/main/packages/shared/src/hooks/useMultiSelectListState.tsx
 */
function useMultiSelectListState(props) {
  const _props$defaultSelecte = props.defaultSelectedKeys,
    defaultSelectedKeys = _props$defaultSelecte === void 0 ? new Set() : _props$defaultSelecte,
    onSelectionChange = props.onSelectionChange,
    selectedKeysProp = props.selectedKeys;
  const _useControlledState$3 = useControlledState$1(selectedKeysProp, defaultSelectedKeys, onSelectionChange),
    _useControlledState$4 = _slicedToArray(_useControlledState$3, 2),
    selectedKeys = _useControlledState$4[0],
    setSelectedKeys = _useControlledState$4[1];
  const _useListState = useListState(_objectSpread(_objectSpread({}, props), {}, {
      allowDuplicateSelectionEvents: true,
      selectionMode: 'multiple',
      selectedKeys,
      onSelectionChange: keys => {
        if (props.onSelectionChange) {
          props.onSelectionChange(keys);
        }
        setSelectedKeys(keys);
      }
    })),
    collection = _useListState.collection,
    disabledKeys = _useListState.disabledKeys,
    selectionManager = _useListState.selectionManager;
  const selectedItems = selectedKeys === 'all' ? [...collection] : [...selectedKeys].map(key => collection.getItem(key));
  return {
    collection,
    disabledKeys,
    selectionManager,
    selectedKeys,
    setSelectedKeys: setSelectedKeys.bind(selectionManager),
    selectedItems
  };
}

/**
 * Pulled directly from the following library and augmented for our needs:
 *
 * https://github.com/so99ynoodles/headless-react/blob/main/packages/combobox/src/hooks/useMultiComboBoxState.tsx
 *
 * Original created by react-aria:
 *
 * https://github.com/adobe/react-spectrum/blob/main/packages/%40react-stately/combobox/src/useComboBoxState.ts
 */
function useMultiComboboxState(props) {
  const _props$allowsEmptyCol = props.allowsEmptyCollection,
    allowsEmptyCollection = _props$allowsEmptyCol === void 0 ? false : _props$allowsEmptyCol,
    allowsCustomValue = props.allowsCustomValue,
    defaultFilter = props.defaultFilter,
    defaultItems = props.defaultItems,
    _props$defaultInputVa = props.defaultInputValue,
    defaultInputValue = _props$defaultInputVa === void 0 ? '' : _props$defaultInputVa,
    inputValueProp = props.inputValue,
    items = props.items,
    _props$menuTrigger = props.menuTrigger,
    menuTrigger = _props$menuTrigger === void 0 ? 'input' : _props$menuTrigger,
    onInputChange = props.onInputChange,
    onOpenChange = props.onOpenChange,
    onSelectionChange = props.onSelectionChange,
    selectedKeysProp = props.selectedKeys,
    _props$shouldCloseOnB2 = props.shouldCloseOnBlur,
    shouldCloseOnBlur = _props$shouldCloseOnB2 === void 0 ? true : _props$shouldCloseOnB2;
  const _React$useState9 = React.useState(false),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    showAllItems = _React$useState10[0],
    setShowAllItems = _React$useState10[1];
  const _React$useState11 = React.useState(false),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    isFocused = _React$useState12[0],
    setIsFocused = _React$useState12[1];
  const _useControlledState$5 = useControlledState$1(inputValueProp, defaultInputValue, onInputChange),
    _useControlledState$6 = _slicedToArray(_useControlledState$5, 2),
    inputValue = _useControlledState$6[0],
    setInputValue = _useControlledState$6[1];
  const renderedRef = React.useRef(true);
  const valueRef = React.useRef(inputValue);
  const triggerTypeRef = React.useRef('focus');
  const resetInputValue = () => {
    valueRef.current = '';
    setInputValue('');
  };
  const triggerState = useMenuTriggerState(_objectSpread(_objectSpread({}, props), {}, {
    onOpenChange: isOpen => {
      onOpenChange?.(isOpen, isOpen ? triggerTypeRef.current : undefined);
    },
    isOpen: undefined,
    defaultOpen: undefined
  }));
  const _useMultiSelectListSt = useMultiSelectListState(_objectSpread(_objectSpread({}, props), {}, {
      items: items ?? defaultItems,
      onSelectionChange: keys => {
        onSelectionChange?.(keys);
        resetInputValue();
        triggerState.close();
      }
    })),
    collection = _useMultiSelectListSt.collection,
    selectionManager = _useMultiSelectListSt.selectionManager,
    selectedKeys = _useMultiSelectListSt.selectedKeys,
    setSelectedKeys = _useMultiSelectListSt.setSelectedKeys,
    selectedItems = _useMultiSelectListSt.selectedItems,
    disabledKeys = _useMultiSelectListSt.disabledKeys;

  // Preserve original collection so we can show all items on demand
  const originalCollection = collection;
  const filteredCollection = React.useMemo(() =>
  // No default filter if items are controlled.
  items != null || !defaultFilter ? collection : filterCollection(collection, inputValue, defaultFilter), [collection, inputValue, defaultFilter, items]);
  const open = (focusStrategy, trigger) => {
    const displayAllItems = trigger === 'manual' || trigger === 'focus' && menuTrigger === 'focus';

    // Prevent open operations from triggering if there is nothing to display
    // Also prevent open operations from triggering if items are uncontrolled but defaultItems is empty, even if displayAllItems is true.
    // This is to prevent comboboxes with empty defaultItems from opening but allow controlled items comboboxes to open even if the inital list is empty (assumption is user will provide swap the empty list with a base list via onOpenChange returning `menuTrigger` manual)
    if (allowsEmptyCollection || filteredCollection.size > 0 || displayAllItems && originalCollection.size > 0 || items) {
      if (displayAllItems && !triggerState.isOpen && items === undefined) {
        // Show all items if menu is manually opened. Only care about this if items are undefined
        setShowAllItems(true);
      } else {
        setShowAllItems(false);
      }
      triggerTypeRef.current = trigger;
      triggerState.open(focusStrategy);
    }
  };
  const commitCustomValue = () => {
    setSelectedKeys(new Set([...selectedKeys, inputValue]));
    resetInputValue();
    triggerState.close();
  };
  const commitSelection = () => {
    // If multiple things are controlled, call onSelectionChange
    if (selectedKeysProp !== undefined && inputValueProp !== undefined) {
      onSelectionChange?.(selectedKeys);

      // Stop menu from reopening from useEffect
      const itemText = collection.getItem(selectionManager.focusedKey)?.textValue ?? '';
      valueRef.current = itemText;
    }

    // If only a single aspect of combobox is controlled, reset input value and close menu for the user
    resetInputValue();
    triggerState.close();
  };
  const commit = () => {
    if (triggerState.isOpen && selectionManager.focusedKey != null) {
      // Reset inputValue and close menu here if the selected key is already the focused key. Otherwise
      // fire onSelectionChange to allow the application to control the closing.
      if ([...selectedKeys].includes(selectionManager.focusedKey)) {
        setSelectedKeys(new Set([...selectedKeys].filter(key => key !== selectionManager.focusedKey)));
        commitSelection();
      } else {
        setSelectedKeys(new Set([...selectedKeys, selectionManager.focusedKey]));
        commitSelection();
      }
    } else if (allowsCustomValue) {
      commitCustomValue();
    } else {
      // Reset inputValue and close menu if no item is focused but user triggers a commit
      commitSelection();
    }
  };
  const setFocused = focused => {
    if (focused) {
      if (menuTrigger === 'focus') {
        open(null, 'focus');
      }
    } else if (shouldCloseOnBlur) {
      const itemTexts = [...collection].map(item => item.textValue);
      if (allowsCustomValue && !itemTexts.includes(inputValue)) {
        commitCustomValue();
      } else {
        commitSelection();
      }
    }
    setIsFocused(focused);
  };
  const revert = () => {
    if (allowsCustomValue && [...selectedKeys].length > 0) {
      commitCustomValue();
    } else {
      commitSelection();
    }
  };
  const toggle = (focusStrategy, trigger) => {
    const displayAllItems = trigger === 'manual' || trigger === 'focus' && menuTrigger === 'focus';

    // If the menu is closed and there is nothing to display, early return so toggle isn't called to prevent extraneous onOpenChange
    if (!(allowsEmptyCollection || filteredCollection.size > 0 || displayAllItems && originalCollection.size > 0 || items) && !triggerState.isOpen) {
      return;
    }
    if (displayAllItems && !triggerState.isOpen && items === undefined) {
      // Show all items if menu is toggled open. Only care about this if items are undefined
      setShowAllItems(true);
    }

    // Only update the menuOpenTrigger if menu is currently closed
    if (!triggerState.isOpen) {
      triggerTypeRef.current = trigger;
    }
    triggerState.toggle(focusStrategy);
  };

  // intentional omit dependency array, want this to happen on every render
  React.useEffect(() => {
    // Open and close menu automatically when the input value changes if the input is focused,
    // and there are items in the collection or allowEmptyCollection is true.
    if (isFocused && (filteredCollection.size > 0 || allowsEmptyCollection) && inputValue !== valueRef.current && !triggerState.isOpen && menuTrigger !== 'manual') {
      open(null, 'input');
    }

    // Close the menu if the collection is empty. Don't close menu if filtered collection size is 0
    // but we are currently showing all items via button press
    if (!showAllItems && !allowsEmptyCollection && triggerState.isOpen && filteredCollection.size === 0) {
      triggerState.close();
    }

    // If it is the intial render and inputValue isn't controlled nor has an intial value, set input to match current selected key if any
    if (renderedRef.current && inputValueProp === undefined && defaultInputValue === undefined) {
      resetInputValue();
    }
    valueRef.current = inputValue;
    renderedRef.current = false;
  });
  React.useEffect(() => {
    // Reset focused key when the menu closes
    if (!triggerState.isOpen) {
      selectionManager.setFocusedKey(null);
    }
  }, [triggerState.isOpen, selectionManager]);
  return _objectSpread(_objectSpread({}, triggerState), {}, {
    toggle,
    open,
    selectionManager,
    selectedKeys,
    setSelectedKeys,
    disabledKeys,
    isFocused,
    setFocused,
    selectedItems,
    collection: showAllItems ? originalCollection : filteredCollection,
    inputValue,
    setInputValue,
    commit,
    revert
  });
}

/**
 * Pulled directly from the following library and augmented for our needs:
 *
 * https://github.com/so99ynoodles/headless-react/blob/main/packages/select/src/hooks/useMultiSelectState.tsx
 */
function useMultiSelectState(props) {
  const _React$useState13 = React.useState(false),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    isFocused = _React$useState14[0],
    setFocused = _React$useState14[1];
  const triggerState = useMenuTriggerState(props);
  const listState = useMultiSelectListState(props);
  return _objectSpread(_objectSpread(_objectSpread({}, listState), triggerState), {}, {
    close() {
      triggerState.close();
    },
    open() {
      // Don't open if the collection is empty.
      if (listState.collection.size > 0) {
        triggerState.open();
      }
    },
    toggle(focusStrategy) {
      if (listState.collection.size > 0) {
        triggerState.toggle(focusStrategy);
      }
    },
    isFocused,
    setFocused
  });
}
const StyledStack = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  variants: {
    orientation: {
      horizontal: {
        flexDirection: 'row'
      },
      vertical: {
        flexDirection: 'column'
      }
    },
    gap: {
      large: {
        gap: '$large'
      },
      medium: {
        gap: '$medium'
      },
      small: {
        gap: '$small'
      },
      'x-large': {
        gap: '$x-large'
      },
      'x-small': {
        gap: '$x-small'
      }
    }
  },
  defaultVariants: {
    orientation: 'vertical'
  }
});
const Stack = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const as = props.as,
    classNameProp = props.className,
    css = props.css,
    gap = props.gap,
    orientation = props.orientation,
    other = _objectWithoutProperties(props, _excluded53);
  return /*#__PURE__*/jsx(StyledStack, _objectSpread(_objectSpread({}, other), {}, {
    ref: forwardedRef,
    as: as,
    className: cx('manifest-stack', classNameProp),
    css: css,
    gap: gap,
    orientation: orientation
  }));
});
const raiseFade = keyframes({
  '0%': {
    opacity: 1,
    transform: 'translateY(0)'
  },
  '100%': {
    opacity: 0,
    transform: `translateY(-${pxToRem(25)})`
  }
});
const useStyles$c = css({
  position: 'relative',
  alignItems: 'center',
  appearance: 'none',
  background: 'none',
  border: '1px solid $colors$palette-grey-200',
  borderRadius: '$small',
  boxSizing: 'border-box',
  color: '$text-primary',
  display: 'inline-flex',
  height: pxToRem(24),
  justifyContent: 'center',
  outline: 0,
  textDecoration: 'none',
  verticalAlign: 'middle',
  whiteSpace: 'nowrap',
  maxWidth: pxToRem(100),
  '.manifest-tag__icon-button': {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    color: '$text-secondary',
    p: '$x-small',
    cursor: 'pointer',
    border: 'none',
    borderRadius: '0 1px 1px 0',
    background: 'none'
  },
  '.manifest-tag__icon-button:hover': {
    border: 'none',
    background: '$background-secondary'
  },
  '.manifest-tag__copy-icon': {
    display: 'none'
  },
  '.manifest-tag__text': {
    px: '$small',
    py: pxToRem(3),
    color: 'inherit',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  '.manifest-tag__start-adornment': {
    display: 'flex',
    marginLeft: '$small',
    marginRight: '-$x-small'
  },
  '&:focus': {
    outline: '1px solid $colors$palette-indigo-200',
    outlineOffset: pxToRem(1)
  },
  variants: {
    isCopied: {
      true: {
        '@media (prefers-reduced-motion: no-preference)': {
          '.manifest-tag__text::before': {
            content: 'attr(data-children)',
            position: 'absolute',
            top: 2,
            left: 8,
            animation: `${raiseFade} 0.7s`
          }
        }
      }
    },
    isCopyable: {
      true: {
        cursor: 'pointer',
        '.manifest-tag__text': {
          paddingRight: pxToRem(8)
        }
      }
    },
    isRemovable: {
      true: {
        '.manifest-tag__text': {
          paddingRight: '$x-small'
        }
      }
    },
    isDisabled: {
      true: {
        opacity: 0.37,
        '.manifest-tag__icon-button': {
          pointerEvents: 'none'
        },
        '&:focus': {
          outline: 'none'
        }
      }
    },
    isHovered: {
      true: {
        border: '1px solid $colors$palette-grey-300'
      }
    }
  },
  compoundVariants: [{
    isHovered: true,
    isCopyable: true,
    css: {
      background: '$background-secondary',
      '.manifest-tag__copy-icon-container': {
        isolation: 'isolate',
        position: 'absolute',
        top: '15%',
        right: pxToRem(4)
      },
      '.manifest-tag__copy-icon': {
        display: 'block',
        color: '$text-secondary'
      },
      '.manifest-tag__copy-icon-fade::after': {
        zIndex: -1,
        content: '',
        position: 'absolute',
        top: 0,
        right: 0,
        width: '110%',
        height: '100%',
        backgroundImage: 'linear-gradient(to right, rgba(245, 245, 245, 0) 0%, rgba(245, 245, 245, 1) 18%)',
        pointerEvents: 'none'
      }
    }
  }]
});
const Tag = createComponent((props, forwardedRef) => {
  const _props$as12 = props.as,
    Comp = _props$as12 === void 0 ? 'div' : _props$as12,
    children = props.children,
    classNameProp = props.className,
    css = props.css,
    isCopyable = props.isCopyable,
    isDisabled = props.isDisabled,
    isRemovable = props.isRemovable,
    _props$label = props.label,
    label = _props$label === void 0 ? '' : _props$label,
    onRemove = props.onRemove,
    removeButtonProps = props.removeButtonProps,
    startAdornment = props.startAdornment,
    other = _objectWithoutProperties(props, _excluded54);
  const _React__default$useSt3 = React__default.useState(false),
    _React__default$useSt4 = _slicedToArray(_React__default$useSt3, 2),
    isCopied = _React__default$useSt4[0],
    setIsCopied = _React__default$useSt4[1];
  const childrenText = useChildrenTextContent(children);
  const removeButtonRef = React__default.useRef(null);
  const copyButtonRef = React__default.useRef(null);
  const _useCopyToClipboard = useCopyToClipboard(),
    copy = _useCopyToClipboard.copy;
  const _useButton7 = useButton(_objectSpread(_objectSpread({}, removeButtonProps), {}, {
      isDisabled,
      onPress: onRemove
    }), removeButtonRef),
    removeButtonCombinedProps = _useButton7.buttonProps;
  const _useHover11 = useHover({
      isDisabled
    }),
    isHovered = _useHover11.isHovered,
    hoverProps = _useHover11.hoverProps;
  const labelText = typeof label === 'string' && label !== '' ? label : childrenText;
  const onCopy = React__default.useCallback(() => {
    copy(labelText).then(didCopy => void setIsCopied(didCopy)).catch(() => void setIsCopied(false));
  }, [labelText, copy]);
  const _useButton8 = useButton({
      elementType: Comp,
      isDisabled,
      onClick: onCopy,
      onPress: onCopy
    }, copyButtonRef),
    copyButtonProps = _useButton8.buttonProps;
  const _useStyles$c = useStyles$c({
      css,
      isCopied,
      isCopyable,
      isDisabled,
      isHovered,
      isRemovable
    }),
    className = _useStyles$c.className;
  if (isCopyable && (!label || label === '')) {
    // eslint-disable-next-line no-console
    console.warn('Tag component requires a label prop for click-to-copy');
  }
  return /*#__PURE__*/jsxs(Comp, _objectSpread(_objectSpread(_objectSpread({}, mergeProps(hoverProps, other, isCopyable && copyButtonProps || {})), {}, {
    ref: mergeRefs(forwardedRef, copyButtonRef),
    className: cx(className, classNameProp, 'manifest-tag'),
    tabIndex: 0
  }, isDisabled ? {
    'aria-disabled': 'true'
  } : {}), {}, {
    children: [startAdornment && /*#__PURE__*/jsx("div", {
      "aria-hidden": true,
      className: "manifest-tag__start-adornment",
      children: startAdornment
    }), /*#__PURE__*/jsx(Typography, {
      className: "manifest-tag__text",
      variant: "caption",
      'data-children': children,
      children: children
    }), isCopyable && /*#__PURE__*/jsxs("div", {
      className: "manifest-tag__copy-icon-container",
      children: [isCopied ? /*#__PURE__*/jsx(Check, {
        className: "manifest-tag__copy-icon",
        size: "small"
      }) : /*#__PURE__*/jsx(CopyAll, {
        className: "manifest-tag__copy-icon",
        size: "small"
      }), /*#__PURE__*/jsx("span", {
        className: "manifest-tag__copy-icon-fade"
      })]
    }), isRemovable && /*#__PURE__*/jsx("button", _objectSpread(_objectSpread({}, removeButtonCombinedProps), {}, {
      ref: removeButtonRef,
      className: "manifest-tag__icon-button",
      tabIndex: -1,
      children: /*#__PURE__*/jsx(Close, {
        className: "manifest-tag__icon",
        size: "small"
      })
    }))]
  }));
});
const useStyles$b = css({
  $$backgroundColor: '$colors$background-primary',
  $$borderColor: '$colors$palette-grey-500',
  $$iconColor: '$colors$text-tertiary',
  $$textColor: '$colors$text-primary',
  '.manifest-multi-combobox__wrapper': {
    borderRadius: '$small',
    border: '1px solid $$borderColor',
    boxSizing: 'border-box',
    display: 'flex',
    flexWrap: 'wrap',
    minHeight: pxToRem(40),
    minWidth: pxToRem(48),
    padding: `${pxToRem(7)} $small`,
    paddingRight: pxToRem(40),
    position: 'relative',
    width: '100%'
  },
  '.manifest-multi-combobox__icon': {
    alignItems: 'center',
    color: '$$iconColor',
    display: 'inline-flex',
    fontSize: '$x-large',
    justifyContent: 'center',
    padding: '$small',
    position: 'absolute',
    left: 0,
    size: pxToRem(40),
    top: 0,
    zIndex: 2,
    '> .material-icons': {
      fontSize: '$x-large'
    }
  },
  '.manifest-multi-combobox__button': {
    appearance: 'none',
    alignItems: 'center',
    background: 'none',
    border: 0,
    borderLeft: '1px solid $$borderColor',
    bottom: 0,
    color: '$$iconColor',
    cursor: 'pointer',
    display: 'inline-flex',
    fontSize: '$x-large',
    justifyContent: 'center',
    margin: 0,
    outline: 'none',
    padding: '$small',
    position: 'absolute',
    right: -2,
    top: -1,
    zIndex: 2,
    '> .material-icons': {
      fontSize: '$x-large'
    }
  },
  '.manifest-multi-combobox__input': {
    appearance: 'none',
    border: 'none',
    backgroundColor: '$$backgroundColor',
    boxSizing: 'border-box',
    color: '$$textColor',
    cursor: 'text',
    flexGrow: 1,
    margin: 0,
    outline: 0,
    p: '0 $small',
    resize: 'none',
    transition: '$color',
    typography: '$subtext',
    width: '0',
    '&::placeholder': {
      color: '$text-tertiary'
    }
  },
  variants: {
    hasStartIcon: {
      true: {
        '.manifest-multi-combobox__wrapper': {
          paddingLeft: pxToRem(40)
        }
      }
    },
    isDisabled: {
      true: {
        $$backgroundColor: '$colors$palette-grey-50',
        $$textColor: '$colors$text-disabled',
        '.manifest-multi-combobox__input': {
          cursor: 'not-allowed'
        }
      }
    },
    isFocused: {
      true: {
        $$borderColor: '$colors$primary-default'
      }
    },
    isFocusVisible: {
      true: {
        '.manifest-multi-combobox__wrapper': {
          '&:after': {
            backgroundColor: 'transparent',
            border: '2px solid $colors$palette-indigo-200',
            // TODO: replace with design token once its defined.s
            borderRadius: '4px',
            bottom: '-4px',
            content: '',
            display: 'block',
            left: '-4px',
            position: 'absolute',
            right: '-4px',
            top: '-4px'
          }
        }
      },
      false: {}
    },
    isHovered: {
      true: {
        $$borderColor: '$colors$palette-grey-600'
      }
    },
    isInvalid: {
      true: {
        $$borderColor: '$colors$border-danger',
        $$iconColor: '$colors$text-danger',
        $$textColor: '$colors$text-danger'
      }
    },
    isPlaceholder: {
      true: {
        $$textColor: '$colors$text-tertiary'
      }
    }
  }
});
const MultiCombobox = createComponent((props, forwardedRef) => {
  const _props$as13 = props.as,
    Comp = _props$as13 === void 0 ? 'div' : _props$as13,
    autoFocus = props.autoFocus,
    classNameProp = props.className,
    containerRefProp = props.containerRef,
    css = props.css,
    isDisabled = props.isDisabled,
    helperText = props.helperText,
    _props$helperTextProp5 = props.helperTextProps,
    helperTextPropsProp = _props$helperTextProp5 === void 0 ? {} : _props$helperTextProp5,
    label = props.label,
    _props$labelProps6 = props.labelProps,
    labelPropsProp = _props$labelProps6 === void 0 ? {} : _props$labelProps6,
    maxHeight = props.maxHeight,
    _props$offset6 = props.offset,
    offset = _props$offset6 === void 0 ? 4 : _props$offset6,
    _props$placement6 = props.placement,
    placement = _props$placement6 === void 0 ? 'bottom' : _props$placement6,
    _props$shouldFlip5 = props.shouldFlip,
    shouldFlip = _props$shouldFlip5 === void 0 ? true : _props$shouldFlip5,
    validationState = props.validationState,
    _props$size7 = props.size,
    size = _props$size7 === void 0 ? 'medium' : _props$size7,
    startIcon = props.startIcon;
  const isInvalid = validationState === 'invalid';
  const containerRef = React.useRef(null);
  const buttonRef = React.useRef(null);
  const inputRef = React.useRef(null);
  const listBoxRef = React.useRef(null);
  const popoverRef = React.useRef(null);
  const _useFilter2 = useFilter({
      sensitivity: 'base'
    }),
    contains = _useFilter2.contains;
  const state = useMultiComboboxState(_objectSpread(_objectSpread({}, props), {}, {
    defaultFilter: contains
  }));
  const _useMultiCombobox = useMultiCombobox(_objectSpread(_objectSpread({}, props), {}, {
      buttonRef,
      inputRef,
      listBoxRef,
      popoverRef
    }), state),
    triggerProps = _useMultiCombobox.buttonProps,
    inputProps = _useMultiCombobox.inputProps,
    listBoxProps = _useMultiCombobox.listBoxProps,
    labelProps = _useMultiCombobox.labelProps,
    descriptionProps = _useMultiCombobox.descriptionProps,
    errorMessageProps = _useMultiCombobox.errorMessageProps;
  const _useOverlayPosition6 = useOverlayPosition({
      isOpen: state.isOpen,
      maxHeight,
      offset,
      onClose: state.close,
      overlayRef: popoverRef,
      placement,
      shouldFlip,
      scrollRef: listBoxRef,
      targetRef: containerRef
    }),
    overlayProps = _useOverlayPosition6.overlayProps;
  const _useButton9 = useButton(triggerProps, buttonRef),
    buttonProps = _useButton9.buttonProps;
  const _useHover12 = useHover({
      isDisabled
    }),
    hoverProps = _useHover12.hoverProps,
    isHovered = _useHover12.isHovered;
  const _useFocusRing10 = useFocusRing({
      autoFocus,
      within: true
    }),
    isFocusVisible = _useFocusRing10.isFocusVisible,
    isFocused = _useFocusRing10.isFocused,
    focusProps = _useFocusRing10.focusProps;
  const handleClose = React.useCallback(() => void state.close(), [state]);
  const handleRemove = key => () => void state.selectionManager.toggleSelection(key);
  const _useStyles$b = useStyles$b({
      hasStartIcon: Boolean(startIcon),
      isDisabled,
      isFocused,
      isFocusVisible,
      isHovered,
      isInvalid,
      isPlaceholder: !state.selectedItems,
      size,
      css
    }),
    className = _useStyles$b.className;
  const classes = cx(className, classNameProp, {
    'manifest-combobox': true,
    'manifest-combobox--disabled': isDisabled,
    'manifest-combobox--invalid': isInvalid,
    [`manifest-combobox--${size}`]: size
  });
  const containerDimensions = containerRef.current?.getBoundingClientRect();
  return /*#__PURE__*/jsx(FormControl, {
    className: classes,
    helperText: helperText,
    helperTextProps: mergeProps$1(descriptionProps, errorMessageProps, helperTextPropsProp),
    label: label,
    labelProps: mergeProps$1(labelProps, labelPropsProp),
    validationState: validationState,
    children: /*#__PURE__*/jsxs(Comp, _objectSpread(_objectSpread({}, mergeProps$1(hoverProps, focusProps)), {}, {
      ref: mergeRefs$1(containerRef, forwardedRef),
      className: "manifest-multi-combobox__wrapper",
      children: [startIcon && /*#__PURE__*/jsx("span", {
        className: "manifest-multi-combobox__icon",
        children: startIcon
      }), /*#__PURE__*/jsx(Stack, {
        css: {
          flexWrap: 'wrap'
        },
        gap: "x-small",
        orientation: "horizontal",
        children: state.selectedItems?.map(item => /*#__PURE__*/jsx(Tag, {
          isRemovable: true,
          label: item.textValue,
          onRemove: handleRemove(item.key),
          children: item.textValue
        }, item.key))
      }), /*#__PURE__*/jsx("input", _objectSpread(_objectSpread({}, inputProps), {}, {
        ref: inputRef,
        className: "manifest-multi-combobox__input"
      })), /*#__PURE__*/jsx("button", _objectSpread(_objectSpread({}, buttonProps), {}, {
        ref: buttonRef,
        className: "manifest-multi-combobox__button",
        children: /*#__PURE__*/jsx(Icon, {
          icon: "expand_more"
        })
      })), /*#__PURE__*/jsx(Overlay, {
        containerRef: containerRefProp,
        isOpen: state.isOpen && !isDisabled,
        children: /*#__PURE__*/jsx(Popover, _objectSpread(_objectSpread({}, overlayProps), {}, {
          ref: popoverRef,
          className: "manifest-multi-combobox__popover",
          css: {
            left: containerDimensions?.left,
            width: containerDimensions?.width
          },
          isOpen: state.isOpen,
          onClose: handleClose,
          children: /*#__PURE__*/jsx(ListBoxBase, _objectSpread(_objectSpread({}, listBoxProps), {}, {
            ref: listBoxRef,
            disallowEmptySelection: true,
            className: "manifest-multi-combobox__list-box",
            state: state
          }))
        }))
      })]
    }))
  });
});
function useHiddenMultiSelect(props, state, triggerRef) {
  const autoComplete = props.autoComplete,
    name = props.name,
    isDisabled = props.isDisabled;
  const modality = useInteractionModality();
  const _useVisuallyHidden = useVisuallyHidden(),
    visuallyHiddenProps = _useVisuallyHidden.visuallyHiddenProps;
  return {
    containerProps: _objectSpread(_objectSpread({}, visuallyHiddenProps), {}, {
      'aria-hidden': true
    }),
    inputProps: {
      type: 'text',
      tabIndex: modality == null || state.isFocused || state.isOpen ? -1 : 0,
      style: {
        fontSize: 16
      },
      onFocus: () => triggerRef.current?.focus(),
      disabled: isDisabled
    },
    selectProps: {
      tabIndex: -1,
      autoComplete,
      disabled: isDisabled,
      name,
      size: state.collection.size,
      selectedoptions: [...state.collection].map(item => ({
        value: item.key
      })),
      onChange: event => void state.setSelectedKeys(new Set([...event.target.selectedOptions].map(option => option.value)))
    }
  };
}
function HiddenMultiSelect(props) {
  const state = props.state,
    triggerRef = props.triggerRef,
    label = props.label,
    name = props.name,
    isDisabled = props.isDisabled;
  const _useHiddenMultiSelect = useHiddenMultiSelect(props, state, triggerRef),
    containerProps = _useHiddenMultiSelect.containerProps,
    inputProps = _useHiddenMultiSelect.inputProps,
    selectProps = _useHiddenMultiSelect.selectProps;
  if (state.collection.size <= 300) {
    return /*#__PURE__*/jsxs("div", _objectSpread(_objectSpread({}, containerProps), {}, {
      children: [/*#__PURE__*/jsx("input", _objectSpread({}, inputProps)), /*#__PURE__*/jsxs("label", {
        children: [label, /*#__PURE__*/jsxs("select", _objectSpread(_objectSpread({
          multiple: true
        }, selectProps), {}, {
          children: [/*#__PURE__*/jsx("option", {}), [...state.collection.getKeys()].map(key => {
            const item = state.collection.getItem(key);
            if (item.type === 'item') {
              return /*#__PURE__*/jsx("option", {
                value: item.key,
                children: item.textValue
              }, item.key);
            }
            return null;
          })]
        }))]
      })]
    }));
  }
  if (name) {
    return /*#__PURE__*/jsx(Fragment, {
      children: [...state.selectedKeys].map(key => /*#__PURE__*/jsx("input", {
        multiple: true,
        autoComplete: selectProps.autoComplete,
        disabled: isDisabled,
        name: name,
        type: "hidden",
        value: key
      }, key))
    });
  }
  return null;
}
const useStyles$a = css({
  $$backgroundColor: '$colors$background-primary',
  $$borderColor: '$colors$palette-grey-500',
  $$iconColor: '$colors$text-tertiary',
  $$textColor: '$colors$text-primary',
  '.manifest-multi-select__wrapper': {
    alignItems: 'center',
    display: 'flex',
    minWidth: pxToRem(48),
    position: 'relative',
    width: '100%'
  },
  '.manifest-multi-select__icon': {
    alignItems: 'center',
    color: '$$iconColor',
    display: 'inline-flex',
    fontSize: '$x-large',
    justifyContent: 'center',
    padding: '$small',
    pointerEvents: 'none',
    position: 'absolute',
    size: pxToRem(40),
    top: 0,
    zIndex: 2,
    '> .manifest-icon': {
      fontSize: '$x-large'
    }
  },
  '.manifest-multi-select__icon--end': {
    right: 0
  },
  '.manifest-multi-select__icon--start': {
    left: 0
  },
  '.manifest-multi-select__input': {
    appearance: 'none',
    backgroundColor: '$$backgroundColor',
    border: '1px solid $$borderColor',
    borderRadius: '$small',
    boxSizing: 'border-box',
    color: '$$textColor',
    cursor: 'default',
    margin: 0,
    minHeight: pxToRem(40),
    outline: 0,
    padding: `${pxToRem(7)} $small`,
    paddingRight: pxToRem(40),
    textAlign: 'start',
    top: 0,
    width: '100%'
  },
  '.manifest-multi-select__text': {
    color: '$text-tertiary'
  },
  variants: {
    hasStartIcon: {
      true: {
        '.manifest-multi-select__input': {
          paddingLeft: pxToRem(40)
        }
      }
    },
    isActive: {
      true: {
        $$borderColor: '$colors$primary-active',
        $$iconColor: '$colors$text-secondary',
        $$textColor: '$colors$text-primary'
      }
    },
    isDisabled: {
      true: {
        $$backgroundColor: '$colors$palette-grey-50',
        $$textColor: '$colors$text-disabled',
        '.manifest-multi-select__input': {
          cursor: 'not-allowed'
        }
      }
    },
    isFocused: {
      true: {
        $$borderColor: '$colors$primary-active',
        $$iconColor: '$colors$text-secondary',
        $$textColor: '$colors$text-primary'
      }
    },
    isFocusVisible: {
      true: {
        '.manifest-multi-select__wrapper': {
          '&:after': {
            backgroundColor: 'transparent',
            border: '2px solid $colors$palette-indigo-200',
            // TODO: replace with design token once its defined.s
            borderRadius: '4px',
            bottom: '-3px',
            content: '',
            display: 'block',
            left: '-3px',
            position: 'absolute',
            right: '-3px',
            top: '-3px'
          }
        }
      },
      false: {}
    },
    isHovered: {
      true: {
        $$borderColor: '$colors$palette-grey-600'
      }
    },
    isInvalid: {
      true: {
        $$borderColor: '$colors$border-danger',
        $$iconColor: '$colors$text-danger',
        $$textColor: '$colors$text-danger'
      }
    },
    isPlaceholder: {
      true: {
        $$textColor: '$colors$text-tertiary'
      }
    },
    isPressed: {
      true: {
        $$borderColor: '$colors$primary-active'
      }
    }
  }
});
const MultiSelect = createComponent((props, forwardedRef) => {
  const _props$as14 = props.as,
    Comp = _props$as14 === void 0 ? 'div' : _props$as14,
    autoComplete = props.autoComplete,
    autoFocus = props.autoFocus,
    classNameProp = props.className,
    containerRefProp = props.containerRef,
    css = props.css,
    isDisabled = props.isDisabled,
    isRequired = props.isRequired,
    helperText = props.helperText,
    _props$helperTextProp6 = props.helperTextProps,
    helperTextProps = _props$helperTextProp6 === void 0 ? {} : _props$helperTextProp6,
    label = props.label,
    _props$labelProps7 = props.labelProps,
    labelPropsProp = _props$labelProps7 === void 0 ? {} : _props$labelProps7,
    name = props.name,
    maxHeight = props.maxHeight,
    _props$offset7 = props.offset,
    offset = _props$offset7 === void 0 ? 4 : _props$offset7,
    placeholder = props.placeholder,
    _props$placement7 = props.placement,
    placement = _props$placement7 === void 0 ? 'bottom start' : _props$placement7,
    _props$shouldFlip6 = props.shouldFlip,
    shouldFlip = _props$shouldFlip6 === void 0 ? true : _props$shouldFlip6,
    validationState = props.validationState,
    startIcon = props.startIcon;
  const containerRef = React.useRef(null);
  const triggerRef = React.useRef(null);
  const listBoxRef = React.useRef(null);
  const popoverRef = React.useRef(null);
  const state = useMultiSelectState(props);
  const _useMultiSelect = useMultiSelect(props, state, triggerRef),
    labelProps = _useMultiSelect.labelProps,
    triggerProps = _useMultiSelect.triggerProps,
    valueProps = _useMultiSelect.valueProps,
    menuProps = _useMultiSelect.menuProps,
    descriptionProps = _useMultiSelect.descriptionProps,
    errorMessageProps = _useMultiSelect.errorMessageProps;
  const _useOverlayPosition7 = useOverlayPosition({
      isOpen: state.isOpen,
      maxHeight,
      offset,
      onClose: state.close,
      overlayRef: popoverRef,
      placement,
      shouldFlip,
      scrollRef: listBoxRef,
      targetRef: containerRef
    }),
    overlayProps = _useOverlayPosition7.overlayProps;
  const isInvalid = validationState === 'invalid';
  const _useButton10 = useButton(triggerProps, triggerRef),
    buttonProps = _useButton10.buttonProps,
    isPressed = _useButton10.isPressed;
  const _useFocusRing11 = useFocusRing({
      autoFocus
    }),
    isFocusVisible = _useFocusRing11.isFocusVisible,
    isFocused = _useFocusRing11.isFocused,
    focusProps = _useFocusRing11.focusProps;
  const _useHover13 = useHover({
      isDisabled
    }),
    hoverProps = _useHover13.hoverProps,
    isHovered = _useHover13.isHovered;
  const handleClose = React.useCallback(() => void state.close(), [state]);
  const handleRemove = key => () => void state.selectionManager.toggleSelection(key);
  const _useStyles$a = useStyles$a({
      hasStartIcon: Boolean(startIcon),
      isActive: state.isOpen,
      isDisabled,
      isFocused,
      isFocusVisible,
      isHovered,
      isInvalid,
      isPlaceholder: !state.selectedItems,
      isPressed,
      css
    }),
    className = _useStyles$a.className;
  const classes = cx(className, classNameProp, {
    'manifest-multi-select': true,
    'manifest-multi-select--disabled': isDisabled,
    'manifest-multi-select--invalid': isInvalid
  });
  const containerDimensions = containerRef.current?.getBoundingClientRect();
  return /*#__PURE__*/jsx(FormControl, {
    className: classes,
    helperText: helperText,
    helperTextProps: mergeProps$1(descriptionProps, errorMessageProps, helperTextProps),
    isRequired: isRequired,
    label: label,
    labelProps: mergeProps$1(labelProps, labelPropsProp),
    validationState: validationState,
    children: /*#__PURE__*/jsxs(Comp, {
      ref: mergeRefs$1(containerRef, forwardedRef),
      className: "manifest-multi-select__wrapper",
      children: [startIcon && /*#__PURE__*/jsx("span", {
        className: cx('manifest-multi-select__icon', 'manifest-multi-select__icon--start'),
        children: startIcon
      }), /*#__PURE__*/jsx(HiddenMultiSelect, {
        autoComplete: autoComplete,
        isDisabled: isDisabled,
        label: label,
        name: name,
        state: state,
        triggerRef: triggerRef
      }), /*#__PURE__*/jsx("button", _objectSpread(_objectSpread({}, mergeProps$1(buttonProps, focusProps, hoverProps, {
        autoFocus
      })), {}, {
        ref: triggerRef,
        className: "manifest-multi-select__input",
        children: state.selectedItems.length > 0 ? /*#__PURE__*/jsx(Stack, {
          css: {
            flexWrap: 'wrap'
          },
          gap: "x-small",
          orientation: "horizontal",
          children: state.selectedItems?.map(item => /*#__PURE__*/jsx(Tag, {
            isRemovable: true,
            label: item.textValue,
            onRemove: handleRemove(item.key),
            children: item.textValue
          }, item.key))
        }) : /*#__PURE__*/jsx(Typography, _objectSpread(_objectSpread({}, valueProps), {}, {
          variant: "subtext",
          children: placeholder
        }))
      })), /*#__PURE__*/jsx("span", {
        className: cx('manifest-multi-select__icon', 'manifest-multi-select__icon--end'),
        children: /*#__PURE__*/jsx(Icon, {
          icon: "expand_more"
        })
      }), /*#__PURE__*/jsx(Overlay, {
        containerRef: containerRefProp,
        isOpen: state.isOpen && !isDisabled,
        children: /*#__PURE__*/jsx(Popover, _objectSpread(_objectSpread({}, overlayProps), {}, {
          ref: popoverRef,
          className: "manifest-combobox__popover",
          css: {
            left: containerDimensions?.left,
            width: containerDimensions?.width
          },
          isOpen: state.isOpen,
          onClose: handleClose,
          children: /*#__PURE__*/jsx(ListBoxBase, _objectSpread(_objectSpread({}, menuProps), {}, {
            ref: listBoxRef,
            disallowEmptySelection: true,
            className: "manifest-multi-select__list-box",
            state: state
          }))
        }))
      })]
    })
  });
});
const useStyles$9 = css({
  $$backgroundColor: '$colors$background-primary',
  $$borderColor: '$colors$palette-grey-500',
  $$iconColor: '$colors$text-tertiary',
  $$textColor: '$colors$text-primary',
  '.manifest-numberfield-base__wrapper': {
    alignItems: 'center',
    boxSizing: 'border-box',
    display: 'inline-flex',
    justifyContent: 'flex-start',
    position: 'relative',
    width: 'auto'
  },
  '.manifest-numberfield-base__icon': {
    alignItems: 'center',
    color: '$$iconColor',
    display: 'inline-flex',
    fontSize: '$x-large',
    justifyContent: 'center',
    padding: '$small',
    pointerEvents: 'none',
    position: 'absolute',
    top: 0,
    zIndex: 2,
    '> .material-icons': {
      fontSize: '$x-large'
    }
  },
  '.manifest-numberfield-base__icon--end': {
    right: 0
  },
  '.manifest-numberfield-base__icon--start': {
    left: 0
  },
  '.manifest-numberfield-base__input': {
    appearance: 'none',
    backgroundColor: '$$backgroundColor',
    border: '1px solid $$borderColor',
    borderRadius: '$small',
    boxSizing: 'border-box',
    color: '$$textColor',
    cursor: 'text',
    fontFamily: '$text',
    margin: 0,
    outline: 0,
    padding: '$small',
    resize: 'none',
    transition: '$color',
    typography: '$subtext',
    width: '100%',
    '&::placeholder': {
      color: '$text-tertiary'
    }
  },
  variants: {
    isDisabled: {
      true: {
        $$backgroundColor: '$colors$palette-grey-50',
        $$textColor: '$colors$text-disabled',
        cursor: 'not-allowed'
      }
    },
    isFocused: {
      true: {
        $$borderColor: '$colors$primary-default'
      }
    },
    isFocusVisible: {
      true: {
        '.manifest-numberfield-base__wrapper': {
          '&:after': {
            backgroundColor: 'transparent',
            border: '2px solid $colors$palette-indigo-200',
            // TODO: replace with design token once its defined.
            borderRadius: '4px',
            bottom: '-3px',
            content: '',
            display: 'block',
            left: '-3px',
            position: 'absolute',
            right: '-3px',
            top: '-3px'
          }
        }
      },
      false: {
        boxShadow: 'none'
      }
    },
    isHovered: {
      true: {
        $$borderColor: '$colors$palette-grey-600'
      }
    },
    isInvalid: {
      true: {
        $$borderColor: '$colors$border-danger',
        $$iconColor: '$colors$text-danger',
        $$textColor: '$colors$text-danger'
      }
    }
  }
});
const NumberFieldBase = createComponent((props, forwardedRef) => {
  const autoFocus = props.autoFocus,
    classNameProp = props.className,
    css = props.css,
    helperText = props.helperText,
    helperTextProps = props.helperTextProps,
    _props$inputProps = props.inputProps,
    inputProps = _props$inputProps === void 0 ? {} : _props$inputProps,
    inputRef = props.inputRef,
    isDisabled = props.isDisabled,
    isRequired = props.isRequired,
    label = props.label,
    labelProps = props.labelProps,
    validationState = props.validationState;
  const isInvalid = validationState === 'invalid';
  const fieldRef = React.useRef(null);
  const _useFocusRing12 = useFocusRing({
      autoFocus,
      isTextInput: true
    }),
    focusProps = _useFocusRing12.focusProps,
    isFocused = _useFocusRing12.isFocused,
    isFocusVisible = _useFocusRing12.isFocusVisible;
  const _useHover14 = useHover({
      isDisabled
    }),
    isHovered = _useHover14.isHovered,
    hoverProps = _useHover14.hoverProps;
  const _useStyles$ = useStyles$9({
      isDisabled,
      isFocused,
      isFocusVisible,
      isHovered,
      isInvalid,
      css
    }),
    className = _useStyles$.className;
  const classes = cx(className, classNameProp, {
    'manifest-numberfield-base': true,
    'manifest-numberfield-base--disabled': isDisabled,
    'manifest-numberfield-base--invalid': isInvalid
  });
  return /*#__PURE__*/jsx(FormControl, {
    className: classes,
    helperText: helperText,
    helperTextProps: helperTextProps,
    isRequired: isRequired,
    label: label,
    labelProps: labelProps,
    validationState: validationState,
    children: /*#__PURE__*/jsx("div", {
      ref: forwardedRef,
      className: "manifest-numberfield-base__wrapper",
      children: /*#__PURE__*/jsx("input", _objectSpread(_objectSpread({}, mergeProps$1(inputProps, focusProps, hoverProps)), {}, {
        ref: mergeRefs$1(fieldRef, inputRef),
        className: "manifest-numberfield-base__input"
      }))
    })
  });
});
const useStyles$8 = css({
  variants: {
    size: {
      medium: {
        '.manifest-numberfield-base__input': {
          py: pxToRem(9)
        }
      },
      small: {
        '.manifest-numberfield-base__input': {
          py: pxToRem(6)
        }
      }
    }
  },
  defaultVariants: {
    size: 'medium'
  }
});
const NumberField = createComponent((props, forwardedRef) => {
  const classNameProp = props.className,
    _props$helperTextProp7 = props.helperTextProps,
    helperTextProps = _props$helperTextProp7 === void 0 ? {} : _props$helperTextProp7,
    customLocale = props.customLocale,
    _props$inputProps2 = props.inputProps,
    inputPropsProp = _props$inputProps2 === void 0 ? {} : _props$inputProps2,
    inputRef = props.inputRef,
    _props$labelProps8 = props.labelProps,
    labelPropsProp = _props$labelProps8 === void 0 ? {} : _props$labelProps8,
    onChange = props.onChange,
    _props$size8 = props.size,
    size = _props$size8 === void 0 ? 'medium' : _props$size8,
    other = _objectWithoutProperties(props, _excluded55);
  const fieldRef = React.useRef(null);
  const _useLocale8 = useLocale(),
    locale = _useLocale8.locale;
  const state = useNumberFieldState(_objectSpread(_objectSpread({}, props), {}, {
    locale: customLocale ?? locale
  }));
  const _useNumberField = useNumberField(_objectSpread({}, props), state, fieldRef),
    inputProps = _useNumberField.inputProps,
    descriptionProps = _useNumberField.descriptionProps,
    errorMessageProps = _useNumberField.errorMessageProps,
    labelProps = _useNumberField.labelProps;
  const _useStyles$2 = useStyles$8({
      size
    }),
    className = _useStyles$2.className;
  const classes = cx(className, {
    'manifest-numberfield': true,
    [`manifest-numberfield--${size}`]: size
  });
  return /*#__PURE__*/jsx(NumberFieldBase, _objectSpread(_objectSpread({}, other), {}, {
    ref: forwardedRef,
    className: classes,
    helperTextProps: mergeProps$1(descriptionProps, errorMessageProps, helperTextProps),
    inputProps: mergeProps$1(inputProps, inputPropsProp),
    inputRef: mergeRefs$1(fieldRef, inputRef),
    labelProps: mergeProps$1(labelProps, labelPropsProp)
  }));
});
const useStyles$7 = css({
  $$backgroundColor: 'transparent',
  alignItems: 'center',
  backgroundColor: '$$backgroundColor',
  borderRadius: '$full',
  boxSizing: 'border-box',
  display: 'inline-flex',
  padding: '2px',
  position: 'relative',
  '.manifest-pill__icon': {
    alignItems: 'center',
    borderRadius: '$full',
    color: '$palette-white',
    display: 'flex',
    fontSize: '$medium',
    justifyContent: 'center',
    size: 20,
    '> .manifest-icon': {
      fontSize: '$medium'
    }
  },
  '.manifest-pill__text': {
    backgroundColor: '$$backgroundColor',
    borderRadius: '$full',
    paddingLeft: '$x-small',
    paddingRight: pxToRem(6),
    width: 'max-content'
  },
  variants: {
    colorScheme: {
      indigo: {
        $$backgroundColor: '$colors$palette-indigo-50',
        '.manifest-pill__text': {
          color: '$palette-indigo-700'
        },
        '.manifest-pill__icon': {
          backgroundColor: '$palette-indigo-700'
        }
      },
      red: {
        $$backgroundColor: '$colors$palette-red-50',
        '.manifest-pill__text': {
          color: '$palette-red-600'
        },
        '.manifest-pill__icon': {
          backgroundColor: '$palette-red-600'
        }
      }
    },
    isCollapsible: {
      true: {
        '.manifest-pill__text': {
          borderBottomLeftRadius: 0,
          borderTopLeftRadius: 0,
          left: 24,
          position: 'absolute',
          paddingLeft: pxToRem(2),
          py: pxToRem(3)
        }
      }
    },
    isOpen: {
      true: {}
    }
  },
  compoundVariants: [{
    isCollapsible: true,
    isOpen: true,
    css: {
      borderBottomRightRadius: 0,
      borderTopRightRadius: 0
    }
  }],
  defaultVariants: {
    colorScheme: 'indigo'
  }
});
const Pill = createComponent((props, forwaredRef) => {
  const _props$as15 = props.as,
    Comp = _props$as15 === void 0 ? 'div' : _props$as15,
    classNameProp = props.className,
    _props$colorScheme = props.colorScheme,
    colorScheme = _props$colorScheme === void 0 ? 'indigo' : _props$colorScheme,
    css = props.css,
    icon = props.icon,
    _props$isCollapsible = props.isCollapsible,
    isCollapsible = _props$isCollapsible === void 0 ? false : _props$isCollapsible,
    label = props.label,
    other = _objectWithoutProperties(props, _excluded56);
  const overlayRef = React.useRef(null);
  const triggerRef = React.useRef(null);
  const state = useTooltipTriggerState({
    isDisabled: !isCollapsible,
    delay: 0
  });
  const _useTooltipTrigger = useTooltipTrigger({
      isDisabled: !isCollapsible
    }, state, triggerRef),
    triggerProps = _useTooltipTrigger.triggerProps,
    contentProps = _useTooltipTrigger.tooltipProps;
  const _useOverlayPosition8 = useOverlayPosition({
      isOpen: state.isOpen,
      offset: 4,
      overlayRef,
      placement: 'end',
      targetRef: triggerRef
    }),
    positionProps = _useOverlayPosition8.overlayProps;
  const _useTooltip = useTooltip({
      isOpen: state.isOpen
    }, state),
    tooltipProps = _useTooltip.tooltipProps;
  const isOpen = isCollapsible ? state.isOpen : true;
  const _useStyles$3 = useStyles$7({
      colorScheme,
      css,
      isCollapsible,
      isOpen
    }),
    className = _useStyles$3.className;
  const classes = cx(className, classNameProp, {
    'manifest-pill': true,
    'manifest-pill--open': isOpen,
    'manifest-pill--collapsible': isCollapsible
  });
  return /*#__PURE__*/jsxs(Comp, _objectSpread(_objectSpread({}, other), {}, {
    ref: forwaredRef,
    className: classes,
    children: [icon && /*#__PURE__*/jsx("span", _objectSpread(_objectSpread({}, triggerProps), {}, {
      ref: triggerRef,
      className: "manifest-pill__icon",
      children: icon
    })), isOpen && /*#__PURE__*/jsx(Typography, _objectSpread(_objectSpread({}, mergeProps$1(contentProps, tooltipProps, isCollapsible ? positionProps : {})), {}, {
      className: "manifest-pill__text",
      variant: "captionBold",
      children: label
    }))]
  }));
});
function Portal(props) {
  const children = props.children,
    containerRef = props.containerRef;
  const _React$useState15 = React.useState(null),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    container = _React$useState16[0],
    setContainer = _React$useState16[1];
  useIsomorphicLayoutEffect(() => {
    setContainer(containerRef ? containerRef.current : document.body);
  }, [containerRef]);
  return container ? /*#__PURE__*/ReactDom.createPortal(children, container) : container;
}
const RadioGroupContext = /*#__PURE__*/createContext$1(null);
const useRadioGroupContext = () => useContext(RadioGroupContext);
const useStyles$6 = css({
  border: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: '$small',
  margin: 0,
  padding: 0,
  variants: {
    orientation: {
      horizontal: {
        flexFlow: 'row wrap'
      },
      vertical: {
        flexFlow: 'column wrap'
      }
    }
  },
  defaultVariants: {
    orientation: 'vertical'
  }
});
const RadioGroup = createComponent((props, forwardedRef) => {
  const _props$as16 = props.as,
    Comp = _props$as16 === void 0 ? 'div' : _props$as16,
    classNameProp = props.className,
    children = props.children,
    css = props.css,
    _props$orientation3 = props.orientation,
    orientation = _props$orientation3 === void 0 ? 'vertical' : _props$orientation3,
    other = _objectWithoutProperties(props, _excluded57);
  const state = useRadioGroupState(props);
  const _useRadioGroup = useRadioGroup(props, state),
    radioGroupProps = _useRadioGroup.radioGroupProps;
  const context = React.useMemo(() => ({
    state
  }), [state]);
  const _useStyles$4 = useStyles$6({
      css,
      orientation
    }),
    className = _useStyles$4.className;
  const classes = cx(className, classNameProp, {
    'manifest-radio-group': true,
    [`manifest-radio-group--${orientation}`]: orientation
  });
  return /*#__PURE__*/jsx(Comp, _objectSpread(_objectSpread({}, mergeProps$1(radioGroupProps, other)), {}, {
    ref: forwardedRef,
    className: classes,
    children: /*#__PURE__*/jsx(RadioGroupContext.Provider, {
      value: context,
      children: children
    })
  }));
});
const useStyles$5 = css({
  $$backgroundColor: '$colors$palette-white',
  $$borderColor: '$colors$palette-grey-500',
  $$indicatorSize: pxToRem(14),
  alignItems: 'center',
  boxSizing: 'border-box',
  display: 'inline-flex',
  justifyContent: 'flex-start',
  position: 'relative',
  width: 'auto',
  '.manifest-radio__control': {
    alignItems: 'center',
    backgroundColor: '$$backgroundColor',
    border: '3px solid $$borderColor',
    borderRadius: '$full',
    boxSizing: 'border-box',
    color: '$palette-white',
    display: 'inline-flex',
    justifyContent: 'center',
    position: 'relative',
    size: pxToRem(20)
  },
  '.manifest-radio__indicator': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    position: 'relative',
    '&::after': {
      backgroundColor: '$palette-white',
      borderRadius: '$full',
      content: '""',
      display: 'block',
      size: '$$indicatorSize'
    }
  },
  '.manifest-radio__input': {
    cursor: 'pointer',
    height: '100%',
    left: 0,
    margin: 0,
    opacity: 0,
    padding: 0,
    position: 'absolute',
    top: 0,
    width: '100%'
  },
  '.manifest-radio__text': {
    marginLeft: '$small'
  },
  variants: {
    isChecked: {
      true: {
        $$backgroundColor: '$colors$primary-default',
        $$borderColor: 'transparent',
        $$indicatorSize: pxToRem(10)
      }
    },
    isDisabled: {
      true: {
        cursor: 'not-allowed',
        opacity: 0.58,
        pointerEvents: 'none'
      }
    },
    isFocusVisible: {
      true: {
        '.manifest-radio__control': {
          '&:after': {
            backgroundColor: 'transparent',
            border: '2px solid $colors$palette-indigo-200',
            borderRadius: '$full',
            bottom: '-7px',
            content: '',
            display: 'block',
            left: '-7px',
            position: 'absolute',
            right: '-7px',
            top: '-7px'
          }
        }
      }
    },
    isHovered: {
      true: {
        $$borderColor: '$colors$palette-grey-600'
      }
    }
  },
  compoundVariants: [{
    isChecked: true,
    isHovered: true,
    css: {
      $$borderColor: '$colors$primary-default'
    }
  }]
});
const Radio = createComponent((props, forwardedRef) => {
  const _props$as17 = props.as,
    Comp = _props$as17 === void 0 ? 'label' : _props$as17,
    autoFocus = props.autoFocus,
    children = props.children,
    css = props.css,
    classNameProp = props.className,
    isDisabled = props.isDisabled;
  const inputRef = React.useRef(null);
  const _useRadioGroupContext = useRadioGroupContext(),
    state = _useRadioGroupContext.state;
  const _useRadio = useRadio(props, state, inputRef),
    inputProps = _useRadio.inputProps;
  const _useFocusRing13 = useFocusRing({
      autoFocus
    }),
    isFocusVisible = _useFocusRing13.isFocusVisible,
    focusProps = _useFocusRing13.focusProps;
  const _useHover15 = useHover({
      isDisabled
    }),
    isHovered = _useHover15.isHovered,
    hoverProps = _useHover15.hoverProps;
  const _usePress3 = usePress({
      isDisabled: inputProps.disabled
    }),
    pressProps = _usePress3.pressProps;
  const _useStyles$5 = useStyles$5({
      css,
      isChecked: inputProps.checked,
      isDisabled: inputProps.disabled,
      isFocusVisible,
      isHovered
    }),
    className = _useStyles$5.className;
  const classes = cx(className, classNameProp, {
    'manifest-radio': true,
    'manifest-radio--checked': inputProps.checked,
    'manifest-radio--disabled': inputProps.disabled
  });
  return /*#__PURE__*/jsxs(Comp, _objectSpread(_objectSpread({}, mergeProps$1(hoverProps, pressProps)), {}, {
    ref: forwardedRef,
    className: classes,
    children: [/*#__PURE__*/jsx("input", _objectSpread(_objectSpread({}, mergeProps$1(inputProps, focusProps)), {}, {
      ref: inputRef,
      className: "manifest-radio__input"
    })), /*#__PURE__*/jsx("div", {
      className: "manifest-radio__control",
      children: /*#__PURE__*/jsx("span", {
        className: "manifest-radio__indicator"
      })
    }), children && /*#__PURE__*/jsx(Typography, {
      className: "manifest-radio__text",
      variant: "subtext",
      children: children
    })]
  }));
});
const VisuallyHidden = createComponent((props, forwardedRef) => {
  const _props$as18 = props.as,
    Comp = _props$as18 === void 0 ? 'div' : _props$as18,
    isFocusable = props.isFocusable,
    other = _objectWithoutProperties(props, _excluded58);
  const _useVisuallyHidden2 = useVisuallyHidden(props),
    visuallyHiddenProps = _useVisuallyHidden2.visuallyHiddenProps;
  return /*#__PURE__*/jsx(Comp, _objectSpread(_objectSpread({}, mergeProps$1(visuallyHiddenProps, other)), {}, {
    ref: forwardedRef
  }));
});
const _createContext9 = createContext({
    name: 'SegmentedControlContext'
  }),
  _createContext10 = _slicedToArray(_createContext9, 2),
  SegmentedControlProvider = _createContext10[0],
  useSegmentedControl = _createContext10[1];
const StyledSegment = styled('label', {
  alignItems: 'center',
  appearance: 'none',
  backgroundColor: 'transparent',
  border: 'none',
  borderRadius: '$full',
  boxSizing: 'border-box',
  color: '$text-primary',
  cursor: 'pointer',
  display: 'inline-flex',
  outline: 'none',
  position: 'relative',
  p: '$small $x-small',
  typography: '$subtext',
  userSelect: 'none',
  whiteSpace: 'nowrap',
  '&.manifest-segment': {
    '&:active': {
      backgroundColor: '$palette-white',
      color: '$text-primary'
    },
    '&:hover': {
      backgroundColor: '$palette-grey-200'
    },
    '&--selected': {
      backgroundColor: '$palette-white',
      typography: '$subtext-bold',
      '&:hover, &:active': {
        backgroundColor: '$palette-white',
        color: '$text-primary'
      }
    },
    '&--focus-visible': {
      '&:after': {
        backgroundColor: 'transparent',
        border: '2px solid $colors$palette-indigo-200',
        borderRadius: '$full',
        bottom: '-4px',
        content: '',
        display: 'block',
        left: '-4px',
        position: 'absolute',
        right: '-4px',
        top: '-4px'
      }
    }
  },
  '.manifest-segment__text': {
    px: '$small'
  },
  '.manifest-segment__start-adornment': {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    marginLeft: '$small'
  },
  '.manifest-segment__end-adornment': {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    marginRight: '$small'
  }
});
const Segment = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const as = props.as,
    autoFocus = props.autoFocus,
    classNameProp = props.className,
    css = props.css,
    label = props.label,
    endAdornment = props.endAdornment,
    startAdornment = props.startAdornment,
    value = props.value,
    other = _objectWithoutProperties(props, _excluded59);
  const inputRef = React.useRef(null);
  const state = useSegmentedControl();
  const _useRadio2 = useRadio(props, state, inputRef),
    inputProps = _useRadio2.inputProps;
  const _useFocusRing14 = useFocusRing({
      autoFocus
    }),
    isFocusVisible = _useFocusRing14.isFocusVisible,
    focusProps = _useFocusRing14.focusProps;
  const _useHover16 = useHover({}),
    isHovered = _useHover16.isHovered,
    hoverProps = _useHover16.hoverProps;
  const _usePress4 = usePress({}),
    pressProps = _usePress4.pressProps,
    isPressed = _usePress4.isPressed;
  const isSelected = state.selectedValue === value;
  const className = cx('manifest-segment', {
    'manifest-segment--active': isPressed,
    'manifest-segment--hover': isHovered,
    'manifest-segment--focus-visible': isFocusVisible,
    'manifest-segment--selected': isSelected
  }, classNameProp);
  return /*#__PURE__*/jsxs(StyledSegment, _objectSpread(_objectSpread({}, mergeProps$1(hoverProps, pressProps, other)), {}, {
    ref: forwardedRef,
    as: as,
    className: className,
    css: css,
    children: [/*#__PURE__*/jsx(VisuallyHidden, {
      children: /*#__PURE__*/jsx("input", _objectSpread(_objectSpread({}, mergeProps$1(inputProps, focusProps)), {}, {
        ref: inputRef
      }))
    }), startAdornment && /*#__PURE__*/jsx("div", {
      className: "manifest-segment__start-adornment",
      children: startAdornment
    }), /*#__PURE__*/jsx("div", {
      className: "manifest-segment__text",
      children: label
    }), endAdornment && /*#__PURE__*/jsx("div", {
      className: "manifest-segment__end-adornment",
      children: endAdornment
    })]
  }));
});
const StyledSegmentedControl = styled('div', {
  alignItems: 'center',
  backgroundColor: '$background-secondary',
  borderRadius: '$full',
  boxSizing: 'border-box',
  display: 'grid',
  gridAutoColumns: 'min-content',
  gridAutoFlow: 'column',
  gap: '$x-small',
  padding: '$x-small'
});
const SegmentedControl = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const as = props.as,
    children = props.children,
    classNameProp = props.className,
    css = props.css;
  const state = useRadioGroupState(props);
  const _useRadioGroup2 = useRadioGroup(props, state),
    radioGroupProps = _useRadioGroup2.radioGroupProps;
  const className = cx('manifest-segmented-control', classNameProp);
  return /*#__PURE__*/jsx(SegmentedControlProvider, {
    value: state,
    children: /*#__PURE__*/jsx(StyledSegmentedControl, _objectSpread(_objectSpread({
      ref: forwardedRef,
      as: as,
      className: className,
      css: css
    }, radioGroupProps), {}, {
      children: children
    }))
  });
});
const useStyles$4 = css({
  $$backgroundColor: '$colors$background-primary',
  $$borderColor: '$colors$palette-grey-500',
  $$iconColor: '$colors$text-tertiary',
  $$textColor: '$colors$text-primary',
  '.manifest-select__wrapper': {
    display: 'flex',
    minWidth: pxToRem(48),
    position: 'relative',
    width: '100%'
  },
  '.manifest-select__icon': {
    alignItems: 'center',
    color: '$$iconColor',
    display: 'inline-flex',
    justifyContent: 'center',
    padding: '$small',
    pointerEvents: 'none',
    position: 'absolute',
    top: 0,
    zIndex: 2
  },
  '.manifest-select__icon--end': {
    right: 0
  },
  '.manifest-select__icon--start': {
    left: 0
  },
  '.manifest-select__input': {
    appearance: 'none',
    backgroundColor: '$$backgroundColor',
    border: '1px solid $$borderColor',
    borderRadius: '$small',
    boxSizing: 'border-box',
    color: '$$textColor',
    cursor: 'default',
    margin: 0,
    outline: 0,
    padding: `${pxToRem(7)} $small`,
    paddingRight: pxToRem(40),
    textAlign: 'start',
    width: '100%'
  },
  '.manifest-select__text': {
    color: '$text-tertiary'
  },
  variants: {
    hasStartIcon: {
      true: {
        '.manifest-select__input': {
          paddingLeft: pxToRem(40)
        }
      }
    },
    isActive: {
      true: {
        $$borderColor: '$colors$primary-active',
        $$iconColor: '$colors$text-secondary',
        $$textColor: '$colors$text-primary'
      }
    },
    isDisabled: {
      true: {
        $$backgroundColor: '$colors$palette-grey-50',
        $$textColor: '$colors$text-disabled',
        '.manifest-select__input': {
          cursor: 'not-allowed'
        }
      }
    },
    isFocused: {
      true: {
        $$borderColor: '$colors$primary-active',
        $$iconColor: '$colors$text-secondary',
        $$textColor: '$colors$text-primary'
      }
    },
    isFocusVisible: {
      true: {
        '.manifest-select__wrapper': {
          '&:after': {
            backgroundColor: 'transparent',
            border: '2px solid $colors$palette-indigo-200',
            // TODO: replace with design token once its defined.s
            borderRadius: '4px',
            bottom: '-3px',
            content: '',
            display: 'block',
            left: '-3px',
            position: 'absolute',
            right: '-3px',
            top: '-3px'
          }
        }
      },
      false: {}
    },
    isHovered: {
      true: {
        $$borderColor: '$colors$palette-grey-600'
      }
    },
    isInvalid: {
      true: {
        $$borderColor: '$colors$border-danger',
        $$iconColor: '$colors$text-danger',
        $$textColor: '$colors$text-danger'
      }
    },
    isPlaceholder: {
      true: {
        $$textColor: '$colors$text-tertiary'
      }
    },
    isPressed: {
      true: {
        $$borderColor: '$colors$primary-active'
      }
    },
    size: {
      medium: {
        '.manifest-select__icon': {
          fontSize: '$x-large',
          size: pxToRem(40),
          '> .manifest-icon': {
            fontSize: '$x-large'
          }
        },
        '.manifest-select__input': {
          height: pxToRem(40)
        }
      },
      small: {
        '.manifest-select__icon': {
          fontSize: pxToRem(18),
          size: pxToRem(34),
          '> .manifest-icon': {
            fontSize: pxToRem(18)
          }
        },
        '.manifest-select__input': {
          height: pxToRem(34)
        }
      }
    }
  },
  defaultVariants: {
    size: 'medium'
  }
});
const Select = createComponent((props, forwardedRef) => {
  const _props$as19 = props.as,
    Comp = _props$as19 === void 0 ? 'div' : _props$as19,
    autoComplete = props.autoComplete,
    autoFocus = props.autoFocus,
    classNameProp = props.className,
    containerRefProp = props.containerRef,
    css = props.css,
    isDisabled = props.isDisabled,
    isRequired = props.isRequired,
    helperText = props.helperText,
    _props$helperTextProp8 = props.helperTextProps,
    helperTextProps = _props$helperTextProp8 === void 0 ? {} : _props$helperTextProp8,
    label = props.label,
    _props$labelProps9 = props.labelProps,
    labelPropsProp = _props$labelProps9 === void 0 ? {} : _props$labelProps9,
    name = props.name,
    maxHeight = props.maxHeight,
    _props$offset8 = props.offset,
    offset = _props$offset8 === void 0 ? 4 : _props$offset8,
    placeholder = props.placeholder,
    _props$placement8 = props.placement,
    placement = _props$placement8 === void 0 ? 'bottom start' : _props$placement8,
    _props$shouldFlip7 = props.shouldFlip,
    shouldFlip = _props$shouldFlip7 === void 0 ? true : _props$shouldFlip7,
    validationState = props.validationState,
    _props$size9 = props.size,
    size = _props$size9 === void 0 ? 'medium' : _props$size9,
    startIcon = props.startIcon;
  const containerRef = React.useRef(null);
  const triggerRef = React.useRef(null);
  const listBoxRef = React.useRef(null);
  const popoverRef = React.useRef(null);
  const state = useSelectState(props);
  const _useSelect = useSelect(props, state, triggerRef),
    labelProps = _useSelect.labelProps,
    triggerProps = _useSelect.triggerProps,
    valueProps = _useSelect.valueProps,
    menuProps = _useSelect.menuProps,
    descriptionProps = _useSelect.descriptionProps,
    errorMessageProps = _useSelect.errorMessageProps;
  const _useOverlayPosition9 = useOverlayPosition({
      isOpen: state.isOpen,
      maxHeight,
      offset,
      onClose: state.close,
      overlayRef: popoverRef,
      placement,
      shouldFlip,
      scrollRef: listBoxRef,
      targetRef: containerRef
    }),
    overlayProps = _useOverlayPosition9.overlayProps;
  const isInvalid = validationState === 'invalid';
  const _useButton11 = useButton(triggerProps, triggerRef),
    buttonProps = _useButton11.buttonProps,
    isPressed = _useButton11.isPressed;
  const _useFocusRing15 = useFocusRing({
      autoFocus
    }),
    isFocusVisible = _useFocusRing15.isFocusVisible,
    isFocused = _useFocusRing15.isFocused,
    focusProps = _useFocusRing15.focusProps;
  const _useHover17 = useHover({
      isDisabled
    }),
    hoverProps = _useHover17.hoverProps,
    isHovered = _useHover17.isHovered;
  const handleClose = React.useCallback(() => void state.close(), [state]);
  const _useStyles$6 = useStyles$4({
      hasStartIcon: Boolean(startIcon),
      isActive: state.isOpen,
      isDisabled,
      isFocused,
      isFocusVisible,
      isHovered,
      isInvalid,
      isPlaceholder: !state.selectedItem,
      isPressed,
      size,
      css
    }),
    className = _useStyles$6.className;
  const classes = cx(className, classNameProp, {
    'manifest-select': true,
    'manifest-select--disabled': isDisabled,
    'manifest-select--invalid': isInvalid,
    [`manifest-select--${size}`]: size
  });
  const containerDimensions = containerRef.current?.getBoundingClientRect();
  return /*#__PURE__*/jsx(FormControl, {
    className: classes,
    helperText: helperText,
    helperTextProps: mergeProps$1(descriptionProps, errorMessageProps, helperTextProps),
    isRequired: isRequired,
    label: label,
    labelProps: mergeProps$1(labelProps, labelPropsProp),
    validationState: validationState,
    children: /*#__PURE__*/jsxs(Comp, {
      ref: mergeRefs$1(containerRef, forwardedRef),
      className: "manifest-select__wrapper",
      children: [startIcon && /*#__PURE__*/jsx("span", {
        className: cx('manifest-select__icon', 'manifest-select__icon--start'),
        children: startIcon
      }), /*#__PURE__*/jsx(HiddenSelect, {
        autoComplete: autoComplete,
        isDisabled: isDisabled,
        label: label,
        name: name,
        state: state,
        triggerRef: triggerRef
      }), /*#__PURE__*/jsx("button", _objectSpread(_objectSpread({}, mergeProps$1(buttonProps, focusProps, hoverProps)), {}, {
        ref: triggerRef,
        className: "manifest-select__input",
        children: /*#__PURE__*/jsx(Typography, _objectSpread(_objectSpread({}, valueProps), {}, {
          variant: "subtext",
          children: state.selectedItem ? state.selectedItem.rendered : placeholder
        }))
      })), /*#__PURE__*/jsx("span", {
        className: cx('manifest-select__icon', 'manifest-select__icon--end'),
        children: /*#__PURE__*/jsx(Icon, {
          icon: "expand_more"
        })
      }), /*#__PURE__*/jsx(Overlay, {
        containerRef: containerRefProp,
        isOpen: state.isOpen && !isDisabled,
        children: /*#__PURE__*/jsx(Popover, _objectSpread(_objectSpread({}, overlayProps), {}, {
          ref: popoverRef,
          className: "manifest-combobox__popover",
          css: {
            left: containerDimensions?.left,
            width: containerDimensions?.width
          },
          isOpen: state.isOpen,
          onClose: handleClose,
          children: /*#__PURE__*/jsx(ListBoxBase, _objectSpread(_objectSpread({}, menuProps), {}, {
            ref: listBoxRef,
            disallowEmptySelection: true,
            className: "manifest-select__list-box",
            state: state
          }))
        }))
      })]
    })
  });
});
const SelectItem = Item;
const SelectSection = Section;
const _createContext11 = createContext({
    name: 'NavigationContext'
  }),
  _createContext12 = _slicedToArray(_createContext11, 2),
  NavigationProvider = _createContext12[0],
  useNavigation = _createContext12[1];
const StyledNavigation = styled('div', {
  $$sideNavWidth: pxToRem(240),
  boxSizing: 'border-box',
  flex: '0 0 auto',
  overflowX: 'hidden',
  position: 'relative',
  transition: 'width 200ms cubic-bezier(0.4, 0.14, 0.3, 1) 0ms',
  whiteSpace: 'nowrap',
  width: '$$sideNavWidth',
  '.manifest-navigation__container': {
    backgroundColor: '$background-primary',
    bottom: 0,
    display: 'flex',
    flex: '1 0 auto',
    flexDirection: 'column',
    left: 0,
    outline: 0,
    overflowX: 'hidden',
    overflowY: 'auto',
    position: 'absolute',
    top: 0,
    transition: 'width 200ms cubic-bezier(0.4, 0.14, 0.3, 1) 0ms',
    width: '$$sideNavWidth',
    zIndex: '$sticky'
  },
  variants: {
    isOpen: {
      true: {
        $$sideNavWidth: pxToRem(240)
      },
      false: {
        $$sideNavWidth: pxToRem(56)
      }
    },
    isHovered: {
      true: {},
      false: {}
    }
  }
});
const SideNavigation = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const as = props.as,
    children = props.children,
    classNameProp = props.className,
    css = props.css,
    defaultOpen = props.defaultOpen,
    isOpenProp = props.isOpen,
    _props$onOpenChange = props.onOpenChange,
    onOpenChange = _props$onOpenChange === void 0 ? noop : _props$onOpenChange,
    other = _objectWithoutProperties(props, _excluded60);
  const _useControlledState3 = useControlledState(isOpenProp, defaultOpen ?? true, onOpenChange),
    _useControlledState4 = _slicedToArray(_useControlledState3, 2),
    isOpen = _useControlledState4[0],
    setOpen = _useControlledState4[1];
  const _React$useState17 = React.useState(false),
    _React$useState18 = _slicedToArray(_React$useState17, 2),
    isHovered = _React$useState18[0],
    setIsHovered = _React$useState18[1];
  const handleMouseEnter = React.useCallback(() => void setIsHovered(true), []);
  const handleMouseLeave = React.useCallback(() => void setIsHovered(false), []);

  // Handle an issue with safari and edge not trigger mouse leave events when the side
  // navigation width changes.
  const handleExited = React.useCallback(() => void setIsHovered(false), []);
  const context = React.useMemo(() => ({
    isHovered,
    isOpen,
    onOpenChange: setOpen
  }), [isHovered, isOpen, setOpen]);
  const className = cx('manifest-navigation', classNameProp, {
    'manifest-navigation--closed': !isOpen,
    'manifest-navigation--open': isOpen
  });
  return /*#__PURE__*/jsx(NavigationProvider, {
    value: context,
    children: /*#__PURE__*/jsx(Transition, {
      in: isOpen,
      onExited: handleExited,
      children: /*#__PURE__*/jsx(StyledNavigation, _objectSpread(_objectSpread({}, other), {}, {
        ref: forwardedRef,
        as: as,
        className: className,
        css: css,
        isOpen: isOpen,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        children: /*#__PURE__*/jsx("div", {
          className: "manifest-navigation__container",
          children: children
        })
      }))
    })
  });
});
const StyledSideNavigationContent = styled('div', {
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  flex: '1 1 auto',
  px: '$x-small'
});
const SideNavigationContent = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const as = props.as,
    children = props.children,
    classNameProp = props.className,
    css = props.css,
    other = _objectWithoutProperties(props, _excluded61);
  const className = cx('manifest-navigation-content', classNameProp);
  return /*#__PURE__*/jsx(StyledSideNavigationContent, _objectSpread(_objectSpread({}, other), {}, {
    ref: forwardedRef,
    as: as,
    className: className,
    css: css,
    children: children
  }));
});
const StyledSideNavigationFooterContent = styled('div', {
  alignItems: 'flex-start',
  boxSizing: 'border-box',
  display: 'flex',
  flex: '1 1 auto',
  flexDirection: 'column',
  px: pxToRem(12)
});
const StyledSideNavigationFooterIcon = styled(ChevronDown, {
  color: '$text-secondary',
  transition: 'transform 100ms cubic-bezier(0.4, 0.14, 0.3, 1) 0ms'
});
const StyledSideNavigationFooter = styled('button', {
  alignItems: 'center',
  appearance: 'none',
  backgroundColor: 'transparent',
  border: 'none',
  borderTop: '1px solid $colors$border-primary',
  boxSizing: 'border-box',
  color: '$text-primary',
  cursor: 'pointer',
  display: 'inline-flex',
  fontSize: '$small',
  fontWeight: '$semibold',
  justifyContent: 'flex-start',
  letterSpacing: '$medium',
  lineHeight: '$small',
  minHeight: pxToRem(64),
  position: 'relative',
  paddingLeft: '$small',
  paddingRight: '$medium',
  outline: 'none',
  overflow: 'hidden',
  userSelect: 'none',
  whiteSpace: 'nowrap',
  '&[aria-expanded="true"]': {
    backgroundColor: '$background-secondary',
    [`& ${StyledSideNavigationFooterIcon}`]: {
      color: '$text-primary',
      transform: 'rotate(180deg)'
    }
  },
  variants: {
    isHovered: {
      true: {
        backgroundColor: '$background-secondary'
      }
    }
  }
});
const SideNavigationFooter = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const as = props.as,
    avatarProps = props.avatarProps,
    children = props.children,
    classNameProp = props.className,
    css = props.css,
    subTitle = props.subTitle,
    title = props.title,
    other = _objectWithoutProperties(props, _excluded62);
  const buttonRef = React.useRef(null);
  const _useButton12 = useButton(other, buttonRef),
    buttonProps = _useButton12.buttonProps;
  const _useHover18 = useHover({}),
    hoverProps = _useHover18.hoverProps,
    isHovered = _useHover18.isHovered;
  const className = cx('manifest-navigation-footer', classNameProp);
  return /*#__PURE__*/jsxs(StyledSideNavigationFooter, _objectSpread(_objectSpread({}, mergeProps(buttonProps, hoverProps)), {}, {
    ref: forwardedRef,
    as: as,
    className: className,
    css: css,
    isHovered: isHovered,
    children: [/*#__PURE__*/jsx(Avatar, _objectSpread({
      className: "manifest-navigation-footer__avatar"
    }, avatarProps)), /*#__PURE__*/jsxs(StyledSideNavigationFooterContent, {
      className: "manifest-navigation-footer__content",
      children: [/*#__PURE__*/jsx(Typography, {
        className: "manifest-navigation-footer__title",
        variant: "subtextBold",
        children: title
      }), subTitle && /*#__PURE__*/jsx(Typography, {
        className: "manifest-navigation-footer__sub-title",
        variant: "caption",
        children: subTitle
      })]
    }), /*#__PURE__*/jsx(StyledSideNavigationFooterIcon, {
      className: "manifest-navigation-footer__icon"
    })]
  }));
});
const StyledSideNavigationHeaderLogo = styled('div', {
  alignItems: 'center',
  boxSizing: 'border-box',
  display: 'flex',
  justifyContent: 'center',
  left: 0,
  position: 'absolute',
  size: pxToRem(56),
  top: 0
});
const StyledSideNavigationHeaderContent = styled('div', {
  boxSizing: 'border-box',
  display: 'flex',
  flex: '1 1 auto'
});
const StyledSideNavigationHeaderButton = styled(IconButton, {
  color: '$text-secondary',
  position: 'absolute',
  right: pxToRem(8),
  top: pxToRem(8),
  transition: 'all 100ms cubic-bezier(0.4, 0.14, 0.3, 1) 0ms'
});
const StyledSideNavigationHeader = styled('div', {
  boxSizing: 'border-box',
  color: '$text-primary',
  display: 'flex',
  alignItems: 'center',
  minHeight: pxToRem(56),
  position: 'relative',
  px: '$x-small',
  [`${StyledSideNavigationHeaderButton}`]: {
    backgroundColor: '$background-primary',
    '&:hover': {
      backgroundColor: '$palette-grey-100'
    }
  },
  variants: {
    isOpen: {
      true: {
        [`${StyledSideNavigationHeaderButton}`]: {
          opacity: 1,
          visibility: 'visible'
        }
      },
      false: {
        [`${StyledSideNavigationHeaderButton}`]: {
          opacity: 0,
          visibility: 'hidden'
        }
      }
    },
    isHovered: {
      true: {}
    }
  },
  compoundVariants: [{
    isHovered: true,
    isOpen: false,
    css: {
      [`${StyledSideNavigationHeaderButton}`]: {
        opacity: 1,
        visibility: 'visible'
      }
    }
  }]
});
const SideNavigationHeader = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const as = props.as,
    children = props.children,
    classNameProp = props.className,
    css = props.css,
    logo = props.logo,
    other = _objectWithoutProperties(props, _excluded63);
  const _useNavigation = useNavigation(),
    isOpen = _useNavigation.isOpen,
    isHovered = _useNavigation.isHovered,
    onOpenChange = _useNavigation.onOpenChange;
  const handleToggle = React.useCallback(() => {
    onOpenChange(!isOpen);
  }, [isOpen, onOpenChange]);
  const className = cx('manifest-navigation-header', classNameProp);
  return /*#__PURE__*/jsxs(StyledSideNavigationHeader, _objectSpread(_objectSpread({}, other), {}, {
    ref: forwardedRef,
    as: as,
    className: className,
    css: css,
    isHovered: isHovered,
    isOpen: isOpen,
    children: [/*#__PURE__*/jsx(StyledSideNavigationHeaderLogo, {
      className: "manifest-navigation-header__logo",
      children: logo
    }), /*#__PURE__*/jsx(StyledSideNavigationHeaderContent, {
      className: "manifest-navigation-header__content",
      children: children
    }), /*#__PURE__*/jsx(StyledSideNavigationHeaderButton, {
      className: "manifest-navigation-header__button",
      variant: "tertiary",
      onPress: handleToggle,
      children: isOpen ? /*#__PURE__*/jsx(Expanded, {}) : /*#__PURE__*/jsx(Collapsed, {})
    })]
  }));
});
const SideNavigationMenu = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const classNameProp = props.className,
    other = _objectWithoutProperties(props, _excluded64);
  const className = cx('manifest-navigation-menu', classNameProp);
  return /*#__PURE__*/jsx(Menu, _objectSpread(_objectSpread({}, other), {}, {
    ref: forwardedRef,
    className: className
  }));
});
const StyledMenuGroup = styled(MenuGroup, {
  variants: {
    isOpen: {
      true: {
        '.manifest-menu-item__label, .manifest-menu-item__icon--end': {
          opacity: 1
        }
      },
      false: {
        '.manifest-menu-item__label, .manifest-menu-item__icon--end': {
          opacity: 0
        }
      }
    }
  }
});
const SideNavigationMenuGroup = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const classNameProp = props.className,
    isExpandedProp = props.isExpanded,
    other = _objectWithoutProperties(props, _excluded65);
  const _useNavigation2 = useNavigation(),
    isOpen = _useNavigation2.isOpen;
  const className = cx('manifest-navigation-menu-group', classNameProp);
  return /*#__PURE__*/jsx(StyledMenuGroup, _objectSpread(_objectSpread({}, other), {}, {
    ref: forwardedRef,
    className: className,
    isExpanded: !isOpen ? false : undefined,
    isOpen: isOpen
  }));
});
const StyledMenuItem = styled(MenuItem, {
  variants: {
    isOpen: {
      true: {
        '.manifest-menu-item__label': {
          opacity: 1
        }
      },
      false: {
        '.manifest-menu-item__label': {
          opacity: 0
        }
      }
    }
  }
});
const SideNavigationMenuItem = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const classNameProp = props.className,
    other = _objectWithoutProperties(props, _excluded66);
  const _useNavigation3 = useNavigation(),
    isOpen = _useNavigation3.isOpen;
  const className = cx('manifest-navigation-menu-item', classNameProp);
  return /*#__PURE__*/jsx(StyledMenuItem, _objectSpread(_objectSpread({}, other), {}, {
    ref: forwardedRef,
    className: className,
    isOpen: isOpen
  }));
});
const useStyles$3 = css({
  $$switchBackgroundColor: '$colors$palette-grey-500',
  alignItems: 'center',
  boxSizing: 'border-box',
  display: 'inline-flex',
  justifyContent: 'flex-start',
  position: 'relative',
  width: 'auto',
  '.manifest-switch__control': {
    alignItems: 'center',
    backgroundColor: '$$switchBackgroundColor',
    borderRadius: '$full',
    boxSizing: 'border-box',
    color: '$palette-white',
    cursor: 'pointer',
    display: 'inline-flex',
    height: pxToRem(24),
    margin: 0,
    padding: 0,
    position: 'relative',
    width: pxToRem(44)
  },
  '.manifest-switch__indicator': {
    backgroundColor: '$palette-white',
    borderRadius: '$full',
    display: 'block',
    size: pxToRem(18),
    transform: 'translateX(3px)',
    transition: '$transform',
    willChange: 'transform'
  },
  '.manifest-switch__input': {
    cursor: 'pointer',
    height: '100%',
    left: 0,
    margin: 0,
    opacity: 0,
    padding: 0,
    position: 'absolute',
    top: 0,
    width: '100%'
  },
  '.manifest-switch__text': {
    marginLeft: '$small'
  },
  variants: {
    isChecked: {
      true: {
        $$switchBackgroundColor: '$colors$primary-default',
        '.manifest-switch__indicator': {
          transform: 'translateX(23px)'
        }
      }
    },
    isDisabled: {
      true: {
        cursor: 'not-allowed',
        opacity: 0.58,
        pointerEvents: 'none'
      }
    },
    isFocusVisible: {
      true: {
        '.manifest-switch__control': {
          '&:after': {
            backgroundColor: 'transparent',
            border: '2px solid $colors$palette-indigo-200',
            borderRadius: '$full',
            bottom: '-4px',
            content: '',
            display: 'block',
            left: '-4px',
            position: 'absolute',
            right: '-4px',
            top: '-4px'
          }
        }
      }
    },
    isHovered: {
      true: {
        $$switchBackgroundColor: '$colors$palette-grey-600'
      }
    }
  }
});
const Switch = createComponent((props, forwardedRef) => {
  const _props$as20 = props.as,
    Comp = _props$as20 === void 0 ? 'label' : _props$as20,
    autoFocus = props.autoFocus,
    children = props.children,
    classNameProp = props.className,
    css = props.css,
    isDisabled = props.isDisabled;
  const inputRef = React.useRef(null);
  const state = useToggleState(props);
  const isChecked = state.isSelected;
  const _useSwitch = useSwitch(props, state, inputRef),
    inputProps = _useSwitch.inputProps;
  const _useHover19 = useHover({
      isDisabled
    }),
    hoverProps = _useHover19.hoverProps,
    isHovered = _useHover19.isHovered;
  const _useFocusRing16 = useFocusRing({
      autoFocus
    }),
    focusProps = _useFocusRing16.focusProps,
    isFocusVisible = _useFocusRing16.isFocusVisible;
  const _usePress5 = usePress({
      isDisabled: inputProps.disabled
    }),
    pressProps = _usePress5.pressProps;
  const _useStyles$7 = useStyles$3({
      css,
      isChecked,
      isDisabled,
      isFocusVisible,
      isHovered
    }),
    className = _useStyles$7.className;
  const classes = cx(className, classNameProp, {
    'manifest-switch': true,
    'manifest-switch--checked': isChecked,
    'manifest-switch--disabled': isDisabled
  });
  return /*#__PURE__*/jsxs(Comp, _objectSpread(_objectSpread({}, mergeProps$1(hoverProps, pressProps)), {}, {
    ref: forwardedRef,
    className: classes,
    children: [/*#__PURE__*/jsx("input", _objectSpread(_objectSpread({}, mergeProps$1(inputProps, focusProps)), {}, {
      ref: inputRef,
      className: "manifest-switch__input"
    })), /*#__PURE__*/jsx("div", {
      className: "manifest-switch__control",
      children: /*#__PURE__*/jsx("span", {
        className: "manifest-switch__indicator"
      })
    }), children && /*#__PURE__*/jsx(Typography, {
      className: "manifest-switch__text",
      variant: "subtext",
      children: children
    })]
  }));
});
const TableContext = /*#__PURE__*/React.createContext({});
const useTableContext = () => React.useContext(TableContext);
const StyledTable = styled('table', table);
const Table = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const as = props.as,
    children = props.children,
    classNameProp = props.className,
    css = props.css,
    _props$isDense = props.isDense,
    isDense = _props$isDense === void 0 ? false : _props$isDense,
    _props$showHover = props.showHover,
    showHover = _props$showHover === void 0 ? false : _props$showHover,
    onMouseEnter = props.onMouseEnter,
    onMouseLeave = props.onMouseLeave,
    other = _objectWithoutProperties(props, _excluded67);
  const className = cx('manifest-table', classNameProp);
  const context = React.useMemo(() => ({
    isDense,
    onMouseEnter,
    onMouseLeave,
    showHover
  }), [isDense, onMouseEnter, onMouseLeave, showHover]);
  return /*#__PURE__*/jsx(StyledTable, _objectSpread(_objectSpread({}, other), {}, {
    ref: forwardedRef,
    as: as,
    className: className,
    css: css,
    children: /*#__PURE__*/jsx(TableContext.Provider, {
      value: context,
      children: children
    })
  }));
});
const StyledTableBody = styled('tbody', tableBody);
const TableBody = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const as = props.as,
    children = props.children,
    classNameProp = props.className,
    css = props.css,
    other = _objectWithoutProperties(props, _excluded68);
  const className = cx('manifest-table-body', classNameProp);
  return /*#__PURE__*/jsx(StyledTableBody, _objectSpread(_objectSpread({}, other), {}, {
    ref: forwardedRef,
    as: as,
    className: className,
    css: css,
    children: children
  }));
});
const StyledTableCell = styled('td', tableCell);
const TableCell = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const as = props.as,
    _props$align = props.align,
    align = _props$align === void 0 ? 'left' : _props$align,
    children = props.children,
    classNameProp = props.className,
    css = props.css,
    onMouseEnter = props.onMouseEnter,
    other = _objectWithoutProperties(props, _excluded69);
  const title = typeof children === 'string' ? children : '';
  const cellRef = React.useRef(null);
  const _React$useState19 = React.useState(false),
    _React$useState20 = _slicedToArray(_React$useState19, 2),
    isOverflown = _React$useState20[0],
    setIsOverflown = _React$useState20[1];
  const _useTableContext = useTableContext(),
    isDense = _useTableContext.isDense;
  const className = cx('manifest-table-cell', classNameProp, {
    'manifest-table-cell': true,
    [`manifest-table-cell--${align}`]: align
  });
  const handleMouseEnter = React.useCallback(() => {
    const cell = cellRef?.current;
    if (cell) {
      setIsOverflown(cell.scrollWidth > cell.offsetWidth);
    }
  }, [cellRef]);
  return /*#__PURE__*/jsx(StyledTableCell, _objectSpread(_objectSpread({}, other), {}, {
    ref: mergeRefs$1(cellRef, forwardedRef),
    align: align,
    as: as,
    className: className,
    css: css,
    isDense: isDense,
    title: isOverflown ? title : undefined,
    onMouseEnter: chain(handleMouseEnter, onMouseEnter),
    children: children
  }));
});
const StyledTableColumn = styled('th', tableColumn, {
  '.manifest-table-column--icon': {
    bottom: 'calc(50% - 11px)',
    margin: '0 $x-small',
    position: 'absolute',
    transition: '$transform'
  },
  '.manifest-table-column--icon__ascending': {
    transform: 'rotate(180deg)',
    bottom: 'calc(50% - 14px)'
  }
});
const TableColumn = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const as = props.as,
    align = props.align,
    children = props.children,
    classNameProp = props.className,
    css = props.css,
    isActive = props.isActive,
    isSortable = props.isSortable,
    _props$sortDirection = props.sortDirection,
    sortDirection = _props$sortDirection === void 0 ? 'asc' : _props$sortDirection,
    other = _objectWithoutProperties(props, _excluded70);
  const className = cx(classNameProp, {
    'manifest-table-column': true,
    [`manifest-table-column--${align}`]: align
  });
  let ariaSort = null;
  if (sortDirection) {
    ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
  }
  return /*#__PURE__*/jsxs(StyledTableColumn, _objectSpread(_objectSpread({}, other), {}, {
    ref: forwardedRef,
    align: align,
    "aria-sort": isSortable ? ariaSort : undefined,
    as: as,
    className: className,
    css: css,
    isActive: isActive,
    isSortable: isSortable,
    children: [children, isSortable && isActive && /*#__PURE__*/jsx(ChevronDown, {
      "aria-hidden": true,
      className: cx('manifest-table-column--icon', {
        'manifest-table-column--icon__ascending': sortDirection === 'asc'
      })
    })]
  }));
});
const StyledTableFooter = styled('tfoot', tableFooter);
const TableFooter = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const as = props.as,
    children = props.children,
    classNameProp = props.className,
    css = props.css,
    other = _objectWithoutProperties(props, _excluded71);
  const className = cx('manifest-table-footer', classNameProp);
  return /*#__PURE__*/jsx(StyledTableFooter, _objectSpread(_objectSpread({}, other), {}, {
    ref: forwardedRef,
    as: as,
    className: className,
    css: css,
    children: children
  }));
});
const StyledTableHeader = styled('thead', tableHeader);
const TableHeader = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const as = props.as,
    children = props.children,
    classNameProp = props.className,
    css = props.css,
    other = _objectWithoutProperties(props, _excluded72);
  const className = cx('manifest-table-header', classNameProp);
  return /*#__PURE__*/jsx(StyledTableHeader, _objectSpread(_objectSpread({}, other), {}, {
    ref: forwardedRef,
    as: as,
    className: className,
    css: css,
    children: children
  }));
});
const StyledTableRow = styled('tr', tableRow, {
  variants: {
    isHovered: {
      true: {
        '.manifest-table-cell': {
          backgroundColor: '$palette-grey-50'
        }
      }
    }
  }
});
const TableRow = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const as = props.as,
    children = props.children,
    classNameProp = props.className,
    css = props.css,
    onMouseEnterProp = props.onMouseEnter,
    onMouseLeaveProp = props.onMouseLeave,
    other = _objectWithoutProperties(props, _excluded73);
  const _useTableContext2 = useTableContext(),
    onMouseEnter = _useTableContext2.onMouseEnter,
    onMouseLeave = _useTableContext2.onMouseLeave,
    showHover = _useTableContext2.showHover;
  const _React$useState21 = React.useState(false),
    _React$useState22 = _slicedToArray(_React$useState21, 2),
    isHovered = _React$useState22[0],
    setIsHovered = _React$useState22[1];
  const className = cx('manifest-table-row', classNameProp);
  const handleMouseEnter = React.useCallback(() => {
    if (!showHover) return;
    setIsHovered(true);
  }, [setIsHovered, showHover]);
  return /*#__PURE__*/jsx(StyledTableRow, _objectSpread(_objectSpread({}, other), {}, {
    ref: forwardedRef,
    as: as,
    className: className,
    css: css,
    isHovered: isHovered,
    onMouseEnter: chain(handleMouseEnter, onMouseEnter, onMouseEnterProp),
    onMouseLeave: chain(() => void setIsHovered(false), onMouseLeave, onMouseLeaveProp),
    children: children
  }));
});
const useStyles$2 = css({
  $$backgroundColor: '$colors$background-primary',
  $$borderColor: '$colors$palette-grey-500',
  $$iconColor: '$colors$text-tertiary',
  $$textColor: '$colors$text-primary',
  '.manifest-textfield-base__wrapper': {
    alignItems: 'center',
    boxSizing: 'border-box',
    display: 'inline-flex',
    justifyContent: 'flex-start',
    position: 'relative',
    width: 'auto'
  },
  '.manifest-textfield-base__icon': {
    alignItems: 'center',
    color: '$$iconColor',
    display: 'inline-flex',
    fontSize: '$x-large',
    justifyContent: 'center',
    padding: '$small',
    pointerEvents: 'none',
    position: 'absolute',
    top: 0,
    zIndex: 2,
    '> .material-icons': {
      fontSize: '$x-large'
    }
  },
  '.manifest-textfield-base__icon--end': {
    right: 0
  },
  '.manifest-textfield-base__icon--start': {
    left: 0
  },
  '.manifest-textfield-base__input': {
    appearance: 'none',
    backgroundColor: '$$backgroundColor',
    border: '1px solid $$borderColor',
    borderRadius: '$small',
    boxSizing: 'border-box',
    color: '$$textColor',
    cursor: 'text',
    fontFamily: '$text',
    margin: 0,
    outline: 0,
    padding: '$small',
    resize: 'none',
    transition: '$color',
    typography: '$subtext',
    width: '100%',
    '&::placeholder': {
      color: '$text-tertiary'
    }
  },
  variants: {
    hasEndIcon: {
      true: {
        '.manifest-textfield-base__input': {
          paddingRight: pxToRem(40)
        }
      }
    },
    hasStartIcon: {
      true: {
        '.manifest-textfield-base__input': {
          paddingLeft: pxToRem(40)
        }
      }
    },
    isDisabled: {
      true: {
        $$backgroundColor: '$colors$palette-grey-50',
        $$textColor: '$colors$text-disabled',
        cursor: 'not-allowed'
      }
    },
    isFocused: {
      true: {
        $$borderColor: '$colors$primary-default'
      }
    },
    isFocusVisible: {
      true: {
        '.manifest-textfield-base__wrapper': {
          '&:after': {
            backgroundColor: 'transparent',
            border: '2px solid $colors$palette-indigo-200',
            // TODO: replace with design token once its defined.
            borderRadius: '4px',
            bottom: '-3px',
            content: '',
            display: 'block',
            left: '-3px',
            position: 'absolute',
            right: '-3px',
            top: '-3px'
          }
        }
      },
      false: {
        boxShadow: 'none'
      }
    },
    isHovered: {
      true: {
        $$borderColor: '$colors$palette-grey-600'
      }
    },
    isInvalid: {
      true: {
        $$borderColor: '$colors$border-danger',
        $$iconColor: '$colors$text-danger',
        $$textColor: '$colors$text-danger'
      }
    }
  }
});
const TextFieldBase = createComponent((props, forwardedRef) => {
  const as = props.as,
    autoFocus = props.autoFocus,
    classNameProp = props.className,
    css = props.css,
    endIcon = props.endIcon,
    helperText = props.helperText,
    helperTextProps = props.helperTextProps,
    _props$inputProps3 = props.inputProps,
    inputProps = _props$inputProps3 === void 0 ? {} : _props$inputProps3,
    inputRef = props.inputRef,
    isDisabled = props.isDisabled,
    isRequired = props.isRequired,
    label = props.label,
    labelProps = props.labelProps,
    _props$multiline = props.multiline,
    multiline = _props$multiline === void 0 ? false : _props$multiline,
    startIcon = props.startIcon,
    validationState = props.validationState;
  const Comp = as ?? (multiline ? 'textarea' : 'input');
  const isInvalid = validationState === 'invalid';
  const fieldRef = React.useRef(null);
  const _useFocusRing17 = useFocusRing({
      autoFocus,
      isTextInput: true
    }),
    focusProps = _useFocusRing17.focusProps,
    isFocused = _useFocusRing17.isFocused,
    isFocusVisible = _useFocusRing17.isFocusVisible;
  const _useHover20 = useHover({
      isDisabled
    }),
    isHovered = _useHover20.isHovered,
    hoverProps = _useHover20.hoverProps;
  const _useStyles$8 = useStyles$2({
      hasEndIcon: Boolean(endIcon),
      hasStartIcon: Boolean(startIcon),
      isDisabled,
      isFocused,
      isFocusVisible,
      isHovered,
      isInvalid,
      css
    }),
    className = _useStyles$8.className;
  const classes = cx(className, classNameProp, {
    'manifest-textfield-base': true,
    'manifest-textfield-base--disabled': isDisabled,
    'manifest-textfield-base--invalid': isInvalid
  });
  return /*#__PURE__*/jsx(FormControl, {
    className: classes,
    helperText: helperText,
    helperTextProps: helperTextProps,
    isRequired: isRequired,
    label: label,
    labelProps: labelProps,
    validationState: validationState,
    children: /*#__PURE__*/jsxs("div", {
      ref: forwardedRef,
      className: "manifest-textfield-base__wrapper",
      children: [startIcon && /*#__PURE__*/jsx("span", {
        className: cx('manifest-textfield-base__icon', 'manifest-textfield-base__icon--start'),
        children: startIcon
      }), /*#__PURE__*/jsx(Comp, _objectSpread(_objectSpread({}, mergeProps$1(inputProps, focusProps, hoverProps)), {}, {
        ref: mergeRefs$1(fieldRef, inputRef),
        className: "manifest-textfield-base__input",
        rows: multiline ? 1 : undefined
      })), endIcon && /*#__PURE__*/jsx("span", {
        className: cx('manifest-textfield-base__icon', 'manifest-textfield-base__icon--end'),
        children: endIcon
      })]
    })
  });
});
const useStyles$1 = css({
  '.manifest-textfield-base__input': {
    minHeight: pxToRem(56)
  }
});
const TextArea = createComponent((props, forwardedRef) => {
  const classNameProp = props.className,
    _props$helperTextProp9 = props.helperTextProps,
    helperTextProps = _props$helperTextProp9 === void 0 ? {} : _props$helperTextProp9,
    _props$inputProps4 = props.inputProps,
    inputPropsProp = _props$inputProps4 === void 0 ? {} : _props$inputProps4,
    inputRef = props.inputRef,
    _props$labelProps10 = props.labelProps,
    labelPropsProp = _props$labelProps10 === void 0 ? {} : _props$labelProps10,
    onChange = props.onChange,
    other = _objectWithoutProperties(props, _excluded74);
  const areaRef = React.useRef(null);
  const _useControlledState$7 = useControlledState$1(props.value, props.defaultValue, () => {
      // noop
    }),
    _useControlledState$8 = _slicedToArray(_useControlledState$7, 2),
    inputValue = _useControlledState$8[0],
    setInputValue = _useControlledState$8[1];
  const handleHeightChange = React.useCallback(() => {
    const input = areaRef.current;
    const prevAlignment = input.style.alignSelf;
    input.style.alignSelf = 'start';
    input.style.height = 'auto';
    input.style.height = `${input.scrollHeight}px`;
    input.style.alignSelf = prevAlignment;
  }, [areaRef]);
  const _useTextField = useTextField(_objectSpread(_objectSpread({}, props), {}, {
      inputElementType: 'textarea',
      onChange: chain(onChange, setInputValue)
    }), areaRef),
    inputProps = _useTextField.inputProps,
    descriptionProps = _useTextField.descriptionProps,
    errorMessageProps = _useTextField.errorMessageProps,
    labelProps = _useTextField.labelProps;
  const _useStyles$9 = useStyles$1(),
    className = _useStyles$9.className;
  const classes = cx(className, classNameProp, {
    'manifest-textarea': true
  });
  useLayoutEffect(() => {
    if (areaRef.current) {
      handleHeightChange();
    }
  }, [handleHeightChange, inputValue, areaRef]);
  return /*#__PURE__*/jsx(TextFieldBase, _objectSpread(_objectSpread({}, other), {}, {
    ref: forwardedRef,
    multiline: true,
    className: classes,
    helperTextProps: mergeProps$1(descriptionProps, errorMessageProps, helperTextProps),
    inputProps: mergeProps$1(inputProps, inputPropsProp),
    inputRef: mergeRefs$1(areaRef, inputRef),
    labelProps: mergeProps$1(labelProps, labelPropsProp)
  }));
});
const useStyles = css({
  variants: {
    size: {
      medium: {
        '.manifest-textfield-base__icon': {
          fontSize: '$x-large',
          '> .material-icons': {
            fontSize: '$x-large'
          }
        },
        '.manifest-textfield-base__input': {
          py: pxToRem(9)
        }
      },
      small: {
        '.manifest-textfield-base__icon': {
          fontSize: pxToRem(18),
          '> .material-icons': {
            fontSize: pxToRem(18)
          }
        },
        '.manifest-textfield-base__input': {
          py: pxToRem(6)
        }
      }
    }
  },
  defaultVariants: {
    size: 'medium'
  }
});
const TextField = createComponent((props, forwardedRef) => {
  const classNameProp = props.className,
    _props$helperTextProp10 = props.helperTextProps,
    helperTextProps = _props$helperTextProp10 === void 0 ? {} : _props$helperTextProp10,
    _props$inputProps5 = props.inputProps,
    inputPropsProp = _props$inputProps5 === void 0 ? {} : _props$inputProps5,
    inputRef = props.inputRef,
    _props$labelProps11 = props.labelProps,
    labelPropsProp = _props$labelProps11 === void 0 ? {} : _props$labelProps11,
    onChange = props.onChange,
    _props$size10 = props.size,
    size = _props$size10 === void 0 ? 'medium' : _props$size10,
    other = _objectWithoutProperties(props, _excluded75);
  const fieldRef = React.useRef(null);
  const _useTextField2 = useTextField(_objectSpread(_objectSpread({}, props), {}, {
      inputElementType: 'input',
      onChange
    }), fieldRef),
    inputProps = _useTextField2.inputProps,
    descriptionProps = _useTextField2.descriptionProps,
    errorMessageProps = _useTextField2.errorMessageProps,
    labelProps = _useTextField2.labelProps;
  const _useStyles = useStyles({
      size
    }),
    className = _useStyles.className;
  const classes = cx(className, classNameProp, {
    'manifest-textfield': true,
    [`manifest-textfield--${size}`]: size
  });
  return /*#__PURE__*/jsx(TextFieldBase, _objectSpread(_objectSpread({}, other), {}, {
    ref: forwardedRef,
    className: classes,
    helperTextProps: mergeProps$1(descriptionProps, errorMessageProps, helperTextProps),
    inputProps: mergeProps$1(inputProps, inputPropsProp),
    inputRef: mergeRefs$1(fieldRef, inputRef),
    labelProps: mergeProps$1(labelProps, labelPropsProp)
  }));
});
const fadeIn = keyframes({
  '0%': {
    opacity: 0
  },
  '100%': {
    opacity: 1
  }
});
const fadeOut = keyframes({
  '0%': {
    opacity: 1
  },
  '100%': {
    opacity: 0
  }
});
const StyledToast = styled('div', {
  $$toastVariantColor: 'transparent',
  backgroundColor: '$background-surface',
  borderLeftColor: '$$toastVariantColor',
  borderLeftStyle: 'solid',
  borderLeftWidth: pxToRem(4),
  borderRadius: '$small',
  boxShadow: '$medium',
  boxSizing: 'border-box',
  display: 'flex',
  maxWidth: pxToRem(440),
  padding: pxToRem(20),
  pointerEvents: 'auto',
  position: 'relative',
  width: '100%',
  willChange: 'transform',
  '> .manifest-toast__icon': {
    color: '$$toastVariantColor',
    marginRight: pxToRem(20),
    size: pxToRem(32)
  },
  variants: {
    isVisible: {
      true: {
        animation: `${fadeIn} 200ms cubic-bezier(0.4, 0.14, 0.3, 1) forwards`
      },
      false: {
        animation: `${fadeOut} 200ms forwards cubic-bezier(0.4, 0.14, 0.3, 1)`
      }
    },
    variant: {
      default: {
        $$toastVariantColor: 'transparent'
      },
      info: {
        $$toastVariantColor: '$colors$palette-indigo-600'
      },
      warning: {
        $$toastVariantColor: '$colors$palette-orange-600'
      },
      success: {
        $$toastVariantColor: '$colors$palette-green-600'
      },
      error: {
        $$toastVariantColor: '$colors$palette-red-600'
      }
    }
  }
});
const StyledToastContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  marginRight: '$x-large'
});
const StyledToastActions = styled('div', {
  alignItems: 'center',
  display: 'flex',
  marginTop: '$medium'
});
const StyledToastDismissButton = styled(IconButton, {
  position: 'absolute',
  right: pxToRem(12),
  top: pxToRem(12)
});
const StyledToastDescription = styled(Typography, {
  marginTop: '$small'
});
const createHandler = variant => (message, options) => hotToast(message, _objectSpread(_objectSpread({}, options), {}, {
  variant
}));
const toast = (...args) => hotToast(...args);
toast.error = createHandler('error');
toast.info = createHandler('info');
toast.success = createHandler('success');
toast.warning = createHandler('warning');
toast.dismiss = hotToast.dismiss;
toast.remove = hotToast.remove;
const variantIcon = {
  info: InfoCircleFilled,
  warning: ExclamationPointTriangleFilled,
  error: BackslashCircleFilled,
  success: CheckCircleFilled,
  default: null
};
const Toast = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const action = props.action,
    as = props.as,
    children = props.children,
    classNameProp = props.className,
    css = props.css,
    _props$dismissButtonP = props.dismissButtonProps,
    dismissButtonProps = _props$dismissButtonP === void 0 ? {} : _props$dismissButtonP,
    id = props.id,
    _props$isDismissable3 = props.isDismissable,
    isDismissable = _props$isDismissable3 === void 0 ? true : _props$isDismissable3,
    isVisible = props.isVisible,
    onDismiss = props.onDismiss,
    description = props.description,
    message = props.message,
    _props$variant4 = props.variant,
    variant = _props$variant4 === void 0 ? 'default' : _props$variant4,
    other = _objectWithoutProperties(props, _excluded76);
  const className = cx('manifest-toast', classNameProp);
  const Icon = variantIcon[variant];
  const handleDismiss = React.useCallback(() => {
    toast.dismiss(id);
    onDismiss?.();
  }, [id, onDismiss]);
  return /*#__PURE__*/jsxs(StyledToast, _objectSpread(_objectSpread({}, other), {}, {
    ref: forwardedRef,
    as: as,
    className: className,
    css: css,
    isVisible: isVisible,
    role: "alert",
    variant: variant,
    children: [Icon && /*#__PURE__*/jsx(Icon, {
      className: "manifest-toast__icon",
      viewBox: "0 0 32 32"
    }), /*#__PURE__*/jsxs(StyledToastContainer, {
      className: "manifest-toast__container",
      children: [/*#__PURE__*/jsx(Typography, {
        className: "manifest-toast__message",
        variant: "bodyBold",
        children: message
      }), description && /*#__PURE__*/jsx(StyledToastDescription, {
        className: "manifest-toast__description",
        variant: "subtext",
        children: description
      }), action && /*#__PURE__*/jsx(StyledToastActions, {
        className: "manifest-toast__actions",
        children: action
      })]
    }), isDismissable && /*#__PURE__*/jsx(StyledToastDismissButton, _objectSpread(_objectSpread({
      className: "manifest-toast__dismiss-button",
      variant: "tertiary",
      onPress: handleDismiss
    }, dismissButtonProps), {}, {
      children: /*#__PURE__*/jsx(Close, {})
    }))]
  }));
});
const StyledToaster = styled('div', {
  bottom: pxToRem(24),
  left: pxToRem(24),
  pointerEvents: 'none',
  position: 'fixed',
  right: pxToRem(24),
  top: pxToRem(24),
  zIndex: 9999
});
const getPositionStyle = offset => ({
  position: 'absolute',
  right: 0,
  top: 0,
  transform: `translateY(${Number(offset)}px)`,
  transition: 'all 200ms cubic-bezier(0.4, 0.14, 0.3, 1)'
});
const Toaster = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const as = props.as,
    classNameProp = props.className,
    cssProp = props.css,
    _props$duration3 = props.duration,
    duration = _props$duration3 === void 0 ? 5000 : _props$duration3,
    other = _objectWithoutProperties(props, _excluded77);
  const _useToaster = useToaster({
      duration
    }),
    toasts = _useToaster.toasts,
    handlers = _useToaster.handlers;
  const endPause = handlers.endPause,
    startPause = handlers.startPause,
    updateHeight = handlers.updateHeight;
  const classes = cx('manifest-toaster', classNameProp);
  const handleMouseEnter = React.useCallback(() => {
    startPause();
  }, [startPause]);
  const handleMouseLeave = React.useCallback(() => {
    endPause();
  }, [endPause]);
  return /*#__PURE__*/jsx(StyledToaster, _objectSpread(_objectSpread({}, other), {}, {
    ref: forwardedRef,
    as: as,
    className: classes,
    css: cssProp,
    role: "region",
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    children: toasts.map(toast => {
      const id = toast.id,
        visible = toast.visible,
        rest = _objectWithoutProperties(toast, _excluded78);
      const action = rest.action,
        className = rest.className,
        css = rest.css,
        description = rest.description,
        dismissButtonProps = rest.dismissButtonProps,
        isDismissable = rest.isDismissable,
        message = rest.message,
        onDismiss = rest.onDismiss,
        variant = rest.variant;
      const offset = handlers.calculateOffset(toast, {
        gutter: 8,
        defaultPosition: 'top-right'
      });
      const styles = getPositionStyle(offset);
      const toastRef = element => {
        if (element && typeof toast.height !== 'number') {
          const _element$getBoundingC = element.getBoundingClientRect(),
            height = _element$getBoundingC.height;
          updateHeight(toast.id, height);
        }
      };
      return /*#__PURE__*/jsx(Toast, {
        ref: toastRef,
        action: action,
        className: className,
        css: css,
        description: description,
        dismissButtonProps: dismissButtonProps,
        id: id,
        isDismissable: isDismissable,
        isVisible: visible,
        message: message,
        style: styles,
        variant: variant,
        onDismiss: onDismiss
      }, toast.id);
    })
  }));
});
const _createContext13 = createContext({
    name: 'TooltipContext'
  }),
  _createContext14 = _slicedToArray(_createContext13, 2),
  TooltipProvider = _createContext14[0],
  useTooltipContext = _createContext14[1];
const StyledTooltipContent = styled('div', {
  backgroundColor: '$palette-grey-700',
  borderRadius: '$small',
  boxSizing: 'border-box',
  color: '$palette-white',
  overflow: 'hidden',
  padding: '$x-small $small',
  position: 'relative',
  typography: '$caption',
  zIndex: '$tooltip'
});
const TooltipContent = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const classNameProp = props.className,
    children = props.children,
    other = _objectWithoutProperties(props, _excluded79);
  const _useTooltipContext = useTooltipContext(),
    tooltipProps = _useTooltipContext.tooltipProps,
    tooltipRef = _useTooltipContext.tooltipRef,
    state = _useTooltipContext.state;
  const _useHover21 = useHover({
      onHoverStart: () => void state?.open(true),
      onHoverEnd: () => void state?.close()
    }),
    hoverProps = _useHover21.hoverProps;
  return /*#__PURE__*/jsx(StyledTooltipContent, _objectSpread(_objectSpread({}, mergeProps(other, tooltipProps, hoverProps)), {}, {
    ref: mergeRefs(tooltipRef, forwardedRef),
    className: cx('manifest-tooltip', classNameProp),
    role: "tooltip",
    children: children
  }));
});
const Tooltip = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const defaultOpen = props.defaultOpen,
    children = props.children,
    _props$delay = props.delay,
    delay = _props$delay === void 0 ? 250 : _props$delay,
    isOpen = props.isOpen,
    isDisabled = props.isDisabled,
    _props$placement9 = props.placement,
    placement = _props$placement9 === void 0 ? 'bottom' : _props$placement9,
    onOpenChange = props.onOpenChange,
    title = props.title,
    trigger = props.trigger,
    other = _objectWithoutProperties(props, _excluded80);
  const tooltipRef = React.useRef(null);
  const triggerRef = React.useRef(null);
  const state = useTooltipTriggerState({
    defaultOpen,
    delay,
    isDisabled,
    isOpen,
    onOpenChange,
    trigger
  });
  const _useTooltipTrigger2 = useTooltipTrigger({
      isDisabled,
      trigger
    }, state, triggerRef),
    tooltipProps = _useTooltipTrigger2.tooltipProps,
    triggerProps = _useTooltipTrigger2.triggerProps;
  const _useOverlayPosition10 = useOverlayPosition({
      isOpen: state?.isOpen,
      offset: 4,
      placement,
      overlayRef: tooltipRef,
      targetRef: triggerRef
    }),
    positionProps = _useOverlayPosition10.overlayProps;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/React.cloneElement(children, _objectSpread(_objectSpread({}, mergeProps(children.props, triggerProps)), {}, {
      ref: triggerRef
    })), /*#__PURE__*/jsx(TooltipProvider, {
      value: {
        tooltipProps: _objectSpread(_objectSpread({}, tooltipProps), positionProps),
        tooltipRef,
        state
      },
      children: /*#__PURE__*/jsx(Overlay, {
        isOpen: state.isOpen,
        children: /*#__PURE__*/jsx(TooltipContent, _objectSpread(_objectSpread({}, other), {}, {
          ref: forwardedRef,
          children: title
        }))
      })
    })]
  });
});
export { ActionCard, ActionCardBody, ActionCardHeader, ActionCardImage, Avatar, Box, Breadcrumb, BreadcrumbItem, Button, ButtonGroup, Calendar, CalendarRange, Card, CardBody, CardFooter, CardHeader, Checkbox, Collapse, Combobox, ComboboxItem, ComboboxSection, Container, DataTable, DatePicker, DateRangePicker, Dialog, DialogContent, DialogFooter, DialogHeader, Dropdown, DropdownItem, DropdownMenu, DropdownSection, Fade, Flex, FormControl, Grid, GridItem, Icon, IconButton, Link, ListBox, ListBoxItem, ListBoxSection, LocalNavigation, LocalNavigationItem, Menu, MenuGroup, MenuItem, MultiCombobox, MultiSelect, NumberField, Overlay, Pagination, Pill, Popover, Portal, Provider, Radio, RadioGroup, Segment, SegmentedControl, Select, SelectItem, SelectSection, Separator, SideNavigation, SideNavigationContent, SideNavigationFooter, SideNavigationHeader, SideNavigationMenu, SideNavigationMenuGroup, SideNavigationMenuItem, Skeleton, Spinner, Stack, Switch, Table, TableBody, TableCell, TableColumn, TableFooter, TableHeader, TableRow, Tag, TextArea, TextField, Toaster, Tooltip, Transition, Typography, VisuallyHidden, toast, useChildrenTextContent, useControlledState, useCopyToClipboard, useDebouncedState, useIsomorphicLayoutEffect, useMergedRef, useMultiCombobox, useMultiComboboxState, useMultiSelect, useMultiSelectListState, useMultiSelectState, usePopoverTrigger, usePopoverTriggerState };
//# sourceMappingURL=index.js.map
